(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@skype/tsregistrar"));
	else if(typeof define === 'function' && define.amd)
		define("@skype/tstrouter", ["@skype/tsregistrar"], factory);
	else if(typeof exports === 'object')
		exports["@skype/tstrouter"] = factory(require("@skype/tsregistrar"));
	else
		root["@skype/tstrouter"] = factory(root["@skype/tsregistrar"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_21__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 20);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
/**
 * Simple logger
 */
var Logger = /** @class */ (function () {
    function Logger(name, logger) {
        this.name = name;
        this.logger = logger;
    }
    Logger.prototype.debug = function (message) {
        this.logger.debug("[".concat(this.name, "] ").concat(message));
    };
    Logger.prototype.info = function (message) {
        this.logger.info("[".concat(this.name, "] ").concat(message));
    };
    Logger.prototype.warn = function (message) {
        this.logger.warn("[".concat(this.name, "] ").concat(message));
    };
    Logger.prototype.error = function (message) {
        this.logger.error("[".concat(this.name, "] ").concat(message));
    };
    return Logger;
}());
exports.Logger = Logger;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_AUTHENTICATE_EVENT_NAME = exports.SUPPORTED_TOKEN_TYPES = exports.FAILED_MESSAGE_ACK = exports.UNHANDLED_MESSAGE_ACK = exports.HANDLED_MESSAGE_ACK = exports.CLIENT_VERSION = exports.constants = void 0;
exports.constants = {
    TROUTER_INIT: 'trouterinit',
    TROUTER_READY_EVENT: 'trouterReadyEvent',
    TROUTER_READY_TIMEOUT: 'trouterReadyTimeout',
    TROUTER_TOKEN_REQUEST: 'trouterTokenRequest',
    TROUTER_TOKEN_GET_SUCCEEDED: 'trouterTokenGetSucceeded',
    TROUTER_TOKEN_GET_FAILED: 'trouterTokenGetFailed',
    TROUTER_RECONNECTING: 'trouterReconnecting',
    RENEWAL: 'renewal',
    NEW_CONNECTION: 'newConnection',
    ENDPOINT_REGISTRATION_FAILED: 'endpointRegistrationFailed'
};
exports.CLIENT_VERSION = '2024.14.01.55';
exports.HANDLED_MESSAGE_ACK = 200;
exports.UNHANDLED_MESSAGE_ACK = 404;
exports.FAILED_MESSAGE_ACK = 500;
exports.SUPPORTED_TOKEN_TYPES = ['skype', 'aad', 'cae'];
exports.USER_AUTHENTICATE_EVENT_NAME = 'user.authenticate';


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 * Type definitions for Trouter JavaScript Client 2024.14.01.55
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrouterState = exports.UserActivityState = void 0;
/**
 * States that a user can reach
 *
 * Use with the `setUserActivityState()` method.
 */
var UserActivityState;
(function (UserActivityState) {
    UserActivityState[UserActivityState["Unknown"] = 0] = "Unknown";
    UserActivityState[UserActivityState["Active"] = 1] = "Active";
    UserActivityState[UserActivityState["Inactive"] = 2] = "Inactive"; /// User is not active according to the application
})(UserActivityState || (exports.UserActivityState = UserActivityState = {}));
var TrouterState;
(function (TrouterState) {
    /** Initial state */
    TrouterState[TrouterState["Unknown"] = 0] = "Unknown";
    /** ready to work */
    TrouterState[TrouterState["Connected"] = 2] = "Connected";
    /**
     * waiting for 'connected' event
     * Might also be in Terminal State. Users should call `isInTerminalState` to check.
     * For legacy reasons, we cannot change the TrouterState enum any longer.
     */
    TrouterState[TrouterState["Disconnected"] = 3] = "Disconnected";
    /** waiting for 'register' from second connection */
    TrouterState[TrouterState["Switching"] = 9] = "Switching";
})(TrouterState || (exports.TrouterState = TrouterState = {}));


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timespan = exports.CorrelationVector = exports.fetchWithTimeout = exports.calculateExpireTsInSec = exports.calculateTtlInSec = exports.toJson = void 0;
function toJson(obj) {
    try {
        return JSON.stringify(obj);
    }
    catch (error) {
        return "Unable to serialize object of type ".concat(typeof obj);
    }
}
exports.toJson = toJson;
function calculateTtlInSec(expirationTsInSec) {
    var now = Math.round(new Date().getTime() / 1000);
    return expirationTsInSec !== undefined && expirationTsInSec > now
        ? expirationTsInSec - now
        : 0;
}
exports.calculateTtlInSec = calculateTtlInSec;
function calculateExpireTsInSec(ttlInSec) {
    return Math.round(new Date().getTime() / 1000) + ttlInSec;
}
exports.calculateExpireTsInSec = calculateExpireTsInSec;
/** Wrapper to send request with specified timeout */
function fetchWithTimeout(request, timeoutMs) {
    return __awaiter(this, void 0, void 0, function () {
        var timeoutId, fetchPromise, timeoutPromise;
        return __generator(this, function (_a) {
            fetchPromise = new Promise(function (resolve, reject) {
                fetch(request).then(function (response) {
                    clearTimeout(timeoutId);
                    resolve(response);
                }).catch(function (error) {
                    clearTimeout(timeoutId);
                    reject(error);
                });
            });
            if (timeoutMs !== 0) {
                timeoutPromise = new Promise(function (resolve, reject) {
                    // We make a compromise on how much information to show in the error message.
                    // Having the URL there is useful, but including any query parameters is both
                    // cumbersome (millions of different errors in telemetry) and unsafe (secret
                    // fields that would need to be redacted). "Origin" and "pathname" achieve that.
                    var url = new URL(request.url);
                    var error = new Error("".concat(request.method, " ").concat(url.origin).concat(url.pathname, " timed out"));
                    timeoutId = setTimeout(reject, timeoutMs, error);
                });
                return [2 /*return*/, Promise.race([fetchPromise, timeoutPromise])];
            }
            return [2 /*return*/, fetchPromise];
        });
    });
}
exports.fetchWithTimeout = fetchWithTimeout;
/***
 * Correlation vector
 */
var CorrelationVector = /** @class */ (function () {
    function CorrelationVector(correlationVector) {
        this.base = (correlationVector !== undefined) ? correlationVector : this.createCorrelationVectorBase();
        this.extension = 0;
    }
    CorrelationVector.extend = function (correlationVector) {
        return new CorrelationVector(correlationVector);
    };
    CorrelationVector.prototype.increase = function () {
        this.extension++;
    };
    CorrelationVector.prototype.value = function () {
        return "".concat(this.base, ".").concat(this.extension);
    };
    CorrelationVector.prototype.createCorrelationVectorBase = function () {
        var length = 21;
        var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0987654321/+';
        var endChars = 'AQgw';
        var result = '';
        for (var i = 0; i < length; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        result += endChars.charAt(Math.floor(Math.random() * endChars.length));
        return result;
    };
    return CorrelationVector;
}());
exports.CorrelationVector = CorrelationVector;
/**
 * Simplify calculation of time intervals
 */
var Timespan = /** @class */ (function () {
    function Timespan() {
        this.start = Date.now();
    }
    Object.defineProperty(Timespan.prototype, "duration", {
        /**
         * Returns number of milliseconds from start
         */
        get: function () {
            return Date.now() - this.start;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Timespan.prototype, "startTime", {
        /**
         * Returns start time
         */
        get: function () {
            return this.start;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Reset start of interval to current timestamp
     */
    Timespan.prototype.reset = function () {
        this.start = Date.now();
    };
    return Timespan;
}());
exports.Timespan = Timespan;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 * Internal type definitions for Trouter JavaScript Client
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrouterManagerState = exports.UserActivityEventReason = exports.ServerState = void 0;
var Common_1 = __webpack_require__(3);
/**
 * Information about server connection
 */
var ServerState = /** @class */ (function () {
    function ServerState(
    /** Trouter client connection ID */
    connectionId, 
    /** Trouter client connected client ID */
    connectedClientId, 
    /** window.location.hostname */
    domId, 
    /** Unsecure Trouter url at which client can be reached */
    unsecureUrl, 
    /** Secure Trouter url at which client can be reached */
    url, 
    /** URL base to use for client-to-client requests */
    c2cUrlBase, 
    /** expiration timestamp for connection in seconds */
    expirationTsSec) {
        this.connectionId = connectionId;
        this.connectedClientId = connectedClientId;
        this.domId = domId;
        this.unsecureUrl = unsecureUrl;
        this.url = url;
        this.c2cUrlBase = c2cUrlBase;
        this.expirationTsSec = expirationTsSec;
    }
    /** Return connection TTL, i.e. number of seconds till expiration */
    ServerState.prototype.getRemainingTtlInSec = function () {
        return (0, Common_1.calculateTtlInSec)(this.expirationTsSec);
    };
    return ServerState;
}());
exports.ServerState = ServerState;
var UserActivityEventReason;
(function (UserActivityEventReason) {
    UserActivityEventReason[UserActivityEventReason["Unknown"] = 0] = "Unknown";
    UserActivityEventReason[UserActivityEventReason["Modified"] = 1] = "Modified";
    UserActivityEventReason[UserActivityEventReason["Snapshot"] = 2] = "Snapshot";
    UserActivityEventReason[UserActivityEventReason["Connected"] = 3] = "Connected";
})(UserActivityEventReason || (exports.UserActivityEventReason = UserActivityEventReason = {}));
/**
 * Duplicating TrouterState since too many parts of SCC depend on it for us to change it internally.
 * Don't expose this to the outside world, to avoid another repeat of this issue.
 */
var TrouterManagerState;
(function (TrouterManagerState) {
    /** Initial state */
    TrouterManagerState[TrouterManagerState["Unknown"] = 0] = "Unknown";
    /** ready to work */
    TrouterManagerState[TrouterManagerState["Connected"] = 2] = "Connected";
    /** waiting for 'connected' event */
    TrouterManagerState[TrouterManagerState["Disconnected"] = 3] = "Disconnected";
    /** waiting for 'register' from second connection */
    TrouterManagerState[TrouterManagerState["Switching"] = 9] = "Switching";
    /** Unable to continue, in final state. */
    TrouterManagerState[TrouterManagerState["TerminalError"] = 10] = "TerminalError";
})(TrouterManagerState || (exports.TrouterManagerState = TrouterManagerState = {}));


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.redirectUrlIfPresent = exports.ensureNumber = exports.reconnectParamsWithoutUrls = exports.adaptUrl = exports.isV4ConnectEvent = exports.usedProtocolAfterFallback = exports.usedProtocol = void 0;
function usedProtocol(tokenType, reconnectParams) {
    return (tokenType === 'skype' && safeToString(reconnectParams === null || reconnectParams === void 0 ? void 0 : reconnectParams.scae) !== '1') ? 'v4a' : 'v4c';
}
exports.usedProtocol = usedProtocol;
function safeToString(value) {
    if (typeof value === 'string') {
        return value;
    }
    else if (typeof value === 'number') {
        return value.toString();
    }
    return undefined;
}
function usedProtocolAfterFallback(protocol, fallbackReason) {
    if ((fallbackReason === null || fallbackReason === void 0 ? void 0 : fallbackReason.kind) === 'v4c-websocket-failure') {
        return 'v4a';
    }
    return protocol;
}
exports.usedProtocolAfterFallback = usedProtocolAfterFallback;
function isV4ConnectEvent(args) {
    return Object.prototype.hasOwnProperty.call(args, 'connectparams');
}
exports.isV4ConnectEvent = isV4ConnectEvent;
/**
 * Needed because we want to have cache with reconnectUrl, serviceUrl working
 * independent of protocol (see IReconnectParameters and its uses)
 */
function adaptUrl(url, protocol) {
    if (protocol === 'v4a') {
        // The insecure (http://, ws://) versions would only ever be used by a test application,
        // the connection URL is normally determined by the consumer of the library.
        // eslint-disable-next-line @microsoft/sdl/no-insecure-url
        return url.replace(/\/v4\/c\b/, '/v4/a').replace('wss://', 'https://').replace('ws://', 'http://');
    }
    else {
        // eslint-disable-next-line @microsoft/sdl/no-insecure-url
        return url.replace(/\/v4\/a\b/, '/v4/c').replace('https://', 'wss://').replace('http://', 'ws://');
    }
}
exports.adaptUrl = adaptUrl;
/**
 * Unfortunately the pre-existing cache format doesn't separate connectparams into its own property so it could be easily sent back,
 * instead it manually removes `reconnectUrl` and `serviceUrl` and send everything else, so we need to do the same here
 */
function reconnectParamsWithoutUrls(reconnectParams) {
    if (reconnectParams === undefined) {
        return undefined;
    }
    return __assign(__assign({}, reconnectParams), { reconnectUrl: undefined, serviceUrl: undefined });
}
exports.reconnectParamsWithoutUrls = reconnectParamsWithoutUrls;
function ensureNumber(value) {
    return typeof value === 'string' ? parseInt(value, 10) : value;
}
exports.ensureNumber = ensureNumber;
function redirectUrlIfPresent(reason) {
    if ((reason === null || reason === void 0 ? void 0 : reason.kind) !== 'redirect' || reason.host === undefined) {
        return undefined;
    }
    var redirectHost = reason.host;
    if (redirectHost.endsWith('/')) {
        redirectHost = redirectHost.substring(0, redirectHost.length - 1);
    }
    if (!redirectHost.endsWith('/v4/c') && !redirectHost.endsWith('/v4/a')) {
        redirectHost += '/v4/c';
    }
    return redirectHost;
}
exports.redirectUrlIfPresent = redirectUrlIfPresent;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrouterFsm = exports.State = void 0;
var InternalInterfaces_1 = __webpack_require__(4);
var Logger_1 = __webpack_require__(0);
var ProtocolAdapters_1 = __webpack_require__(5);
var State;
(function (State) {
    State[State["Initial"] = 0] = "Initial";
    /** waiting for token from User */
    State[State["RetrievingToken"] = 1] = "RetrievingToken";
    /** waiting for allocation response from service */
    State[State["Allocating"] = 2] = "Allocating";
    /**
     * waiting for Socket.IO handshake to be finished. After that Socket.IO will
     * start to try transports and send 'connecting' event
     */
    State[State["Handshaking"] = 3] = "Handshaking";
    /**
     * waiting for 'connected' event - socket.io is trying different transports.
     * onSocketError event should be ignored, as it's expected event. So, only ConnectFailed or
     * connection timeout meas failed connection
     */
    State[State["Connecting"] = 4] = "Connecting";
    /**
     * connecting to a websocket /v4/c URL
     *
     * this is the equivalent of the "Allocating -> Handshaking -> Connecting" chain
     * from the /v4/a protocol
     */
    State[State["AnonymousConnecting"] = 5] = "AnonymousConnecting";
    /**
     * connected to a websocket /v4/c URL, sending the authentication message,
     * and waiting to receive a `trouter.connected` event back
     */
    State[State["WebsocketAuthenticating"] = 6] = "WebsocketAuthenticating";
    /** ready to work */
    State[State["Connected"] = 7] = "Connected";
    /** waiting for a successful 'unregister' response */
    State[State["Unregistering"] = 8] = "Unregistering";
    /**
     * Unrecoverable state
     * Trouter cannot start once in this state
     */
    State[State["TerminalError"] = 9] = "TerminalError";
})(State || (exports.State = State = {}));
var RegistrationState;
(function (RegistrationState) {
    RegistrationState[RegistrationState["Initial"] = 0] = "Initial";
    /** Waiting for a successful 'register' response */
    RegistrationState[RegistrationState["Registering"] = 1] = "Registering";
    /** like the above, but another registration must happen when done because of resendRegistration() */
    RegistrationState[RegistrationState["RegisteringButResendPending"] = 2] = "RegisteringButResendPending";
    /** Registration failed, waiting to retry */
    RegistrationState[RegistrationState["Retrying"] = 3] = "Retrying";
    /** Registration succeeded */
    RegistrationState[RegistrationState["Registered"] = 4] = "Registered";
    /** Registration is skipped */
    RegistrationState[RegistrationState["RegistrationDisabled"] = 5] = "RegistrationDisabled";
})(RegistrationState || (RegistrationState = {}));
/**
 * State machine for trouter
 */
var TrouterFsm = /** @class */ (function () {
    function TrouterFsm(logfunc, worker, incallModeEnabled, protocolSelector) {
        this.worker = worker;
        this.incallModeEnabled = incallModeEnabled;
        this.protocolSelector = protocolSelector;
        this.state = State.Initial;
        this.autoReconnect = true;
        this.logger = new Logger_1.Logger('ConnectionFsm', logfunc);
        this.registrationState = RegistrationState.Initial;
    }
    /** Returns current state */
    TrouterFsm.prototype.getState = function () {
        return this.state;
    };
    TrouterFsm.prototype.isActive = function () {
        return this.state === State.Allocating
            || this.state === State.Connected
            || this.state === State.Handshaking
            || this.state === State.Connecting
            || this.state === State.RetrievingToken
            || this.state === State.AnonymousConnecting
            || this.state === State.WebsocketAuthenticating;
    };
    TrouterFsm.prototype.isConnecting = function () {
        return this.state === State.Allocating
            || this.state === State.Handshaking
            || this.state === State.Connecting
            || this.state === State.AnonymousConnecting;
    };
    //////////// Events ////////////
    /**
     * Start trouter
     */
    TrouterFsm.prototype.start = function () {
        if (this.state === State.Initial) {
            this.setState(State.RetrievingToken);
            this.worker.getToken(true, false, undefined);
            return true;
        }
        else {
            this.showIgnored('start');
            return false;
        }
    };
    /**
     * Stop trouter
     * @param dontUnregister    if true, FSM will not unregister. It's needed in case of two simultaneous
     *                          connections, to replace first connection with second - registrar just updates
     *                          the existing record for the user, by registrationId (see their API docs),
     *                          that id does not change during the lifetime of a TrouterService instance.
     * @param isTerminalError   if true, FSM will transition into the terminal state
     */
    TrouterFsm.prototype.stop = function (dontUnregister, isTerminalError) {
        if (dontUnregister) {
            this.registrationState = RegistrationState.Initial;
        }
        if (this.worker.isIncallMode()) {
            this.worker.exitIncallMode();
        }
        this.worker.resetTokenBackoff();
        this.worker.cancelPendingRegistrationRequests();
        this.worker.stopConnectionTimer();
        this.worker.stopPingTimer();
        this.worker.clearSentEventTimers();
        this.worker.stopRegistrationTimer();
        this.worker.stopSocketIo();
        if (this.state === State.Connected) {
            this.worker.sendDisconnectTelemetryEvent('connection stopped');
        }
        // Stop can happen in any state - the only difference is if registration exists or not.
        // It can be also called a second time, just to stop a stuck unregistration.
        if ((this.registrationState === RegistrationState.Registered
            || this.registrationState === RegistrationState.Registering
            || this.registrationState === RegistrationState.RegisteringButResendPending)
            && this.state !== State.Unregistering) {
            this.registrationState = RegistrationState.Initial;
            this.setState(State.Unregistering);
            this.worker.sendUnregisterRequest();
        }
        else {
            if (isTerminalError) {
                this.setState(State.TerminalError);
                this.worker.dispatchTerminalError();
            }
            else {
                this.setState(State.Initial);
                this.worker.dispatchDisconnected();
            }
        }
    };
    TrouterFsm.prototype.onTokenReceived = function (token, reason, reconnectParams) {
        if (this.state === State.RetrievingToken) {
            if ((0, ProtocolAdapters_1.usedProtocolAfterFallback)(this.protocolSelector(token.tokenType, reconnectParams), reason) === 'v4c') {
                this.setState(State.AnonymousConnecting);
                this.worker.startConnectionTimer();
                this.worker.connectV4c(token, reason);
            }
            else {
                this.setState(State.Allocating);
                this.worker.startConnectionTimer();
                this.worker.sendAllocateRequest(token);
            }
        }
        else {
            this.showIgnored('onTokenReceived');
        }
    };
    /**
     * if disconnectDetected - need to send ping to check if connection is really dead,
     * otherwise - network is available
     */
    TrouterFsm.prototype.checkConnection = function (disconnectDetected) {
        if (disconnectDetected) {
            this.onPingInterval();
        }
    };
    /** Allocation request succeed with 200 */
    TrouterFsm.prototype.onAllocationSucceed = function (token) {
        // Call to dispatchUnregistered a little bit earlier takes into account the case when the state
        // of the state machine can change inside the callback, for example if Trouter.stop() is called inside the callback.
        if (this.state === State.Allocating && this.registrationState === RegistrationState.Registered) {
            this.worker.dispatchUnregistered();
        }
        if (this.state === State.Allocating) {
            this.setState(State.Handshaking);
            this.registrationState = RegistrationState.Initial;
            this.worker.startSocketIo(token);
            return true;
        }
        else {
            this.showIgnored('onAllocationSucceed');
            return false;
        }
    };
    /** Allocation request failed */
    TrouterFsm.prototype.onAllocationFailed = function (unauthorized, claimsChallenge) {
        if (this.state === State.Allocating) {
            this.cleanUpAndInitiateReconnect({ backoff: true, allowCachedToken: !unauthorized, claimsChallenge: claimsChallenge });
        }
        else {
            this.showIgnored('onAllocationFailed');
        }
    };
    TrouterFsm.prototype.onV4cException = function () {
        if (this.state === State.AnonymousConnecting || this.state === State.WebsocketAuthenticating) {
            this.logger.error('v4c exception, falling back to longpoll');
            this.cleanUpAndInitiateReconnect({ backoff: true, allowCachedToken: true, fallbackReason: { kind: 'v4c-websocket-failure' } });
        }
    };
    /** Connection didn't succeed in given timeout */
    TrouterFsm.prototype.onConnectingTimeout = function () {
        // implementation note: this also called from onConnectingFailed
        if (this.state === State.Allocating
            || this.state === State.Connecting
            || this.state === State.Handshaking
            || this.state === State.AnonymousConnecting
            || this.state === State.WebsocketAuthenticating) {
            this.cleanUpAndInitiateReconnect({ backoff: false, allowCachedToken: true });
        }
        else {
            this.showIgnored('onConnectingTimeout');
        }
    };
    /** socket.io handshake succeed and socket.io is trying next transport */
    TrouterFsm.prototype.onConnecting = function () {
        if (this.state === State.Handshaking) {
            this.setState(State.Connecting);
        }
        else {
            this.showIgnored('onConnecting');
        }
    };
    /** socket.io connected (1::), but trouter.connected event has not arrived yet */
    TrouterFsm.prototype.onSocketConnect = function (token) {
        if (this.state === State.AnonymousConnecting) {
            this.setState(State.WebsocketAuthenticating);
            this.worker.sendV4cAuthenticationEvent(token);
        }
        else {
            this.showIgnored('onSocketConnect');
        }
    };
    /** Socket.io connection wasn't established */
    TrouterFsm.prototype.onConnectingFailed = function () {
        // This callback will be called when all transports failed to connect, i.e. socket.io can't proceed
        if (this.state === State.Connecting) {
            this.onConnectingTimeout();
        }
        else if (this.state === State.Handshaking) {
            // It should never happen, because socket.io should try at least one transport
            this.logger.error('Unexpected error in Socket.io - no valid transports');
            this.onConnectingTimeout();
        }
        else if (this.state === State.AnonymousConnecting || this.state === State.WebsocketAuthenticating) {
            this.logger.info('/v4/c falling back to longpoll');
            this.cleanUpAndInitiateReconnect({ backoff: true, allowCachedToken: true, fallbackReason: { kind: 'v4c-websocket-failure' } });
        }
        else {
            this.showIgnored('onConnectingFailed');
        }
    };
    /** Socket.io error (or disconnect) */
    TrouterFsm.prototype.onSocketDisconnect = function (disconnectReason) {
        if (this.state === State.Handshaking || this.state === State.Connected || this.state === State.WebsocketAuthenticating) {
            if (this.state === State.Connected) {
                this.worker.sendDisconnectTelemetryEvent(disconnectReason === null || disconnectReason === void 0 ? void 0 : disconnectReason.toTelemetryString());
            }
            if (this.state === State.WebsocketAuthenticating) {
                this.worker.countDisconnectBeforeConnectionEstablishment();
            }
            if ((disconnectReason === null || disconnectReason === void 0 ? void 0 : disconnectReason.reason) === 'skypetoken-deprecated') {
                this.logger.error('Skypetoken deprecated response, not retrying any further');
                this.onTerminalError();
            }
            else {
                this.cleanUpAndInitiateReconnect({
                    // If client was already successfully connected, no backoff is needed (we want to reconnect quickly).
                    // If however connection failed before the `trouter.connected` event arrived,
                    // that means some sort of error where we don't want to retry immediately.
                    backoff: this.state !== State.Connected && (disconnectReason === null || disconnectReason === void 0 ? void 0 : disconnectReason.reason) !== 'dup',
                    allowCachedToken: (disconnectReason === null || disconnectReason === void 0 ? void 0 : disconnectReason.reason) !== 'unauthorized',
                    claimsChallenge: disconnectReason === null || disconnectReason === void 0 ? void 0 : disconnectReason.claims
                });
            }
        }
        else {
            // Disconnect can be called because of an error.
            // Such error can happen in Connecting state, which means that
            // websocket transport failed to establish connection
            this.showIgnored('onSocketDisconnect');
        }
    };
    /** Received 'trouter.connected' event from service */
    TrouterFsm.prototype.onTrouterConnected = function () {
        if (this.state === State.Connecting || this.state === State.WebsocketAuthenticating) {
            this.setState(State.Connected);
            this.worker.resetTokenBackoff();
            this.worker.stopConnectionTimer();
            this.worker.sendUserActivityState(InternalInterfaces_1.UserActivityEventReason.Connected, true);
            this.worker.startPingTimer();
            this.worker.dispatchConnected();
            if (this.worker.shouldSkipRegistration()) {
                this.registrationState = RegistrationState.RegistrationDisabled;
                this.worker.dispatchRegistered();
            }
            else {
                this.registrationState = RegistrationState.Registering;
                this.worker.sendRegisterRequest();
            }
        }
        else {
            this.showIgnored('onTrouterConnected');
        }
    };
    /**
     * Received 'trouter.reconnect' event from service, or URL in configuration has changed,
     * need to establish a new connection
     */
    TrouterFsm.prototype.onReconnectRequired = function (useConnectParamsFromCache, reason, eventArgs) {
        if (this.state === State.AnonymousConnecting || this.state === State.WebsocketAuthenticating) {
            if (eventArgs === undefined || eventArgs.target !== 'host' || eventArgs.url === undefined || eventArgs.url === '') {
                this.logger.error("unexpected reconnect arguments: ".concat(eventArgs === null || eventArgs === void 0 ? void 0 : eventArgs.target, " ").concat(eventArgs === null || eventArgs === void 0 ? void 0 : eventArgs.url, ", reconnecting without cache"));
                this.cleanUpAndInitiateReconnect({ backoff: true, allowCachedToken: true, fallbackReason: { kind: 'redirect-no-host' } });
            }
            else {
                this.cleanUpAndInitiateReconnect({ backoff: true, allowCachedToken: true, fallbackReason: { kind: 'redirect', host: eventArgs.url } });
            }
        }
        else {
            this.worker.dispatchReconnectIsRequired(useConnectParamsFromCache, reason);
        }
    };
    TrouterFsm.prototype.disableAutoReconnect = function () {
        this.autoReconnect = false;
    };
    /** Request from downstream is received */
    TrouterFsm.prototype.onDownstreamRequest = function (request) {
        if (this.state === State.Connected) {
            this.switchToIncallModeIfEnabled();
            this.worker.dispatchDownstreamRequest(request);
        }
        else {
            this.showIgnored('onDownstreamRequest');
        }
    };
    TrouterFsm.prototype.onTrouterMessageLost = function (messageLossIndicators) {
        if (this.state === State.Connected) {
            this.worker.dispatchTrouterMessageLost(messageLossIndicators);
        }
        else {
            this.showIgnored('onTrouterMessageLost');
        }
    };
    /** Timer for ping request fired */
    TrouterFsm.prototype.onPingInterval = function () {
        if (this.state === State.Connected) {
            this.worker.sendPingRequest();
        }
        else {
            this.showIgnored('onPingInterval');
        }
    };
    /** No pong response from service within timeout */
    TrouterFsm.prototype.onPingResponseTimeout = function () {
        this.onMissedResponse('onPingResponseTimeout');
    };
    /** Pong response */
    TrouterFsm.prototype.onPingResponse = function () {
        if (this.state === State.Connected) {
            // do nothing
        }
        else {
            this.showIgnored('onPingResponse');
        }
    };
    TrouterFsm.prototype.onRegistrationFailed = function () {
        if (this.state === State.Connected && this.registrationState === RegistrationState.Registering) {
            this.worker.dispatchUnregistered();
            this.registrationState = RegistrationState.Retrying;
            this.worker.startRegistrationRetryTimer();
        }
        else if (this.state === State.Connected && this.registrationState === RegistrationState.RegisteringButResendPending) {
            this.registrationState = RegistrationState.Registering;
            this.worker.sendRegisterRequest();
        }
        else {
            this.showIgnored('onRegistrationFailed');
        }
    };
    TrouterFsm.prototype.onRetryRegistration = function () {
        if (this.state === State.Connected && this.registrationState === RegistrationState.Retrying) {
            this.registrationState = RegistrationState.Registering;
            this.worker.sendRegisterRequest();
        }
        else {
            this.showIgnored('onRetryRegistration');
        }
    };
    TrouterFsm.prototype.onRegistrationSucceeded = function () {
        if (this.state === State.Connected && this.registrationState === RegistrationState.Registering) {
            this.registrationState = RegistrationState.Registered;
            this.worker.dispatchRegistered();
            this.worker.startRegistrationTimer();
        }
        else if (this.state === State.Connected && this.registrationState === RegistrationState.RegisteringButResendPending) {
            this.registrationState = RegistrationState.Registering;
            this.worker.sendRegisterRequest();
        }
        else {
            this.showIgnored('onRegistrationSucceeded');
        }
    };
    /** Registration TTL is about to expire */
    TrouterFsm.prototype.onRegistrationNearExpiry = function () {
        if (this.state === State.Connected && this.registrationState === RegistrationState.Registered) {
            this.registrationState = RegistrationState.Registering;
            this.worker.sendRegisterRequest();
        }
        else {
            this.showIgnored('onRegistrationNearExpiry');
        }
    };
    TrouterFsm.prototype.onUnregistrationDone = function () {
        if (this.state === State.Unregistering) {
            this.setState(State.Initial);
            this.worker.dispatchUnregistered();
            this.worker.dispatchDisconnected(); // TODO: only sending "disconneted" upon unregistration makes no sense
        }
        else {
            this.showIgnored('onUnregistrationDone');
        }
    };
    TrouterFsm.prototype.onResendRegistration = function () {
        this.worker.dispatchUnregistered();
        if (this.state === State.Connected && this.registrationState === RegistrationState.Registered) {
            this.registrationState = RegistrationState.Registering;
            this.worker.stopRegistrationTimer();
            this.worker.sendRegisterRequest();
        }
        else if (this.state === State.Connected && this.registrationState === RegistrationState.Registering) {
            this.registrationState = RegistrationState.RegisteringButResendPending;
        }
    };
    TrouterFsm.prototype.onIncallModeTimer = function () {
        this.worker.exitIncallMode();
        if (this.state === State.Connected) {
            this.worker.stopPingTimer();
            this.worker.startPingTimer();
        }
        else {
            this.showIgnored('onIncallModeTimer');
        }
    };
    TrouterFsm.prototype.onSetNewUserActivityState = function () {
        this.worker.sendUserActivityState(InternalInterfaces_1.UserActivityEventReason.Modified, this.state === State.Connected);
    };
    TrouterFsm.prototype.onActivityStateResponseTimeout = function () {
        this.onMissedResponse('onActivityStateResponseTimeout');
    };
    TrouterFsm.prototype.forceReconnect = function (reason) {
        if (this.state === State.Connected) {
            this.worker.sendDisconnectTelemetryEvent(reason);
        }
        this.worker.resetTokenBackoff();
        this.cleanUpAndInitiateReconnect({ backoff: false, allowCachedToken: true });
    };
    TrouterFsm.prototype.onTerminalError = function () {
        this.logger.error("Cannot proceed, reached terminal state. Switching from state '".concat(State[this.state], "' to ").concat(State[State.TerminalError]));
        this.stop(
        /* dontUnregister */ true, 
        /* isTerminalError */ true);
        this.setState(State.TerminalError);
    };
    TrouterFsm.prototype.onMissedResponse = function (onResponseHandlerName) {
        if (this.state === State.Connected) {
            this.worker.sendDisconnectTelemetryEvent(onResponseHandlerName);
            this.cleanUpAndInitiateReconnect({ backoff: false, allowCachedToken: true });
        }
        else {
            this.showIgnored(onResponseHandlerName);
        }
    };
    TrouterFsm.prototype.showIgnored = function (event) {
        this.logger.debug("Ignoring event '".concat(event, "' in state '").concat(State[this.state], "'"));
    };
    TrouterFsm.prototype.setState = function (state) {
        this.logger.info("Switching from state '".concat(State[this.state], "' to state '").concat(State[state], "'"));
        if (this.state === state) {
            this.logger.error("Attempt to switch to the current state '".concat(State[state], "'"));
            return;
        }
        this.state = state;
    };
    TrouterFsm.prototype.switchToIncallModeIfEnabled = function () {
        if (this.incallModeEnabled) {
            if (!this.worker.isIncallMode()) {
                this.worker.enterIncallMode();
                this.worker.stopPingTimer();
                this.worker.startPingTimer();
            }
            this.worker.restartIncallModeTimer();
        }
    };
    TrouterFsm.prototype.cleanUpAndInitiateReconnect = function (options) {
        if (!this.autoReconnect) {
            this.logger.info('Automatic reconnect is disabled, stopping this connection');
            this.stop(true);
            return;
        }
        this.worker.cancelPendingRegistrationRequests();
        this.worker.stopConnectionTimer();
        this.worker.stopPingTimer();
        this.worker.clearSentEventTimers();
        this.worker.stopRegistrationTimer();
        this.worker.stopSocketIo();
        this.setState(State.RetrievingToken);
        this.worker.dispatchReconnecting();
        this.worker.getToken(options.allowCachedToken, options.backoff, options.claimsChallenge, options.fallbackReason);
    };
    return TrouterFsm;
}());
exports.TrouterFsm = TrouterFsm;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrouterConnection = exports.ReconnectReason = void 0;
var tsregistrar_1 = __webpack_require__(21);
var Common_1 = __webpack_require__(3);
var ConnectionTracker_1 = __webpack_require__(15);
var Constants_1 = __webpack_require__(1);
var DisconnectReason_1 = __webpack_require__(16);
var ExponentialBackoff_1 = __webpack_require__(17);
var Interfaces_1 = __webpack_require__(2);
var InternalInterfaces_1 = __webpack_require__(4);
var Logger_1 = __webpack_require__(0);
var ProtocolAdapters_1 = __webpack_require__(5);
var TrouterFsm_1 = __webpack_require__(6);
// This is the current API version
var VERSION = 'v4';
// Default value for registration timeout
var DEFAULT_REGISTRATION_TIMEOUT_SEC = 3600;
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-explicit-any
var io = __webpack_require__(12);
/**
 * Stub for IClientInfo
 */
var ClientInfo = /** @class */ (function () {
    function ClientInfo() {
        this.cv = Constants_1.CLIENT_VERSION;
        this.ua = '';
        this.hr = '';
        this.v = '';
    }
    return ClientInfo;
}());
/**
 * Stub for ISocketIoOptions
 */
var SocketIoOptions = /** @class */ (function () {
    function SocketIoOptions() {
        this['force new connection'] = true;
        this['reconnect'] = false;
        this['query'] = '';
        this.ackTimeoutMs = 5000;
    }
    SocketIoOptions.prototype.rewriteUrlForProxy = function (url) { return url; };
    return SocketIoOptions;
}());
var cvHeader = 'MS-CV';
/**
 * Request from downstream service
 */
var TrouterRequest = /** @class */ (function () {
    function TrouterRequest(requestJson, logger) {
        this.logger = logger;
        this.cvCounter = 0;
        var json = JSON.parse(requestJson);
        this.startTS = this.safeJsonNumber(json, 'startTS', 0);
        this.url = this.safeJsonString(json, 'url', '');
        this.shortUrl = this.safeJsonString(json, 'shortUrl', '');
        this.body = this.safeJsonString(json, 'body', '');
        this.headers = this.safeJsonRecord(json, 'headers', {});
        this.id = this.safeJsonNumber(json, 'id', -1);
        this.method = this.safeJsonString(json, 'method', '');
        this.replied = false;
        this.timedout = false;
        this.receivedCv = this.headers[cvHeader];
        this.updateCvHeader();
    }
    Object.defineProperty(TrouterRequest.prototype, "correlationVector", {
        get: function () {
            return this.receivedCv ? "".concat(this.receivedCv, ".").concat(this.cvCounter) : '';
        },
        enumerable: false,
        configurable: true
    });
    TrouterRequest.prototype.on = function (target, targetCallback) {
        if (target === 'data') {
            this.dataCallback = targetCallback;
        }
        else if (target === 'end') {
            if (typeof this.dataCallback === 'function') {
                this.dataCallback(this.body);
            }
            targetCallback();
        }
    };
    TrouterRequest.prototype.incrementCorrelationVector = function () {
        ++this.cvCounter;
        this.updateCvHeader();
    };
    TrouterRequest.prototype.updateCvHeader = function () {
        var cv = this.correlationVector;
        if (cv) {
            this.headers[cvHeader] = cv;
        }
    };
    TrouterRequest.prototype.safeJsonNumber = function (json, property, defaultValue) {
        var _a;
        if (json !== null && json !== undefined && Object.prototype.hasOwnProperty.call(json, property)) {
            var jsonRecord = json;
            if (typeof jsonRecord[property] === 'number') {
                return (jsonRecord[property]);
            }
            else if (typeof jsonRecord[property] === 'string') {
                return parseFloat((jsonRecord[property]));
            }
            else {
                (_a = this.logger) === null || _a === void 0 ? void 0 : _a.warn("unexpected type of '".concat(property, "': ").concat(typeof jsonRecord[property]));
            }
        }
        return defaultValue;
    };
    TrouterRequest.prototype.safeJsonString = function (json, property, defaultValue) {
        var _a;
        if (json !== null && json !== undefined && Object.prototype.hasOwnProperty.call(json, property)) {
            var jsonRecord = json;
            if (typeof jsonRecord[property] === 'string') {
                return (jsonRecord[property]);
            }
            else {
                (_a = this.logger) === null || _a === void 0 ? void 0 : _a.warn("unexpected type of '".concat(property, "': ").concat(typeof jsonRecord[property]));
            }
        }
        return defaultValue;
    };
    TrouterRequest.prototype.safeJsonRecord = function (json, property, defaultValue) {
        var _a;
        if (json !== null && json !== undefined && Object.prototype.hasOwnProperty.call(json, property)) {
            var jsonRecord = json;
            if (typeof jsonRecord[property] === 'object') {
                return (jsonRecord[property]);
            }
            else {
                (_a = this.logger) === null || _a === void 0 ? void 0 : _a.warn("unexpected type of '".concat(property, "': ").concat(typeof jsonRecord[property]));
            }
        }
        return defaultValue;
    };
    return TrouterRequest;
}());
/**
 * Response to downstream service
 */
var TrouterResponse = /** @class */ (function () {
    function TrouterResponse(request, responseData, sendResponse) {
        this.request = request;
        this.responseData = responseData;
        this.sendResponse = sendResponse;
    }
    TrouterResponse.prototype.writeHead = function (status, headers) {
        this.responseData.status = status;
        this.responseData.headers = headers;
    };
    TrouterResponse.prototype.write = function (chunk) {
        this.responseData.body += chunk;
    };
    TrouterResponse.prototype.end = function (chunk) {
        if (chunk) {
            this.responseData.body += chunk;
        }
        return this.sendResponse(this.request, this.responseData);
    };
    return TrouterResponse;
}());
/**
 * An client-initiated event that is to be sent to trouter.
 */
var DownstreamEvent = /** @class */ (function () {
    function DownstreamEvent(name) {
        this.name = name;
        this.args = {};
        this.timeoutTimerId = 0;
    }
    return DownstreamEvent;
}());
/**
 * Reason why a connection switch is happening.
 */
var ReconnectReason;
(function (ReconnectReason) {
    /** Configuration change coming from ECS, containing different URL */
    ReconnectReason[ReconnectReason["Configuration"] = 0] = "Configuration";
    /** In response to a `trouter.reconnect` socket.io event */
    ReconnectReason[ReconnectReason["ServerInitiated"] = 1] = "ServerInitiated";
})(ReconnectReason || (exports.ReconnectReason = ReconnectReason = {}));
/**
 * Trouter + registration flow implementation
 */
var TrouterConnection = /** @class */ (function () {
    function TrouterConnection(logProvider, options, manager, tokenProvider, usingLegacyTokenApi, initialUserActivityState, protocolSelector, audienceSubscriptionState) {
        var _this = this;
        var _a;
        this.options = options;
        this.manager = manager;
        this.tokenProvider = tokenProvider;
        this.usingLegacyTokenApi = usingLegacyTokenApi;
        this.protocolSelector = protocolSelector;
        this.audienceSubscriptionState = audienceSubscriptionState;
        this.WEBSOCKET_TRANSPORT_NAME = 'websocket';
        this.XHR_POLLING_TRANSPORT_NAME = 'xhr-polling';
        this.AUDIENCE_SUBSCRIPTION_RESULT_ERROR = 'Error';
        this.AUDIENCE_SUBSCRIPTION_RESULT_UNSUBSCRIBED = 'Unsubscribed';
        this.AUDIENCE_SUBSCRIPTION_RESULT_TIMEOUT = 'Timeout';
        this.AUDIENCE_SUBSCRIPTION_RESULT_BAD_REQUEST = "BadRequest";
        this.AUDIENCE_SUBSCRIPTION_STATE_QUERY_PARAM_REGEX = /&audienceSubscriptionState=[^&]*|^audienceSubscriptionState=[^&]*&?/;
        this.connectionId = '';
        this.inIncallMode = false;
        this.connectionAttempt = 0;
        this.connectedClientId = '';
        this.isNavigatorOnline = true;
        this.onNavigatorOnlineStatusUpdateBound = this.onNavigatorOnlineStatusUpdate.bind(this); // Bound to allow removing the listener
        this.c2cUrlBase = '';
        this.connectingErrorsInRow = 0;
        /** Keeps track of 401s */
        this.unauthorizedErrorCount = 0;
        this.pendingSentEventTimers = {};
        this.lastDisconnectReason = '';
        this.UNKNOWN_TRANSPORT = 'unknown_transport';
        this.connectingErrorsThreshold = 3;
        // this variable represents and ongoing audience subscription operation that has been initiated by user
        // if the operation value exists it means that user requested a subscription but there has not been an answer from server yet
        // valid only for longpoll 
        this.pendingAudienceSubscription = undefined;
        this.logger = new Logger_1.Logger('Connection', logProvider);
        this.timeoutOptions = this.options.timeoutOptions;
        this.tokenBackoff = new ExponentialBackoff_1.ExponentialBackoff(this.logger, this.timeoutOptions.maxBackoffMs);
        this.clientID = Date.now();
        if ((typeof window !== 'undefined') && window.location) {
            this.domId = window.location.hostname;
        }
        var clientInfo = new ClientInfo();
        clientInfo.cv = Constants_1.CLIENT_VERSION;
        clientInfo.ua = '';
        if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.clientInfo) {
            clientInfo.ua = this.safeString(this.options.clientInfo.ua);
            clientInfo.v = this.safeString(this.options.clientInfo.v);
        }
        this.clientInfo = clientInfo;
        this.connectionTracker = new ConnectionTracker_1.ConnectionTracker(logProvider, this.clientID, this.clientInfo, function () { return _this.getServerState(); }, this.options.endpointId, this.options.clientCorrelationID, this.options.environment);
        this.applyConnectionTrackerOptions(options);
        var useIncallMode = this.options.incallModeTimeoutMs > 0;
        this.fsm = new TrouterFsm_1.TrouterFsm(logProvider, this, useIncallMode, this.protocolSelector);
        if (options.registration) {
            var registrarOptions = {
                registrarUrl: options.registration.registrarUrl,
                proxyUrlRewrite: options.rewriteUrlForProxy,
                registrationId: options.registration.registrationId,
                requestTimeoutMs: options.timeoutOptions.fetchTimeoutMs,
                initialRetryDelayMs: 1000,
                maxRetryDelayMs: options.timeoutOptions.maxBackoffMs,
                usingLegacyTokenApi: this.usingLegacyTokenApi,
                maxRetriesForGetToken: options.retryLimitOnTokenFetch,
                extraRegistrationHeaders: options.extraConnectionHeaders
            };
            this.registrarClient = (0, tsregistrar_1.createRegistrarClient)(logProvider, this.tokenProvider, registrarOptions);
        }
        this.userActivityState = initialUserActivityState;
    }
    TrouterConnection.prototype.start = function (externalConnectParams) {
        this.logger.info('Starting');
        this.reconnectParams = externalConnectParams;
        if (typeof window !== 'undefined' && window.navigator && window.addEventListener) {
            this.isNavigatorOnline = window.navigator.onLine;
            window.addEventListener('online', this.onNavigatorOnlineStatusUpdateBound);
            window.addEventListener('offline', this.onNavigatorOnlineStatusUpdateBound);
            this.logger.debug("Registered for browser online notifications - current state: ".concat(this.isNavigatorOnline));
        }
        else {
            this.isNavigatorOnline = true; // Assume always online if the API is not available
        }
        this.fsm.start();
    };
    TrouterConnection.prototype.stop = function (dontUnregister) {
        this.logger.info('Stopping');
        if (typeof window !== 'undefined' && window.navigator) {
            window.removeEventListener('online', this.onNavigatorOnlineStatusUpdateBound);
            window.removeEventListener('offline', this.onNavigatorOnlineStatusUpdateBound);
        }
        this.fsm.stop(dontUnregister);
        this.connectionTracker.close();
    };
    TrouterConnection.prototype.configure = function (options) {
        // Currently only baseUrl and telemetrySettings options are supported for reconfiguration
        var urlChanged = this.options.trouterUrl !== options.trouterUrl;
        this.options = options;
        this.applyConnectionTrackerOptions(options);
        if (urlChanged) {
            this.logger.info('Configuration changed. Reconnection required.');
            this.fsm.onReconnectRequired(false, ReconnectReason.Configuration);
        }
    };
    TrouterConnection.prototype.checkConnection = function (disconnectDetected) {
        this.logger.info("checkConnection called with ".concat(disconnectDetected));
        this.fsm.checkConnection(disconnectDetected);
        // Don't send on disconnectDetected === false, because Teams client calls it on timer
        if (disconnectDetected) {
            this.connectionTracker.sendTelemetry(ConnectionTracker_1.ClientEventName.CheckConnection, {
                disconnectDetected: disconnectDetected
            }, []);
        }
    };
    TrouterConnection.prototype.disableRegistrationsAndAutoReconnect = function () {
        this.stopRegistrationTimer();
        this.cancelPendingRegistrationRequests();
        this.fsm.disableAutoReconnect();
    };
    /** Returns info about connection */
    TrouterConnection.prototype.getServerState = function () {
        return new InternalInterfaces_1.ServerState(this.connectionId, this.connectedClientId, this.domId ? this.domId : '', this.allocateResult ? this.allocateResult.url : '', this.allocateResult ? this.allocateResult.surl : '', this.c2cUrlBase, this.connectionExpireTimestampInSecs);
    };
    TrouterConnection.prototype.getState = function () {
        return this.fsm.getState();
    };
    //////// Implement IWorker ////////
    TrouterConnection.prototype.getToken = function (useCache, backoff, claimsChallenge, reason, retryCounter) {
        var _this = this;
        if (retryCounter === void 0) { retryCounter = 0; }
        this.logger.info("Getting token ".concat(backoff ? 'with backoff' : 'without backoff'));
        var requestFunction = function () {
            _this.connectionTracker.trackStart('token');
            var tokenRequest = {
                needFresh: !useCache,
                wwwAuthenticateHeader: claimsChallenge,
                supportedTokenTypes: Constants_1.SUPPORTED_TOKEN_TYPES,
                purpose: 'trouter'
            };
            _this.logger.info("Requesting token: needFresh=".concat(tokenRequest.needFresh, " ") +
                "types=[".concat(Constants_1.SUPPORTED_TOKEN_TYPES, "], ") +
                "wwwAuthenticateHeader is ".concat(tokenRequest.wwwAuthenticateHeader ? 'non empty' : 'empty'));
            _this.tokenProvider(tokenRequest).then(function (token) {
                _this.logger.debug("".concat(token.tokenType, " token is received"));
                _this.connectionTracker.trackEnd('token');
                _this.fsm.onTokenReceived(token, reason, _this.reconnectParams);
            }).catch(function (error) {
                var msg = (0, Common_1.toJson)(error.stack);
                _this.logger.error("Getting token failed, will retry after timeout. Error: ".concat(msg));
                _this.connectionTracker.trackError('token', msg);
                // Can't retry getToken request, which means client would not receive any notifications from trouter.
                // Unrecoverable error unless client tries to reconnect with Trouter
                //     - retryCounter tracks internal loop
                //     - unauthorizedErrorCount tracks external loop (consecutive number of sendAllocationFailures as a result of 401s)
                if (!_this.canRetryTokenFetchRequest(retryCounter + _this.unauthorizedErrorCount)) {
                    var errorMessage = 'getToken retry limit hit, reached terminal error state';
                    _this.connectionTracker.trackError('token', errorMessage);
                    _this.resetTokenBackoff();
                    _this.fsm.onTerminalError();
                    return;
                }
                _this.getToken(useCache, true, claimsChallenge, reason, retryCounter + 1);
            });
        };
        if (backoff) {
            this.tokenBackoff.backoff('getting token', requestFunction);
        }
        else {
            this.resetTokenBackoff();
            requestFunction();
        }
    };
    TrouterConnection.prototype.startConnectionTimer = function () {
        var _this = this;
        this.stopConnectionTimer();
        this.logger.debug("Starting connection timeout for ".concat(this.timeoutOptions.connectionTimeoutMs, " ms"));
        this.connectionTimeoutId = setTimeout(function () {
            _this.logger.info('Connection timeout is fired');
            _this.fsm.onConnectingTimeout();
        }, this.timeoutOptions.connectionTimeoutMs);
    };
    TrouterConnection.prototype.stopConnectionTimer = function () {
        if (this.connectionTimeoutId) {
            this.logger.debug('Stopping connection timeout');
            clearTimeout(this.connectionTimeoutId);
            this.connectionTimeoutId = undefined;
        }
    };
    TrouterConnection.prototype.startPingTimer = function () {
        var _this = this;
        if (this.transportTypeName === 'websocket') {
            this.logger.debug("Starting ping timeout for ".concat(this.timeoutOptions.pingTimeoutMs, " ms"));
            this.pingTimerId = setInterval(function () {
                _this.logger.info('Ping interval fired');
                _this.fsm.onPingInterval();
            }, this.timeoutOptions.pingTimeoutMs);
        }
        else {
            this.logger.debug("Not starting ping for transport ".concat(this.transportTypeName));
        }
    };
    TrouterConnection.prototype.stopPingTimer = function () {
        if (this.pingTimerId) {
            this.logger.debug('Stopping ping timeout');
            this.clearPingResponseTimer();
            clearInterval(this.pingTimerId);
            this.pingTimerId = undefined;
        }
    };
    TrouterConnection.prototype.shouldSkipRegistration = function () {
        return this.options.registration === undefined;
    };
    TrouterConnection.prototype.hasCustomRegistrationTtl = function () {
        var _a, _b;
        return ((_a = this.options.registration) === null || _a === void 0 ? void 0 : _a.registrarTtlSec) !== undefined && ((_b = this.options.registration) === null || _b === void 0 ? void 0 : _b.registrarTtlSec) !== 0;
    };
    TrouterConnection.prototype.startRegistrationTimer = function () {
        var _this = this;
        this.stopRegistrationTimer();
        var timeForReregistrationSec = 30;
        var _a = this.getRegistrationTtl(), ttl = _a[0], isTtlReduced = _a[1];
        if (ttl <= timeForReregistrationSec || !isTtlReduced) {
            this.logger.debug("Starting registration expiration timer (TTL ".concat(ttl, " sec)"));
            this.registrationTimerId = setTimeout(function () {
                _this.registrationTimerId = undefined;
                _this.logger.warn('Registration expired but the connection is still alive. Should never happen');
                _this.dispatchUnregistered();
            }, ttl * 1000);
            return;
        }
        var delay = ttl - timeForReregistrationSec;
        this.logger.debug("Starting registration extension timer for ".concat(delay, " sec"));
        this.registrationTimerId = setTimeout(function () {
            _this.logger.info('Registration extension timer fired');
            _this.registrationTimerId = setTimeout(function () {
                _this.registrationTimerId = undefined;
                _this.logger.debug('Registration extension did not happen in time');
                _this.dispatchUnregistered();
            }, timeForReregistrationSec * 1000);
            _this.fsm.onRegistrationNearExpiry();
        }, delay * 1000);
    };
    TrouterConnection.prototype.startRegistrationRetryTimer = function () {
        var _this = this;
        this.stopRegistrationTimer();
        // A simple static delay for now, per discussion in PR 870422.
        var registrationRetryDelaySec = 123;
        this.registrationTimerId = setTimeout(function () {
            _this.registrationTimerId = undefined;
            _this.fsm.onRetryRegistration();
        }, registrationRetryDelaySec * 1000);
    };
    TrouterConnection.prototype.stopRegistrationTimer = function () {
        if (this.registrationTimerId) {
            this.logger.debug('Stopping registration timeout');
            clearTimeout(this.registrationTimerId);
            this.registrationTimerId = undefined;
        }
    };
    TrouterConnection.prototype.resendRegistration = function () {
        if (!this.registrarClient) {
            throw new Error('Trouter Client not configured to handle registrations');
        }
        this.fsm.onResendRegistration();
        return Promise.resolve();
    };
    TrouterConnection.prototype.buildSocketIoUrlParams = function (userActivitySnapshot, audienceSubscriptionSnapshot) {
        if (!this.allocateResult) {
            throw new Error('Allocate result is undefined in buildSocketIoUrlParams()');
        }
        var urlParams = {};
        // Copy connection parameters (i.e. signature) from allocation response
        var signatureData = this.allocateResult.connectparams;
        for (var _i = 0, _a = Object.keys(signatureData); _i < _a.length; _i++) {
            var i = _a[_i];
            if (signatureData[i] !== undefined) {
                var value = signatureData[i];
                if (typeof value === 'string' || typeof value === 'number') {
                    urlParams[i] = value;
                }
                else {
                    this.logger.error("signatureData[".concat(i, "] has unsupported type ").concat(typeof value));
                }
            }
        }
        // And add some more fields
        urlParams.v = VERSION;
        urlParams.tc = encodeURI((0, Common_1.toJson)(this.clientInfo));
        urlParams.timeout = this.timeoutOptions.pingTimeoutMs / 1000;
        urlParams.auth = 'true';
        if (this.options.endpointId) {
            urlParams.epid = this.options.endpointId;
        }
        if (userActivitySnapshot) {
            urlParams.userActivity = encodeURI((0, Common_1.toJson)(userActivitySnapshot));
        }
        if (audienceSubscriptionSnapshot) {
            urlParams.audienceSubscriptionState = encodeURIComponent((0, Common_1.toJson)(audienceSubscriptionSnapshot));
        }
        return this.appendConnectedClientIds(this.buildQuery(urlParams), true);
    };
    TrouterConnection.prototype.startSocketIo = function (token) {
        var _a, _b;
        this.logger.debug('Starting socket io');
        this.connectionTracker.trackStart('connectSocket');
        if (!this.allocateResult) {
            throw new Error('Allocate result is undefined in startSocketIo()');
        }
        var options = this.options.ioOptions ? __assign({}, this.options.ioOptions) : new SocketIoOptions();
        // Take user activity snapshot (if a state isn't unknown) to make sure it's consistent between the function calls below.
        var userActivitySnapshot = this.userActivityState.state !== Interfaces_1.UserActivityState.Unknown
            ? this.userActivityState.increaseCvAndGetEventObject()
            : undefined;
        var audienceSubscriptionStateSnapshot = (_a = this.audienceSubscriptionState) === null || _a === void 0 ? void 0 : _a.increaseCvAndGetEventObject();
        // Regardless of any passed in socket.io options, force the following settings.
        options['force new connection'] = true;
        options.reconnect = false;
        options.rewriteUrlForProxy = this.options.rewriteUrlForProxy;
        options.requestHeaders = __assign(__assign({}, this.options.extraConnectionHeaders), headersFromToken(token, this.usingLegacyTokenApi));
        // Query params to each socket.io request
        options.query = this.buildSocketIoUrlParams(userActivitySnapshot, audienceSubscriptionStateSnapshot);
        this.logger.info("connecting to ".concat(this.allocateResult.socketio, "?").concat(options.query));
        // msg868 - clear all events and disconnect
        this.stopSocketIo();
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
        this.socket = ((_b = this.options.io) !== null && _b !== void 0 ? _b : io).connect(this.allocateResult.socketio, options);
        if (this.socket === undefined) {
            throw new Error('Can\'t create Socket.io object');
        }
        this.attachSocketIoHandlers(this.socket, token, userActivitySnapshot, audienceSubscriptionStateSnapshot);
    };
    TrouterConnection.prototype.stopSocketIo = function () {
        if (this.socket) {
            this.logger.debug('clearing socket.io');
            try {
                for (var _i = 0, _a = [
                    'connecting', 'connect', 'connect_failed', 'close_during_connecting', 'disconnect', 'reconnect', 'reconnect_failed',
                    'reconnecting', 'error', 'message', 'trouter.connected', 'trouter.reconnect', 'trouter.message_loss'
                ]; _i < _a.length; _i++) {
                    var event_1 = _a[_i];
                    this.socket.removeAllListeners(event_1);
                }
                this.socket.disconnect();
                this.logger.debug('cleared socket');
                this.socket = undefined;
            }
            catch (error) {
                this.logger.error("exception in disconnecting previous socket. Error: ".concat(errorStackToJson(error)));
            }
        }
    };
    TrouterConnection.prototype.dispatchConnected = function () {
        this.logger.info('dispatching connected');
        this.manager.onConnected(this);
    };
    TrouterConnection.prototype.dispatchRegistered = function () {
        this.logger.info('dispatching registered');
        this.manager.onRegistered(this);
    };
    TrouterConnection.prototype.dispatchUnregistered = function () {
        this.logger.info('dispatching unregistered');
        this.manager.onUnregistered(this);
    };
    TrouterConnection.prototype.dispatchDownstreamRequest = function (request) {
        var _this = this;
        this.logger.debug('dispatching downstream request');
        try {
            var response = new TrouterResponse(request, new ConnectionTracker_1.ResponseData(request.id), function (req, responseData) {
                _this.logger.debug('sending response to downstream');
                return _this.sendResponse(req, responseData);
            });
            this.manager.onDownstreamRequest(this, request, response);
        }
        catch (error) {
            this.logger.error("exception in socket.on message. Error : ".concat(errorStackToJson(error)));
        }
    };
    TrouterConnection.prototype.dispatchReconnecting = function () {
        this.logger.info('dispatching reconnecting');
        this.manager.onReconnecting(this);
    };
    TrouterConnection.prototype.dispatchReconnectIsRequired = function (useConnectParamsFromCache, reason) {
        this.logger.info('dispatching reconnect is required by server');
        this.manager.onReconnectIsRequired(this, useConnectParamsFromCache, reason);
    };
    TrouterConnection.prototype.dispatchDisconnected = function () {
        this.logger.info('dispatching disconnected');
        this.manager.onDisconnected(this);
    };
    TrouterConnection.prototype.dispatchTerminalError = function () {
        this.logger.info('dispatching terminal error');
        this.manager.onTerminalError(this);
    };
    TrouterConnection.prototype.dispatchTrouterMessageLost = function (messageLossIndicators) {
        this.logger.info('dispatching trouter message lost');
        this.manager.onTrouterMessageLost(messageLossIndicators);
    };
    TrouterConnection.prototype.countDisconnectBeforeConnectionEstablishment = function () {
        this.logger.warn('counting disconnect before connection was fully established as a connection failure');
        this.connectingErrorsInRow++;
        if (this.connectingErrorsInRow >= this.connectingErrorsThreshold) {
            this.resetReconnectParamsOnErrorThreshold();
        }
    };
    TrouterConnection.prototype.sendProcessedDroppedIndicators = function (messageLossIndicators) {
        var _this = this;
        try {
            this.logger.debug('emitting processed flow tags to the server');
            var processedMessageLossEvent = new DownstreamEvent('trouter.processed_message_loss');
            processedMessageLossEvent.args = { droppedIndicators: messageLossIndicators };
            this.sendDownstreamEvent(processedMessageLossEvent, function () {
                _this.logger.info('emitted processed flow tags to the server');
            });
        }
        catch (error) {
            var msg = errorStackToJson(error);
            this.logger.error("unable to send processed message loss event. Error: ".concat(msg));
            this.connectionTracker.trackError('trouter.processed_message_loss', msg, false);
        }
    };
    TrouterConnection.prototype.sendAllocateRequest = function (token) {
        var _this = this;
        this.connectionAttempt++;
        this.connectionTracker.trackNewConnection();
        var url = this.options.trouterUrl;
        var connectParams;
        var rp = this.reconnectParams;
        var expiration = typeof (rp === null || rp === void 0 ? void 0 : rp.se) === 'string' ? parseInt(rp.se, 10) : (typeof (rp === null || rp === void 0 ? void 0 : rp.se) === 'number' ? rp.se : undefined);
        if (expiration && expiration <= Date.now() + 3600000) { // 1 hour
            this.logger.warn("Dropping expired cached connection parameters: ".concat(new Date(expiration)));
            this.reconnectParams = rp = undefined;
        }
        if (rp && rp.serviceUrl !== url) {
            this.logger.warn("Dropping cached connection parameters for a different environment (".concat(rp.serviceUrl, ", now ").concat(url, ")"));
            this.reconnectParams = rp = undefined;
        }
        if (rp === null || rp === void 0 ? void 0 : rp.reconnectUrl) {
            url = rp.reconnectUrl;
        }
        if (rp) {
            // Do not append serviceUrl and reconnectUrl as query parameters
            connectParams = __assign(__assign({}, rp), { serviceUrl: undefined, reconnectUrl: undefined });
        }
        else {
            connectParams = null;
        }
        url = (0, ProtocolAdapters_1.adaptUrl)(url, 'v4a');
        url = this.appendCorrelationIds(url, false);
        url = this.appendEndpointId(url, false);
        if (connectParams) {
            url += "&".concat(this.buildQuery(connectParams));
            // Currently server doesn't return "v" in allocate result, but it
            // can be changed, so implement it this way just in case
            if (!connectParams.v) {
                url += "&v=".concat(VERSION);
            }
        }
        url = this.options.rewriteUrlForProxy(url);
        var allocateRequest = new Request(url, {
            method: 'POST',
            mode: 'cors',
            headers: new Headers(__assign(__assign({ 'Content-Type': 'text/plain' }, this.options.extraConnectionHeaders), headersFromToken(token, this.usingLegacyTokenApi)))
        });
        this.logger.info("sendAllocateRequest: POST ".concat(url));
        this.connectionTracker.trackStart('allocation');
        var startTimestamp = Date.now();
        var responseStatusCode = -1;
        var responseClaimsChallenge;
        var responseSkypetokenDeprecated = false;
        (0, Common_1.fetchWithTimeout)(allocateRequest, this.timeoutOptions.fetchTimeoutMs).then(function (response) {
            var _a;
            responseStatusCode = response.status;
            if (!response.ok) {
                responseClaimsChallenge = (_a = response.headers.get('www-authenticate')) !== null && _a !== void 0 ? _a : undefined;
                responseSkypetokenDeprecated = response.headers.get('x-trouter-skypetoken-deprecated') === '1';
                _this.logger.warn("Allocation request got response status ".concat(response.status, ", www-authenticate header was ").concat(responseClaimsChallenge ? 'not empty' : 'empty'));
                throw new Error(response.statusText);
            }
            var contentType = response.headers.get('content-type');
            if (!contentType || (contentType !== 'application/json' && !contentType.startsWith('application/json;'))) {
                throw new Error("Content-type '".concat(contentType, "' is unexpected"));
            }
            _this.connectionTracker.trackEnd('allocation');
            return response.json();
        }).then(function (responseObj) {
            _this.unauthorizedErrorCount = 0;
            // We perform no parsing/validation of the response received from server
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            _this.onAllocationResponse(responseObj, token);
        }).catch(function (error) {
            _this.connectingErrorsInRow++;
            var msg = "".concat(error).concat(responseStatusCode >= 0 ? ", status code ".concat(responseStatusCode) : '');
            _this.logger.error("".concat(_this.connectingErrorsInRow, " failed connecting attempt(s) in a row. ").concat(msg));
            _this.connectionTracker.trackError('allocation', msg);
            if (responseSkypetokenDeprecated) {
                var errorMessage = 'Skypetoken deprecated response, not retrying any further';
                _this.logger.error(errorMessage);
                _this.connectionTracker.trackError('allocation', errorMessage);
                _this.fsm.onTerminalError();
                return;
            }
            if (responseStatusCode === 401) {
                _this.unauthorizedErrorCount++;
            }
            if (!_this.canRetryTokenFetchRequest(_this.unauthorizedErrorCount)) {
                var errorMessage = 'getToken retry limit hit, reached terminal error state';
                _this.connectionTracker.trackError('allocation', errorMessage);
                _this.fsm.onTerminalError();
                return;
            }
            if (responseStatusCode === -1 && !_this.isNavigatorOnline) {
                _this.logger.info('Expected failure, the browser says it is not online at the moment');
            }
            else if (_this.reconnectParams && _this.connectingErrorsInRow >= _this.connectingErrorsThreshold) {
                if (responseStatusCode >= 400 && responseStatusCode <= 599) {
                    _this.resetReconnectParamsOnErrorThreshold();
                }
                else if (_this.reconnectParams.reconnectUrl && _this.connectingErrorsInRow % 3 === 0) {
                    _this.logger.warn("".concat(_this.connectingErrorsInRow, " connection attempts, testing nominal service URL"));
                    // Make sure to finish the check before connection timeout passes to avoid unexpected FSM calls
                    var timeoutMs = Math.min(_this.timeoutOptions.connectionTimeoutMs - (Date.now() - startTimestamp) - 500, _this.timeoutOptions.fetchTimeoutMs);
                    _this.testNominalUrlConnectivity(timeoutMs)
                        .then(function (result) {
                        _this.connectionTracker.trackProgress('nomcheck', result ? 'ok' : 'failed');
                        if (result) {
                            _this.logger.warn('Nominal service URL is reachable, erasing cached reconnect URL');
                            if (_this.reconnectParams) {
                                delete _this.reconnectParams.reconnectUrl;
                            }
                        }
                        else {
                            _this.logger.warn('Nominal service URL is not reachable either, keeping cached reconnect URL');
                        }
                        _this.fsm.onAllocationFailed(false, undefined);
                    }, function () {
                        // Should not happen, but removes no-floating-promises warning
                        _this.fsm.onAllocationFailed(false, undefined);
                    });
                    return;
                }
            }
            _this.fsm.onAllocationFailed(responseStatusCode === 401, responseClaimsChallenge);
        });
    };
    TrouterConnection.prototype.testNominalUrlConnectivity = function (timeoutMs) {
        var _this = this;
        if (timeoutMs < 1000) {
            this.logger.warn("There is no time left to reasonably perform the nominal service URL connectivity check (".concat(timeoutMs, " ms), falling back to assuming that the connectivity is fine"));
            return Promise.resolve(true);
        }
        var testRequest;
        try {
            var url = new URL(this.options.trouterUrl);
            // Modify the URL to reach the root page (which returns a plain text string "Trouter")
            url.pathname = '/';
            // Add a few query parameters for possible classification and troubleshooting
            url.search = '?' + this.buildQuery({
                check: Date.now(),
                cor_id: encodeURIComponent(this.options.clientCorrelationID),
                epid: encodeURIComponent(this.options.endpointId ? this.options.endpointId : ''),
                tc: encodeURIComponent((0, Common_1.toJson)(this.clientInfo))
            });
            testRequest = new Request(this.options.rewriteUrlForProxy(url.toString()), {
                method: 'GET',
                headers: { Accept: 'text/plain' }
            });
        }
        catch (error) {
            this.logger.warn("Nominal service URL connectivity test request could not be created (".concat(error, "), falling back to assuming that the connectivity is fine"));
            return Promise.resolve(true);
        }
        return (0, Common_1.fetchWithTimeout)(testRequest, timeoutMs)
            .then(function (response) {
            if (response.status !== 200) {
                throw new Error("Not 200 OK: ".concat(response.status, " ").concat(response.statusText));
            }
            return response.text();
        })
            .then(function (body) {
            if (body !== 'Trouter') {
                throw new Error("Not \"Trouter\": ".concat(body.substring(0, 16)).concat(body.length > 16 ? '...' : ''));
            }
            return true;
        })
            .catch(function (error) {
            _this.logger.error("Nominal service URL connectivity test failed: ".concat(error));
            return false;
        });
    };
    TrouterConnection.prototype.sendPingRequest = function () {
        var _this = this;
        if (this.socket && this.pingResponseTimerId === undefined) {
            try {
                this.logger.debug('emitting ping event');
                var timeoutReached_1 = false;
                this.socket.emit('ping', function () {
                    if (timeoutReached_1 === true) {
                        return;
                    }
                    _this.onPingResponse();
                });
                this.pingResponseTimerId = setTimeout(function () {
                    _this.logger.error('Ping response timeout is fired');
                    timeoutReached_1 = true;
                    _this.clearPingResponseTimer();
                    _this.fsm.onPingResponseTimeout();
                }, this.timeoutOptions.pongTimeoutMs);
            }
            catch (error) {
                var msg = errorStackToJson(error);
                this.logger.error("unable to send ping. Error: ".concat(msg));
                this.connectionTracker.trackError('ping', msg, false);
            }
        }
    };
    TrouterConnection.prototype.connectV4c = function (token, reason) {
        var _a, _b, _c, _d, _e, _f;
        var options = this.options.ioOptions ? __assign({}, this.options.ioOptions) : new SocketIoOptions();
        // Regardless of any passed in socket.io options, force the following settings.
        options['force new connection'] = true;
        options.reconnect = false;
        if (((_a = this.reconnectParams) === null || _a === void 0 ? void 0 : _a.serviceUrl) &&
            // previous input URL != current input URL (passed via `start()`)
            (0, ProtocolAdapters_1.adaptUrl)(this.reconnectParams.serviceUrl, 'v4c') !== (0, ProtocolAdapters_1.adaptUrl)(this.options.trouterUrl, 'v4c')) {
            this.logger.warn("Dropping cached connection parameters for a different environment (".concat(this.reconnectParams.serviceUrl, ", now ").concat(this.options.trouterUrl, ")"));
            this.reconnectParams = undefined;
        }
        var inputUrl = (_d = (_b = (0, ProtocolAdapters_1.redirectUrlIfPresent)(reason)) !== null && _b !== void 0 ? _b : ((reason === null || reason === void 0 ? void 0 : reason.kind) !== 'redirect-no-host' ? (_c = this.reconnectParams) === null || _c === void 0 ? void 0 : _c.reconnectUrl : undefined)) !== null && _d !== void 0 ? _d : this.options.trouterUrl;
        var url = (0, ProtocolAdapters_1.adaptUrl)(inputUrl, 'v4c');
        options['skipped handshake data'] = {
            timeout: 70,
            websocketUrl: url
        };
        options.query = this.buildV4cUrlParams();
        options.rewriteUrlForProxy = this.options.rewriteUrlForProxy;
        try {
            this.stopSocketIo();
            this.transportTypeName = 'websocket';
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-assignment
            this.socket = ((_e = this.options.io) !== null && _e !== void 0 ? _e : io).connect(this.options.trouterUrl, options);
            if (this.socket === undefined) {
                throw new Error('failed to create Socket.io object');
            }
            var audienceSubscriptionStateSnapshot = (_f = this.audienceSubscriptionState) === null || _f === void 0 ? void 0 : _f.increaseCvAndGetEventObject();
            this.attachSocketIoHandlers(this.socket, token, undefined, audienceSubscriptionStateSnapshot);
        }
        catch (e) {
            this.logger.error("".concat(e));
            this.connectionTracker.trackError('v4c', "".concat(e));
            this.fsm.onV4cException();
        }
    };
    TrouterConnection.prototype.sendV4cAuthenticationEvent = function (token) {
        var _a;
        var payload = {
            headers: __assign(__assign({}, this.options.extraConnectionHeaders), headersFromToken(token, this.usingLegacyTokenApi)),
            connectparams: (0, ProtocolAdapters_1.reconnectParamsWithoutUrls)(this.reconnectParams)
        };
        (_a = this.socket) === null || _a === void 0 ? void 0 : _a.emit(Constants_1.USER_AUTHENTICATE_EVENT_NAME, payload);
    };
    TrouterConnection.prototype.setUserActivityState = function (userActivityObject) {
        var changed = (userActivityObject.state !== this.userActivityState.state);
        this.userActivityState = userActivityObject;
        if (changed) {
            this.logger.info("Changing user activity state to '".concat(userActivityObject.toEventJSON(), "'"));
            this.fsm.onSetNewUserActivityState();
        }
        else {
            this.logger.debug("Not changing the same user activity state '".concat(userActivityObject.toEventJSON(), "'"));
            this.manager.onUserActivityStateAccepted(userActivityObject.correlationVector.value());
        }
    };
    TrouterConnection.prototype.sendUserActivityState = function (reason, connected) {
        if (this.userActivityState.state === Interfaces_1.UserActivityState.Unknown) {
            return;
        }
        if (this.transportTypeName === 'websocket' && connected) {
            if (reason === InternalInterfaces_1.UserActivityEventReason.Connected) {
                this.sendUserActivityStateMultiple(2);
            }
            else {
                this.sendUserActivityStateMultiple(1);
            }
        }
        else if (this.transportTypeName === 'xhr-polling') { // ignoring the connected flag
            if (reason === InternalInterfaces_1.UserActivityEventReason.Modified) {
                this.fsm.forceReconnect('user activity/force reconnect');
            }
        }
    };
    TrouterConnection.prototype.setAudienceSubscriptionsAsync = function (audienceSubscriptionState, timeoutInMs) {
        var previousAudienceSubscriptionState = this.audienceSubscriptionState;
        this.audienceSubscriptionState = audienceSubscriptionState;
        if (this.transportTypeName === this.WEBSOCKET_TRANSPORT_NAME) {
            return this.setAudienceSubscriptionsInternalAsync(audienceSubscriptionState.increaseCvAndGetEventObject(), timeoutInMs);
        }
        if (this.transportTypeName === this.XHR_POLLING_TRANSPORT_NAME) {
            var setAudienceSubscriptionsPromise = this.setAudienceSubscriptionsLongpollInternalAsync(audienceSubscriptionState.increaseCvAndGetEventObject(), timeoutInMs, previousAudienceSubscriptionState);
            this.fsm.forceReconnect('set audience subscription force reconnect');
            return setAudienceSubscriptionsPromise;
        }
        throw new Error('set audience subscription executed on an unknown transport');
    };
    TrouterConnection.prototype.setAudienceSubscriptionsUnsafeAsync = function (audienceSubscriptionSnapshot) {
        if (!audienceSubscriptionSnapshot) {
            return undefined;
        }
        if (this.transportTypeName === this.WEBSOCKET_TRANSPORT_NAME) {
            return this.setAudienceSubscriptionsInternalAsync(audienceSubscriptionSnapshot, 15000);
        }
    };
    TrouterConnection.prototype.setAudienceSubscriptionsInternalAsync = function (audienceSubscriptionSnapshot, timeoutInMs) {
        return __awaiter(this, void 0, void 0, function () {
            var audienceSubscriptionEvent, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.info('[WebSocket] Audience subscription set requested.');
                        audienceSubscriptionEvent = new DownstreamEvent('audience.subscribe');
                        audienceSubscriptionEvent.args = audienceSubscriptionSnapshot;
                        return [4 /*yield*/, new Promise(function (resolve) {
                                var hasTimedOut = false;
                                var timeoutId = setTimeout(function () {
                                    hasTimedOut = true;
                                    return resolve(_this.buildAudienceSubscriptionsTimeoutResponse(audienceSubscriptionSnapshot));
                                }, timeoutInMs);
                                _this.sendDownstreamEvent(audienceSubscriptionEvent, function (_, args) {
                                    if (hasTimedOut) {
                                        return;
                                    }
                                    clearTimeout(timeoutId);
                                    _this.logger.debug("[Websocket] Audience subscription response: ".concat(args));
                                    if (_this.pendingAudienceSubscription) {
                                        _this.onAudienceSubscriptionResult(args);
                                    }
                                    resolve(args);
                                });
                            })];
                    case 1:
                        result = _a.sent();
                        this.manager.onAudiencesSetResolved(result, audienceSubscriptionSnapshot.cv);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    TrouterConnection.prototype.setAudienceSubscriptionsLongpollInternalAsync = function (audienceSubscriptionSnapshot, timeoutInMs, previousSubscriptionState) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var result, currentResponse, currentAudienceResponse, subscribesToDifferentAudience, synthResponses;
            var _b;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.logger.info('[XHR Polling] Audience subscription set requested.');
                        if (this.pendingAudienceSubscription) {
                            this.logger.error('Racing audience subscriptions occured. This situation resolves into undefined scenario and/or nasal demons.');
                            clearTimeout(this.pendingAudienceSubscription.timeoutId);
                        }
                        if (audienceSubscriptionSnapshot.audiences.length === 0) {
                            return [2 /*return*/, this.handleAudienceUnsubscribeLongpoll(audienceSubscriptionSnapshot.cv, previousSubscriptionState)];
                        }
                        return [4 /*yield*/, new Promise(function (resolve) {
                                var timeoutId = setTimeout(function () {
                                    _this.pendingAudienceSubscription = undefined;
                                    return resolve(_this.buildAudienceSubscriptionsTimeoutResponse(audienceSubscriptionSnapshot));
                                }, timeoutInMs);
                                _this.pendingAudienceSubscription = {
                                    audienceSetResolve: resolve,
                                    timeoutId: timeoutId
                                };
                            })];
                    case 1:
                        result = _c.sent();
                        if (this.manager.getState() === Interfaces_1.TrouterState.Unknown || this.transportTypeName === this.WEBSOCKET_TRANSPORT_NAME) {
                            return [2 /*return*/, result];
                        }
                        currentResponse = result.responses[0];
                        if ((currentResponse === null || currentResponse === void 0 ? void 0 : currentResponse.result.audienceSubscriptionState) === this.AUDIENCE_SUBSCRIPTION_RESULT_BAD_REQUEST) {
                            this.clearAudienceSubscriptionStateQueryParam();
                            this.manager.onAudiencesSetResolved(result, audienceSubscriptionSnapshot.cv);
                            return [2 /*return*/, result];
                        }
                        currentAudienceResponse = result.responses.find(function (r) { return r.audienceId === audienceSubscriptionSnapshot.audiences[0].id; });
                        if ((currentAudienceResponse === null || currentAudienceResponse === void 0 ? void 0 : currentAudienceResponse.result.audienceSubscriptionState) === this.AUDIENCE_SUBSCRIPTION_RESULT_ERROR) {
                            this.clearAudienceSubscriptionStateQueryParam();
                            this.manager.onAudiencesSetResolved(result, audienceSubscriptionSnapshot.cv);
                            return [2 /*return*/, result];
                        }
                        subscribesToDifferentAudience = ((_a = previousSubscriptionState === null || previousSubscriptionState === void 0 ? void 0 : previousSubscriptionState.audienceSubscriptionModel.audienceSubscriptions[0]) === null || _a === void 0 ? void 0 : _a.id) !== (currentResponse === null || currentResponse === void 0 ? void 0 : currentResponse.audienceId);
                        if (previousSubscriptionState && subscribesToDifferentAudience) {
                            synthResponses = this.mapToSyntheticAudienceSubscriptionResponses(previousSubscriptionState.audienceSubscriptionModel.audienceSubscriptions, this.AUDIENCE_SUBSCRIPTION_RESULT_UNSUBSCRIBED, 200);
                            (_b = result.responses).push.apply(_b, synthResponses);
                        }
                        this.manager.onAudiencesSetResolved(result, audienceSubscriptionSnapshot.cv);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    // remove the `audienceSubscriptionState` param from longpoll query string so the subscription is not attempted over and over creating loop
    TrouterConnection.prototype.clearAudienceSubscriptionStateQueryParam = function () {
        var _a, _b, _c;
        if ((_c = (_b = (_a = this.socket) === null || _a === void 0 ? void 0 : _a.socket) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.query) {
            this.socket.socket.options.query = this.socket.socket.options.query.replace(this.AUDIENCE_SUBSCRIPTION_STATE_QUERY_PARAM_REGEX, '');
        }
    };
    TrouterConnection.prototype.handleAudienceUnsubscribeLongpoll = function (correlationVector, previousSubscriptionState) {
        var _a;
        this.audienceSubscriptionState = undefined;
        var result = {
            responses: []
        };
        if (previousSubscriptionState) {
            var synthResponses = this.mapToSyntheticAudienceSubscriptionResponses(previousSubscriptionState.audienceSubscriptionModel.audienceSubscriptions, this.AUDIENCE_SUBSCRIPTION_RESULT_UNSUBSCRIBED, 200);
            (_a = result.responses).push.apply(_a, synthResponses);
        }
        this.manager.onAudiencesSetResolved(result, correlationVector);
        return result;
    };
    TrouterConnection.prototype.buildAudienceSubscriptionsTimeoutResponse = function (audienceSubscriptionSnapshot) {
        this.logger.error("Audience subscription attempt has timed out.");
        return {
            responses: this.mapToSyntheticAudienceSubscriptionResponses(audienceSubscriptionSnapshot.audiences, this.AUDIENCE_SUBSCRIPTION_RESULT_TIMEOUT)
        };
    };
    TrouterConnection.prototype.mapToSyntheticAudienceSubscriptionResponses = function (audiences, synthState, synthResponseStatus) {
        return audiences
            .map(function (audSub) { return ({
            audienceId: audSub.id,
            result: {
                audienceSubscriptionState: synthState,
                responseStatus: synthResponseStatus
            }
        }); });
    };
    TrouterConnection.prototype.expediteBackoff = function () {
        this.tokenBackoff.expediteIfPending();
    };
    TrouterConnection.prototype.sendRegisterRequest = function () {
        var _this = this;
        if (!this.options.registration || !this.registrarClient) {
            throw new Error('Internal error - options.registration is undefined');
        }
        if (!this.allocateResult) {
            throw new Error('Allocate result is undefined in sendRegisterRequest()');
        }
        this.logger.info('sending register request');
        var span = new Common_1.Timespan();
        this.connectionTracker.trackStart('registration');
        var registrationTtl = this.getRegistrationTtl()[0];
        this.registrarClient.register({
            appId: this.options.registration.pnhAppId,
            aesKey: '',
            languageId: 'en-US',
            platform: this.options.registration.platform,
            templateKey: this.options.registration.pnhTemplateKey,
            platformUIVersion: this.options.registration.platformUIVersion,
            productContext: this.options.registration.productContext
        }, {
            TROUTER: [{
                    context: this.options.registration.context,
                    path: this.allocateResult.surl,
                    ttl: registrationTtl
                }]
        }).then(function () {
            _this.logger.info('Register request successful');
            _this.connectionTracker.trackEnd('registration');
            _this.fsm.onRegistrationSucceeded();
            _this.connectionTracker.sendTelemetry(ConnectionTracker_1.ClientEventName.Registration, {
                duration: span.duration
            }, []);
        }).catch(function (error) {
            _this.logger.error("Register request failed. Error: ".concat(error));
            _this.connectionTracker.trackError('registration', errorMessageToString(error));
            _this.fsm.onRegistrationFailed();
            _this.connectionTracker.sendTelemetry(ConnectionTracker_1.ClientEventName.Registration, {
                duration: span.duration
            }, []);
        });
    };
    TrouterConnection.prototype.sendUnregisterRequest = function () {
        var _this = this;
        this.logger.info('sending unregister request');
        var span = new Common_1.Timespan();
        if (!this.options.registration || !this.registrarClient) {
            throw new Error('Internal error - options.registration is undefined');
        }
        this.connectionTracker.trackStart('unregistration');
        this.registrarClient.unregister().then(function () {
            _this.logger.info('Unregister request successful');
            _this.connectionTracker.trackEnd('unregistration');
            _this.fsm.onUnregistrationDone();
            _this.connectionTracker.sendTelemetry(ConnectionTracker_1.ClientEventName.Unregistration, {
                duration: span.duration
            }, []);
        }).catch(function (error) {
            _this.logger.error("Unregister request failed. Error: ".concat(error));
            _this.connectionTracker.trackError('unregistration', errorMessageToString(error));
            // The Registrar Client library already does internal retries on 5xx HTTP responses etc.
            // So if we end up here, something more exceptional must have happened. There is little
            // point delaying the stopping further by trying again, just finish as if successful.
            _this.fsm.onUnregistrationDone();
            _this.connectionTracker.sendTelemetry(ConnectionTracker_1.ClientEventName.Unregistration, {
                duration: span.duration
            }, []);
        });
    };
    TrouterConnection.prototype.resetTokenBackoff = function () {
        this.tokenBackoff.reset();
    };
    TrouterConnection.prototype.cancelPendingRegistrationRequests = function () {
        if (this.registrarClient) {
            this.registrarClient.cancelPendingRequests();
        }
    };
    TrouterConnection.prototype.clearSentEventTimers = function () {
        var keys = Object.keys(this.pendingSentEventTimers);
        if (keys.length > 0) {
            this.logger.debug('Clearing all pending downstream events related timers');
            for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                var key = keys_1[_i];
                this.clearSentEventTimer(Number(key));
            }
        }
    };
    TrouterConnection.prototype.restartIncallModeTimer = function () {
        var _this = this;
        this.clearIncallModeTimerId();
        this.logger.debug('Restarting incall mode timer');
        this.incallModeTimerId = setTimeout(function () {
            _this.logger.info('Call mode timer fired');
            _this.fsm.onIncallModeTimer();
        }, this.options.incallModeTimeoutMs);
    };
    TrouterConnection.prototype.enterIncallMode = function () {
        this.logger.info('Entering incall mode');
        this.timeoutOptions = this.options.incallTimeoutOptions;
        this.tokenBackoff.setMaxBackoffMs(this.timeoutOptions.maxBackoffMs);
        // Uncomment to enable change of timeout in XHR mode - do it once server start to support it
        // if (this.socket) {
        //     this.socket.socket.options.query = this.buildSocketIoUrlParams();
        // }
        this.inIncallMode = true;
    };
    TrouterConnection.prototype.exitIncallMode = function () {
        this.logger.info('Exiting incall mode');
        this.clearIncallModeTimerId();
        this.timeoutOptions = this.options.timeoutOptions;
        this.tokenBackoff.setMaxBackoffMs(this.timeoutOptions.maxBackoffMs);
        // Uncomment to enable change of timeout in XHR mode - do it once server start to support it
        // if (this.socket) {
        //     this.socket.socket.options.query = this.buildSocketIoUrlParams();
        // }
        this.inIncallMode = false;
    };
    TrouterConnection.prototype.isIncallMode = function () {
        return this.inIncallMode;
    };
    TrouterConnection.prototype.sendDisconnectTelemetryEvent = function (reason) {
        var props = { reason: reason, serverClosed: !this.fsm.isActive() };
        this.connectionTracker.trackDisconnected(props);
        this.connectionTracker.clearConnectedInfo();
    };
    TrouterConnection.prototype.forceReconnectDueToNoRegistration = function () {
        this.fsm.forceReconnect('force reconnect due to no registration');
    };
    TrouterConnection.prototype.resetReconnectParamsOnErrorThreshold = function () {
        this.logger.warn("".concat(this.connectingErrorsInRow, " connection attempts, server-side failure: erasing cached connection parameters"));
        this.reconnectParams = undefined;
    };
    ////////// SocketIO callbacks //////////
    TrouterConnection.prototype.onSocketConnecting = function (transportTypeName) {
        this.logger.info("onSocketConnecting(".concat(transportTypeName, ")"));
        this.transportTypeName = transportTypeName;
        this.connectionTracker.trackProgress('connecting', this.transportTypeName);
        this.fsm.onConnecting();
    };
    TrouterConnection.prototype.onSocketConnect = function (token) {
        this.logger.info('onSocketConnect');
        this.fsm.onSocketConnect(token);
    };
    TrouterConnection.prototype.onSocketConnectFailed = function (reason) {
        this.logger.error('onSocketConnectFailed');
        this.connectionTracker.trackError('connect_failed', reason, true, this.transportTypeName ? this.transportTypeName : this.UNKNOWN_TRANSPORT);
        this.fsm.onConnectingFailed();
    };
    TrouterConnection.prototype.onSocketDisconnect = function (rawReason) {
        var sessionLengthMs = this.connectionTracker.getSessionLength() || 0;
        var reason = DisconnectReason_1.DisconnectReason.fromRawReason(rawReason);
        this.logger.error("onSocketDisconnect, reason: ".concat(reason.reason));
        if (reason.reason === 'dup' && this.lastDisconnectReason === 'dup' &&
            sessionLengthMs < this.options.duplicateDisconnectThresholdMs) {
            this.logger.warn('Socket was closed by server as Duplicate for the second time in a row ' +
                "after ".concat(sessionLengthMs, " ms which is below the threshold of ") +
                "".concat(this.options.duplicateDisconnectThresholdMs, " ms. Resetting cached ") +
                'connection parameters and making a new allocation.');
            this.reconnectParams = undefined;
        }
        this.lastDisconnectReason = reason.reason;
        this.fsm.onSocketDisconnect(reason);
        this.connectionExpireTimestampInSecs = undefined;
    };
    TrouterConnection.prototype.onSocketReconnect = function () {
        // this callback should not be called, because reconnect on socket.io is disabled, but
        // leave it here in case error in socket.io
        this.logger.error('onSocketReconnect');
        this.fsm.onTrouterConnected();
    };
    TrouterConnection.prototype.onSocketReconnectFailed = function (reason) {
        // this callback should not be called, because reconnect on socket.io is disabled, but
        // leave it here in case error in socket.io
        this.logger.error("onSocketReconnectFailed with '".concat(reason, "'"));
        this.fsm.onSocketDisconnect(DisconnectReason_1.DisconnectReason.fromSocketIoEventData('reconnecterror', reason));
    };
    TrouterConnection.prototype.onSocketReconnecting = function () {
        // this callback should not be called, because reconnect on socket.io is disabled, but
        // leave it here in case error in socket.io
        this.logger.error('onSocketReconnecting');
    };
    TrouterConnection.prototype.onSocketError = function (errorObject) {
        this.logger.error("onSocketError with '".concat((0, Common_1.toJson)(errorObject), "'"));
        if (this.fsm.isConnecting()) {
            this.connectingErrorsInRow++;
            if (this.connectingErrorsInRow >= this.connectingErrorsThreshold) {
                this.resetReconnectParamsOnErrorThreshold();
            }
        }
        this.connectionTracker.trackError('connectSocket', safeToStringOrType(errorObject));
        this.fsm.onSocketDisconnect(DisconnectReason_1.DisconnectReason.fromSocketIoEventData('socketerror', errorObject));
    };
    TrouterConnection.prototype.onSocketMessage = function (requestJson) {
        var _this = this;
        var _a;
        this.logger.debug('onSocketMessage');
        var request;
        try {
            request = new TrouterRequest(requestJson, this.logger);
            var chainId = (_a = request.headers) === null || _a === void 0 ? void 0 : _a['X-Microsoft-Skype-Chain-ID'];
            var chainIdLogText = chainId ? " Chain-Id ".concat(chainId) : '';
            this.logger.info("Received request N ".concat(request.id).concat(chainIdLogText, " CV ").concat(request.correlationVector, " to '").concat(request.url, "'"));
            request.startTS = Date.now();
            if (request.url && this.urlPath && request.url.startsWith(this.urlPath)) {
                request.shortUrl = request.url.substring(this.urlPath.length);
            }
        }
        catch (error) {
            var msg = errorStackToJson(error);
            this.logger.error("unable to parse request. Error: ".concat(msg));
            this.connectionTracker.trackRequest(undefined, msg);
            this.connectionTracker.sendResponseError("unable to parse request, error: ".concat(error));
            return;
        }
        request.timeoutTimerId = setTimeout(function () {
            if (request.replied) {
                return;
            }
            _this.logger.error("Request ".concat(request.id, " timed out"));
            var responseData = new ConnectionTracker_1.ResponseData(request.id);
            responseData.status = 504;
            responseData.headers = { 'Trouter-Responder': 'ClientLib' };
            _this.sendResponse(request, responseData);
            request.timedout = true;
        }, this.timeoutOptions.requestTimeoutMs);
        try {
            this.connectionTracker.trackRequest(request);
            this.fsm.onDownstreamRequest(request);
        }
        catch (error) {
            this.logger.error("exception in socket.on message. Error: ".concat(errorStackToJson(error)));
            this.connectionTracker.sendResponseError(errorMessageToString(error), request, undefined);
        }
    };
    TrouterConnection.prototype.onTrouterConnected = function (eventArgs, userActivitySnapshot, audienceSubscriptionSnapshot) {
        var _this = this;
        var _a, _b, _c, _d;
        if ((0, ProtocolAdapters_1.isV4ConnectEvent)(eventArgs)) {
            var v4cArgs = eventArgs;
            this.allocateResult = __assign(__assign({}, v4cArgs), { ttl: eventArgs.ttl.toString() });
            this.populateAndCacheReconnectParams(v4cArgs, v4cArgs.reconnectUrl);
            this.populateConnectionStateFields(v4cArgs);
        }
        else if (!this.allocateResult) {
            this.logger.error('Invalid internal state - received onTrouterConnected while allocateResult is not set');
            return;
        }
        this.connectingErrorsInRow = 0;
        this.logger.info("onTrouterConnected: ".concat(this.allocateResult.url));
        if (this.transportTypeName === 'xhr-polling' && userActivitySnapshot) {
            this.manager.onUserActivityStateAccepted(userActivitySnapshot.cv);
        }
        // Prevent next 'trouter.connected' responses from other trouter nodes
        // hackish way, since socket.io doesn't have API for that
        if ((_c = (_b = (_a = this.socket) === null || _a === void 0 ? void 0 : _a.socket) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.query) {
            this.socket.socket.options.query += '&connected=true';
        }
        // Strip off the first part of the URL, up to the path
        // eslint-disable-next-line no-useless-escape
        this.urlPath = this.allocateResult.url.replace(/https?:\/\/([A-z0-9\:\$\-\_\.\+\!\*\"\(\)\,]*)\//, '/');
        var isNewUrl = (this.connectedUrl !== this.allocateResult.url);
        this.connectedUrl = this.allocateResult.url;
        this.connectionExpireTimestampInSecs = (0, Common_1.calculateExpireTsInSec)((0, ProtocolAdapters_1.ensureNumber)(eventArgs.ttl));
        this.connectionTracker.trackEnd('connectSocket');
        this.connectionTracker.trackConnected(isNewUrl, this.transportTypeName ? this.transportTypeName : this.UNKNOWN_TRANSPORT);
        (_d = this.setAudienceSubscriptionsUnsafeAsync(audienceSubscriptionSnapshot)) === null || _d === void 0 ? void 0 : _d.catch(function (reason) { return _this.logger.error("Re-subscribe to audiences has failed with ".concat(reason)); });
        this.fsm.onTrouterConnected();
    };
    TrouterConnection.prototype.onTrouterReconnect = function (eventArgs) {
        var target = eventArgs.target;
        this.logger.info("onTrouterReconnect target: ".concat(target));
        if (target === 'self') {
            this.fsm.onReconnectRequired(true, ReconnectReason.ServerInitiated);
        }
        else {
            this.fsm.onReconnectRequired(false, ReconnectReason.ServerInitiated, eventArgs);
        }
    };
    TrouterConnection.prototype.onTrouterMessageLoss = function (eventArgs) {
        this.logger.debug('onTrouterMessageLoss');
        // Send only array of tags for further processing
        this.fsm.onTrouterMessageLost(eventArgs.droppedIndicators);
    };
    TrouterConnection.prototype.onAudienceSubscriptionResult = function (eventArgs) {
        this.logger.info('onAudienceSubscriptionResult');
        if (!this.pendingAudienceSubscription) {
            return;
        }
        clearTimeout(this.pendingAudienceSubscription.timeoutId);
        this.pendingAudienceSubscription.audienceSetResolve(eventArgs);
        this.pendingAudienceSubscription = undefined;
    };
    ////////// Other functions //////////
    TrouterConnection.prototype.buildV4cUrlParams = function () {
        var urlParams = {};
        urlParams.tc = encodeURI((0, Common_1.toJson)(this.clientInfo));
        urlParams.timeout = Math.floor(this.timeoutOptions.pingTimeoutMs / 1000);
        if (this.options.endpointId) {
            urlParams.epid = this.options.endpointId;
        }
        return this.appendConnectedClientIds(this.buildQuery(urlParams), true);
    };
    TrouterConnection.prototype.attachSocketIoHandlers = function (socket, token, userActivitySnapshot, audienceSubscriptionSnapshot) {
        var _this = this;
        socket.on('connecting', function (transportTypeName) { _this.onSocketConnecting(transportTypeName); });
        socket.on('connect', function () { _this.onSocketConnect(token); });
        socket.on('connect_failed', function (reason) { _this.onSocketConnectFailed(reason); });
        socket.on('close_during_connecting', function (reason) { _this.onSocketConnectFailed(reason); });
        socket.on('disconnect', function (reason) { _this.onSocketDisconnect(reason); });
        socket.on('reconnect', function () { _this.onSocketReconnect(); });
        socket.on('reconnect_failed', function (reason) { _this.onSocketReconnectFailed(reason); });
        socket.on('reconnecting', function () { _this.onSocketReconnecting(); });
        socket.on('error', function (error) { _this.onSocketError(error); });
        socket.on('message', function (request) { _this.onSocketMessage(request); });
        socket.on('trouter.connected', function (eventArgs) { _this.onTrouterConnected(eventArgs, userActivitySnapshot, audienceSubscriptionSnapshot); });
        socket.on('trouter.reconnect', function (eventArgs) { _this.onTrouterReconnect(eventArgs); });
        socket.on('trouter.message_loss', function (eventArgs) { _this.onTrouterMessageLoss(eventArgs); });
        // event valid only for long polling
        // when user subscribes for audience events a query param `audienceSubscriptionState` is added to all long poll GETs 
        // if the audience subscription state differs from the one defined on server, it will adjust its state to be identical
        // after audience set opeartion finished server side `audience.subscriptionresult` is fired marking the end of asynchronous operation
        socket.on('audience.subscriptionresult', function (_, eventArgs) { _this.onAudienceSubscriptionResult(eventArgs); });
    };
    TrouterConnection.prototype.onNavigatorOnlineStatusUpdate = function () {
        var state = window.navigator.onLine;
        this.logger.debug("Browser online status update - new state: ".concat(state, ", previously: ").concat(this.isNavigatorOnline));
        if (state && !this.isNavigatorOnline) {
            this.isNavigatorOnline = true;
            this.tokenBackoff.expediteIfPending();
            this.connectionTracker.trackProgress('browserNet', 'online');
        }
        else if (!state && this.isNavigatorOnline) {
            this.isNavigatorOnline = false;
            this.connectionTracker.trackProgress('browserNet', 'offline');
        }
    };
    TrouterConnection.prototype.onAllocationResponse = function (allocateResult, token) {
        this.logger.info("Received allocation response ".concat(JSON.stringify(allocateResult)));
        this.allocateResult = allocateResult;
        this.populateAndCacheReconnectParams(this.allocateResult, "".concat(this.allocateResult.socketio, "v4/a"));
        this.populateConnectionStateFields(this.allocateResult);
        this.fsm.onAllocationSucceed(token);
    };
    TrouterConnection.prototype.populateAndCacheReconnectParams = function (args, reconnectUrl) {
        this.reconnectParams = __assign({ serviceUrl: this.options.trouterUrl, reconnectUrl: reconnectUrl }, args.connectparams);
        this.manager.onConnectionParametersUpdated(this.reconnectParams);
    };
    TrouterConnection.prototype.populateConnectionStateFields = function (args) {
        var _a, _b;
        var ttl = typeof args.ttl === 'string' ? parseInt(args.ttl, 10) : args.ttl;
        // Don't use allocateResult.connectparams.se here since system clock can be
        // incorrect on client's machine, so using TTL is safer
        this.connectionExpireTimestampInSecs = (0, Common_1.calculateExpireTsInSec)(ttl);
        this.connectionId = (_a = args.id) !== null && _a !== void 0 ? _a : '';
        this.connectedClientId = args.ccid;
        this.logger.debug("connected client id set {connectedClientId:".concat(this.connectedClientId, "}"));
        this.c2cUrlBase = (_b = args.curlb) !== null && _b !== void 0 ? _b : '';
        if (this.c2cUrlBase === '') {
            // Try to just remove the port as a fallback if the service didn't provide anything
            var pos = args.surl.indexOf('://');
            if (pos >= 0) {
                pos = args.surl.indexOf('/', pos + 3);
                if (pos >= 5 && args.surl.substr(pos - 5, 5) === ':3443') {
                    this.c2cUrlBase = args.surl.substr(0, pos - 5);
                }
            }
        }
    };
    TrouterConnection.prototype.onPingResponse = function () {
        this.logger.debug('onPingResponse');
        this.connectionTracker.increasePingResponseCount();
        this.clearPingResponseTimer();
        this.fsm.onPingResponse();
    };
    TrouterConnection.prototype.clearPingResponseTimer = function () {
        if (this.pingResponseTimerId !== undefined) {
            clearTimeout(this.pingResponseTimerId);
            this.pingResponseTimerId = undefined;
        }
    };
    TrouterConnection.prototype.buildQuery = function (map) {
        // TO-DO: Replace this and all other similar functions around with URLSearchParams
        var components = [];
        for (var _i = 0, _a = Object.keys(map); _i < _a.length; _i++) {
            var i = _a[_i];
            if (map[i] !== undefined) {
                components.push("".concat(i, "=").concat(map[i]));
            }
        }
        return components.join('&');
    };
    TrouterConnection.prototype.appendConnectedClientIds = function (url, isParamsOnly) {
        var params = '';
        if (!url.includes('ccid=')) {
            params = "ccid=".concat(this.connectedClientId, "&");
        }
        if (this.domId) {
            params += "dom=".concat(this.domId, "&");
        }
        if (params.length > 0) {
            params = params.slice(0, -1);
        }
        var sep = (isParamsOnly || url.includes('?')) ? ('&') : ('?');
        return this.appendCorrelationIds(url + sep + params, isParamsOnly);
    };
    TrouterConnection.prototype.appendEndpointId = function (url, isParamsOnly) {
        var sep = (isParamsOnly || url.includes('?')) ? ('&') : ('?');
        return (!url.includes('epid') && this.options.endpointId)
            ? "".concat(url).concat(sep, "epid=").concat(this.options.endpointId)
            : url;
    };
    TrouterConnection.prototype.appendCorrelationIds = function (url, isParamsOnly) {
        var sep = (isParamsOnly || url.includes('?')) ? ('&') : ('?');
        return (!url.includes('cor_id'))
            ? "".concat(url).concat(sep, "cor_id=").concat(this.options.clientCorrelationID)
                + "&con_num=".concat(this.clientID, "_").concat(this.connectionAttempt)
            : url;
    };
    TrouterConnection.prototype.safeString = function (str) {
        return (typeof str === 'string') ? str : '';
    };
    TrouterConnection.prototype.sendResponse = function (request, responseData) {
        var _a, _b, _c;
        if (request.timedout) {
            this.logger.error("Request ".concat(request.id, " already timed out"));
            return 1 /* SendResponseResult.Timeout */;
        }
        if (request.replied) {
            this.logger.error("Response for request ".concat(request.id, " already sent"));
            return 2 /* SendResponseResult.Duplicate */;
        }
        clearTimeout(request.timeoutTimerId);
        request.timeoutTimerId = undefined;
        request.replied = true;
        responseData.headers = (_a = responseData.headers) !== null && _a !== void 0 ? _a : {};
        var cv = request.correlationVector;
        this.logger.info("Sending response N ".concat(request.id, " CV ").concat(cv, " with status ").concat(responseData.status));
        if (cv) {
            responseData.headers[cvHeader] = cv;
        }
        // Echo back the incoming "trouter-request" header
        if ((_b = request.headers) === null || _b === void 0 ? void 0 : _b['trouter-request']) {
            responseData.headers['trouter-request'] = request.headers['trouter-request'];
        }
        // Fill in "trouter-client" header
        var latencyMS = Date.now() - request.startTS;
        responseData.headers['trouter-client'] = (0, Common_1.toJson)({
            cd: latencyMS
        });
        // Echo back "trouter-is-broadcast" header
        if ((_c = request.headers) === null || _c === void 0 ? void 0 : _c['trouter-is-broadcast']) {
            responseData.headers['trouter-is-broadcast'] = request.headers['trouter-is-broadcast'];
        }
        this.logger.debug("response: ".concat((0, Common_1.toJson)(responseData)));
        if (this.socket) {
            try {
                this.socket.send((0, Common_1.toJson)(responseData));
                responseData.sentTS = Date.now();
                request.incrementCorrelationVector();
                this.connectionTracker.trackResponse(request, latencyMS, responseData);
                if (this.transportTypeName === 'websocket') {
                    // Send ping request immediately to emulate 'ack' from server, so
                    // client can faster react on network issues
                    this.sendPingRequest();
                }
                return 0 /* SendResponseResult.OK */;
            }
            catch (error) {
                var errorMsg = "unable to send data on response.end. Error: ".concat(errorStackToJson(error));
                this.logger.error(errorMsg);
                this.connectionTracker.sendResponseError(errorMsg, request, responseData);
                return 4 /* SendResponseResult.Disconnected */;
            }
        }
        else {
            this.connectionTracker.sendResponseError('no socket', request, responseData);
            return 4 /* SendResponseResult.Disconnected */;
        }
    };
    /*
        Sends the activity state event to Trouter.
        Has implemented support for sending the current state twice (or multiple times)
        after reconnect, first immediately, and theen the second after configured delay.

        If after the first sent state event the client app changes the state,
        the new state is sent in the second event after the delay.
        Meanwhile the new state is also sent immediately upon
        the change, but the planned second sending (after delay) is triggered anyway,
        to fulfill it's purpose, which is to prevent server-side race condition.
     */
    TrouterConnection.prototype.sendUserActivityStateMultiple = function (remaining) {
        var _this = this;
        var activityEvent = new DownstreamEvent('user.activity');
        var activityEventObject = this.userActivityState.increaseCvAndGetEventObject();
        activityEvent.args = activityEventObject;
        this.logger.debug("Sending user activity '".concat(this.userActivityState.toEventJSON(), "', remaining ").concat(remaining - 1));
        var timeoutReached = false;
        this.sendDownstreamEvent(activityEvent, function () {
            if (timeoutReached === true) {
                return;
            }
            _this.logger.info("User activity state: ".concat(activityEventObject.state, ", cv: ").concat(activityEventObject.cv, " accepted"));
            _this.manager.onUserActivityStateAccepted(activityEventObject.cv);
            _this.clearSentEventTimer(activityEvent.timeoutTimerId);
            if (remaining > 1) {
                var timerId_1 = setTimeout(function () {
                    _this.clearSentEventTimer(timerId_1);
                    _this.sendUserActivityStateMultiple(remaining - 1);
                }, _this.options.userActivitySecondResendDelayMs);
                _this.registerSentEventTimer(timerId_1, 'user.activity/resend');
            }
        });
        activityEvent.timeoutTimerId = setTimeout(function () {
            _this.logger.error('Activity state response timeout is fired');
            timeoutReached = true;
            _this.fsm.onActivityStateResponseTimeout();
            _this.clearSentEventTimer(activityEvent.timeoutTimerId);
        }, this.timeoutOptions.userActivityResponseTimeoutMs);
        this.registerSentEventTimer(activityEvent.timeoutTimerId, 'user.activity/response');
    };
    TrouterConnection.prototype.sendDownstreamEvent = function (event, responseCallback) {
        this.logger.debug("Sending downstream event ".concat(event.name));
        if (this.socket) {
            this.socket.emit(event.name, event.args, responseCallback);
        }
    };
    TrouterConnection.prototype.registerSentEventTimer = function (timerId, timerDescription) {
        this.logger.debug("registering timer ".concat(timerId, " -> ").concat(timerDescription));
        this.pendingSentEventTimers[timerId] = timerDescription;
    };
    TrouterConnection.prototype.clearSentEventTimer = function (id) {
        var timerDescription = this.pendingSentEventTimers[id];
        this.logger.debug("clearing timer ".concat(id, " -> ").concat(timerDescription));
        delete this.pendingSentEventTimers[id];
        clearTimeout(id);
    };
    /**
     * Calculate registration interval. Result is based on configuration parameters
     * and allocation ttl value from trouter server.
     * Returns true only if the registration ttl is present and is smaller than known `allocationTtl`.
     * This means we'll need to re-register to keep the registration alive for the duration of the allocation.
     */
    TrouterConnection.prototype.getRegistrationTtl = function () {
        var _a, _b;
        var allocationTtl = (0, Common_1.calculateTtlInSec)(this.connectionExpireTimestampInSecs);
        this.logger.debug("Current connectionID will expire in ".concat(allocationTtl, " seconds"));
        if (((_a = this.options.registration) === null || _a === void 0 ? void 0 : _a.registrarTtlSec) && allocationTtl > 0) {
            var isLower = this.options.registration.registrarTtlSec < allocationTtl;
            return [Math.min(this.options.registration.registrarTtlSec, allocationTtl), isLower];
        }
        else if ((_b = this.options.registration) === null || _b === void 0 ? void 0 : _b.registrarTtlSec) {
            return [this.options.registration.registrarTtlSec, false];
        }
        else if (allocationTtl > 0) {
            return [allocationTtl, false];
        }
        return [DEFAULT_REGISTRATION_TIMEOUT_SEC, false];
    };
    TrouterConnection.prototype.clearIncallModeTimerId = function () {
        if (this.incallModeTimerId !== undefined) {
            this.logger.debug('Clearing in-call mode timer');
            clearTimeout(this.incallModeTimerId);
            this.incallModeTimerId = undefined;
        }
    };
    TrouterConnection.prototype.applyConnectionTrackerOptions = function (options) {
        try {
            var eventLoggerSent = (options.eventLogger && typeof options.eventLogger.logEvent === 'function');
            if (!eventLoggerSent) {
                this.logger.warn('Trouter client event logging disabled due to invalid configuration.');
            }
            else {
                this.connectionTracker.mergeSettings(options.telemetrySettings);
                this.connectionTracker.enable(options.eventLogger);
            }
        }
        catch (error) {
            this.logger.warn("Trouter client event logging disabled. Error: ".concat(errorStackToJson(error)));
            this.connectionTracker.disable();
        }
    };
    /**
     * Returns boolean indicating if we can retry token fetch
     * based on value of optional configuration 'retryLimitOnTokenFetch'
     * @returns boolean
     */
    TrouterConnection.prototype.canRetryTokenFetchRequest = function (currentCounter) {
        var retryLimit = this.options.retryLimitOnTokenFetch;
        if (retryLimit === null || retryLimit === undefined) {
            return true;
        }
        if (currentCounter < retryLimit) {
            return true;
        }
        this.logger.warn("Reached limit on maximum number of token fetch request. Current count: ".concat(currentCounter, ", retry limit: ").concat(retryLimit));
        return false;
    };
    return TrouterConnection;
}());
exports.TrouterConnection = TrouterConnection;
function headersFromToken(token, usingLegacyTokenApi) {
    var migrationHeader = usingLegacyTokenApi ? undefined : { 'X-MS-Migration': 'True' };
    switch (token.tokenType.toLowerCase()) {
        case 'skype':
            return __assign({ 'X-Skypetoken': token.token }, migrationHeader);
        case 'aad':
        case 'cae':
            return __assign({ Authorization: "Bearer ".concat(token.token) }, migrationHeader);
        default:
            throw new Error("unsupported token type: ".concat(token.tokenType));
    }
}
function safeToStringOrType(value) {
    if (value !== undefined && value !== null && typeof value.toString === 'function') {
        return value.toString();
    }
    return "[".concat(typeof value, "]");
}
function errorStackToJson(error) {
    if (typeof error === 'object' && error !== null && error.stack !== undefined) {
        // Keeping this as it was for now, but `error.stack` is usually just a string anyway.
        // I guess it also converts newlines to '\n', which some part may need? Or it's completely unnecessary?
        return (0, Common_1.toJson)(error.stack);
    }
    return '"(no error.stack)"';
}
function errorMessageToString(error) {
    if (typeof error === 'object' && error !== null && typeof error.message === 'string') {
        return error.message;
    }
    return '(no error.message)';
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageHandlerRegistry = void 0;
var Constants_1 = __webpack_require__(1);
var Logger_1 = __webpack_require__(0);
/**
 * Registry of message handlers.
 * Safely executes individual handlers and aggregates results
 */
var MessageHandlerRegistry = /** @class */ (function () {
    function MessageHandlerRegistry(logProvider) {
        this.messageHandlers = [];
        this.logger = new Logger_1.Logger("MessageHandlers", logProvider);
    }
    MessageHandlerRegistry.prototype.register = function (handler) {
        if (this.messageHandlers.some(function (item) { return item === handler; })) {
            throw new Error('Registering the same handler twice is not allowed');
        }
        this.messageHandlers.push(handler);
    };
    MessageHandlerRegistry.prototype.clear = function () {
        this.logger.debug('Clearing message handlers');
        this.messageHandlers = [];
    };
    MessageHandlerRegistry.prototype.active = function () {
        return (this.messageHandlers.length > 0);
    };
    MessageHandlerRegistry.prototype.handleMessage = function (message) {
        var unhandledMessageResult = {
            resultCode: Constants_1.UNHANDLED_MESSAGE_ACK,
            isHandled: false
        };
        for (var _i = 0, _a = this.messageHandlers; _i < _a.length; _i++) {
            var messageHandler = _a[_i];
            var result = this.safeExecuteHandle(messageHandler, message);
            if (result !== undefined && (result.isHandled === undefined || result.isHandled)) {
                if (result.resultCode === undefined) {
                    result.resultCode = Constants_1.HANDLED_MESSAGE_ACK;
                }
                return result;
            }
        }
        return unhandledMessageResult;
    };
    MessageHandlerRegistry.prototype.safeExecuteHandle = function (handler, message) {
        try {
            return handler.handleMessage(message);
        }
        catch (exception) {
            this.logger.warn("Trouter message handler threw an exception: ".concat(exception));
            return undefined;
        }
    };
    return MessageHandlerRegistry;
}());
exports.MessageHandlerRegistry = MessageHandlerRegistry;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addCacheAsBackupTo = void 0;
function addCacheAsBackupTo(provider) {
    var _this = this;
    var cachedToken;
    return function (forceRefresh) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (forceRefresh) {
                cachedToken = undefined;
            }
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    provider(forceRefresh).then(function (token) {
                        cachedToken = token;
                        resolve(token);
                    }).catch(function (error) {
                        if (cachedToken !== undefined && cachedToken.length > 0) {
                            resolve(cachedToken);
                        }
                        reject(error);
                    });
                })];
        });
    }); };
}
exports.addCacheAsBackupTo = addCacheAsBackupTo;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrouterManager = exports.AudienceSubscriptionState = exports.UserActivityObject = void 0;
var Common_1 = __webpack_require__(3);
var Interfaces_1 = __webpack_require__(2);
var InternalInterfaces_1 = __webpack_require__(4);
var Logger_1 = __webpack_require__(0);
var ProtocolAdapters_1 = __webpack_require__(5);
var RegistrationEnforcer_1 = __webpack_require__(18);
var TrouterConnection_1 = __webpack_require__(7);
var TrouterFsm_1 = __webpack_require__(6);
var TrouterManagerFsm_1 = __webpack_require__(19);
/**
 * UserActivity object
 */
var UserActivityObject = /** @class */ (function () {
    function UserActivityObject(state, correlationVector) {
        this.state = state;
        this.correlationVector = correlationVector !== undefined ? correlationVector : Common_1.CorrelationVector.extend();
    }
    UserActivityObject.prototype.getStateString = function () {
        switch (this.state) {
            case Interfaces_1.UserActivityState.Active:
                return 'active';
            case Interfaces_1.UserActivityState.Inactive:
                return 'inactive';
            case Interfaces_1.UserActivityState.Unknown:
                return 'unknown';
            default:
                return 'undefined';
        }
    };
    UserActivityObject.prototype.increaseCvAndGetEventObject = function () {
        this.correlationVector.increase();
        return this.toEventObject();
    };
    UserActivityObject.prototype.toEventObject = function () {
        return { state: this.getStateString(), cv: this.correlationVector.value() };
    };
    UserActivityObject.prototype.toEventJSON = function () {
        return (0, Common_1.toJson)(this.toEventObject());
    };
    return UserActivityObject;
}());
exports.UserActivityObject = UserActivityObject;
var AudienceSubscriptionState = /** @class */ (function () {
    function AudienceSubscriptionState(audienceSubscriptionModel, correlationVector) {
        if (correlationVector === void 0) { correlationVector = Common_1.CorrelationVector.extend(); }
        this.audienceSubscriptionModel = audienceSubscriptionModel;
        this.correlationVector = correlationVector;
    }
    AudienceSubscriptionState.prototype.increaseCvAndGetEventObject = function () {
        this.correlationVector.increase();
        return this.toEventObject();
    };
    AudienceSubscriptionState.prototype.toEventObject = function () {
        return { audiences: this.audienceSubscriptionModel.audienceSubscriptions, cv: this.correlationVector.value() };
    };
    AudienceSubscriptionState.prototype.toEventJSON = function () {
        return (0, Common_1.toJson)(this.toEventObject());
    };
    return AudienceSubscriptionState;
}());
exports.AudienceSubscriptionState = AudienceSubscriptionState;
/**
 * Trouter implementation
 */
var TrouterManager = /** @class */ (function () {
    function TrouterManager(logFunc, options, tokenProvider, usingLegacyTokenApi, listener, protocolSelector) {
        var _this = this;
        this.logFunc = logFunc;
        this.options = options;
        this.tokenProvider = tokenProvider;
        this.usingLegacyTokenApi = usingLegacyTokenApi;
        this.listener = listener;
        this.tokenTypeProtocolSelector = function (tokenType, reconnectParams) {
            return _this.options.forceV4aProtocol ? 'v4a' : (0, ProtocolAdapters_1.usedProtocol)(tokenType, reconnectParams);
        };
        this.logger = new Logger_1.Logger('Manager', logFunc);
        this.logger.info("Created TrouterManager with options ".concat((0, Common_1.toJson)(this.options)));
        this.fsm = new TrouterManagerFsm_1.TrouterManagerFsm(logFunc, this);
        this.baseEndpointUrl = '';
        this.processedMessageLoss = {};
        this.userActivityObject = new UserActivityObject(Interfaces_1.UserActivityState.Unknown);
        this.protocolSelector = protocolSelector !== null && protocolSelector !== void 0 ? protocolSelector : this.tokenTypeProtocolSelector.bind(this);
    }
    TrouterManager.prototype.start = function () {
        this.fsm.start();
    };
    TrouterManager.prototype.stop = function (dontUnregister) {
        this.fsm.stop(dontUnregister);
    };
    TrouterManager.prototype.configure = function (options) {
        this.options = options;
        if (this.firstConnection !== undefined) {
            this.firstConnection.configure(options);
        }
        if (this.secondConnection !== undefined) {
            this.secondConnection.configure(options);
        }
        this.logger.info("Reconfigured TrouterManager with options ".concat((0, Common_1.toJson)(this.options)));
    };
    TrouterManager.prototype.checkConnection = function (disconnectDetected) {
        if (this.firstConnection !== undefined) {
            this.firstConnection.checkConnection(disconnectDetected);
        }
        if (this.secondConnection !== undefined) {
            this.secondConnection.checkConnection(disconnectDetected);
        }
    };
    TrouterManager.prototype.resendRegistration = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.secondConnection !== undefined) {
                    this.logger.info('Resending registration on the second/new connection');
                    return [2 /*return*/, this.secondConnection.resendRegistration()];
                }
                if (this.firstConnection !== undefined) {
                    this.logger.info('Resending registration on the first/current connection');
                    return [2 /*return*/, this.firstConnection.resendRegistration()];
                }
                this.logger.info('No connection to resend registration on, will be done upon (re)connect');
                return [2 /*return*/];
            });
        });
    };
    TrouterManager.prototype.getServerState = function () {
        if (this.firstConnection !== undefined) {
            return this.firstConnection.getServerState();
        }
        return undefined;
    };
    /** Returns current state */
    TrouterManager.prototype.getState = function () {
        return this.fsm.getState();
    };
    TrouterManager.prototype.isInTerminalState = function () {
        return this.fsm.getInternalState() === InternalInterfaces_1.TrouterManagerState.TerminalError;
    };
    TrouterManager.prototype.reportStateInfo = function () {
        var firstState = this.firstConnection ? TrouterFsm_1.State[this.firstConnection.getState()] : "Unknown";
        var managerState = InternalInterfaces_1.TrouterManagerState[this.fsm.getInternalState()];
        if (this.secondConnection) {
            var secondState = TrouterFsm_1.State[this.secondConnection.getState()];
            return "Manager ".concat(managerState, "; 1st ").concat(firstState, "; 2nd ").concat(secondState);
        }
        return "Manager ".concat(managerState, "; Connection ").concat(firstState);
    };
    //////////// IManagerWorker ////////////
    TrouterManager.prototype.startFirstConnection = function () {
        var connection = new TrouterConnection_1.TrouterConnection(this.logFunc, this.options, this.configuredTrouterManager(), this.tokenProvider, this.usingLegacyTokenApi, this.userActivityObject, this.protocolSelector, this.audienceSubscriptionState);
        this.firstConnection = connection;
        this.getConnectionCache()
            .then(function (connectionCache) {
            connection.start(connectionCache);
        })
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            .catch(function () { });
    };
    TrouterManager.prototype.startSecondConnection = function (useConnectParamsFromCache) {
        var connection = new TrouterConnection_1.TrouterConnection(this.logFunc, this.options, this.configuredTrouterManager(), this.tokenProvider, this.usingLegacyTokenApi, this.userActivityObject, this.protocolSelector, this.audienceSubscriptionState);
        this.secondConnection = connection;
        if (this.firstConnection !== undefined) {
            this.firstConnection.disableRegistrationsAndAutoReconnect();
        }
        if (useConnectParamsFromCache) {
            this.getConnectionCache()
                .then(function (connectionCache) {
                connection.start(connectionCache);
            })
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                .catch(function () { });
        }
        else {
            connection.start();
        }
    };
    TrouterManager.prototype.stopFirstConnection = function (dontUnregister) {
        if (this.firstConnection !== undefined) {
            // Store first connection to be able to compare in onDisconnected() handler
            this.storedFirstConnection = this.firstConnection;
            this.firstConnection.stop(dontUnregister);
            this.firstConnection = undefined;
        }
    };
    TrouterManager.prototype.stopSecondConnection = function (dontUnregister) {
        if (this.secondConnection !== undefined) {
            this.secondConnection.stop(dontUnregister);
            this.secondConnection = undefined;
        }
    };
    TrouterManager.prototype.stopSecondConnectionDelayed = function () {
        if (this.secondConnection !== undefined) {
            var connection_1 = this.secondConnection;
            this.secondConnection = undefined;
            this.logger.info("Closing an inactive connection in ".concat(Math.round(this.options.lingeringConnectionDelayMs / 1000), "s"));
            setTimeout(function () {
                connection_1.stop(true);
            }, this.options.lingeringConnectionDelayMs);
        }
    };
    TrouterManager.prototype.forceStopLingeringConnection = function () {
        if (this.storedFirstConnection) {
            this.storedFirstConnection.stop(false);
            this.storedFirstConnection = undefined;
        }
    };
    TrouterManager.prototype.switchConnections = function () {
        var tmp = this.firstConnection;
        this.firstConnection = this.secondConnection;
        this.secondConnection = tmp;
    };
    TrouterManager.prototype.doesSecondConnectionExist = function () {
        return this.secondConnection !== undefined;
    };
    TrouterManager.prototype.dispatchConnected = function () {
        if (this.firstConnection !== undefined) {
            var ss = this.firstConnection.getServerState();
            var baseEndpointUrl = (ss.url.endsWith('/')) ? ss.url.slice(0, -1) : ss.url;
            var connectionInfo = {
                baseEndpointUrl: baseEndpointUrl,
                newEndpointUrl: (baseEndpointUrl !== this.baseEndpointUrl),
                c2cUrlBase: ss.c2cUrlBase,
                clientId: ss.connectedClientId,
                connectionId: ss.connectionId,
                connectionTtlSec: ss.getRemainingTtlInSec()
            };
            this.baseEndpointUrl = baseEndpointUrl;
            this.listener.onTrouterConnected(ss.url, connectionInfo);
        }
    };
    TrouterManager.prototype.dispatchDisconnected = function () {
        if (this.listener.onTrouterDisconnected) {
            this.listener.onTrouterDisconnected();
        }
    };
    TrouterManager.prototype.dispatchTerminalError = function () {
        // Emit a disconnected event to listeners too.
        if (this.listener.onTrouterDisconnected) {
            this.listener.onTrouterDisconnected();
        }
    };
    TrouterManager.prototype.dispatchRegistrationState = function (isRegistered) {
        if (this.options.registrationStateCallback) {
            this.options.registrationStateCallback(isRegistered);
        }
    };
    TrouterManager.prototype.expediteBackoffOnConnections = function () {
        var _a;
        if (this.lastExpediteBackoffCallAt !== undefined && Date.now() - this.lastExpediteBackoffCallAt < ((_a = this.options.expediteBackoffOnStartMinimumDelayMs) !== null && _a !== void 0 ? _a : 10000)) {
            this.logger.info('Expedite backoff due to start() too frequent, skipping');
            return;
        }
        this.lastExpediteBackoffCallAt = Date.now();
        if (this.firstConnection !== undefined) {
            this.firstConnection.expediteBackoff();
        }
        if (this.secondConnection !== undefined) {
            this.secondConnection.expediteBackoff();
        }
    };
    //////////// IManagerConsumer ////////////
    TrouterManager.prototype.onDownstreamRequest = function (connection, request, response) {
        var req = {
            id: request.id,
            method: request.method,
            path: "/".concat(request.shortUrl),
            body: request.body,
            headers: request.headers
        };
        var rsp = {
            id: request.id,
            status: 0,
            headers: {},
            body: '',
            send: function () {
                if (rsp.status <= 100 || rsp.status >= 999) {
                    return 3 /* SendResponseResult.Incomplete */;
                }
                response.writeHead(rsp.status, rsp.headers);
                return response.end(rsp.body);
            }
        };
        this.listener.onTrouterRequest(req, rsp);
    };
    TrouterManager.prototype.onConnected = function (connection) {
        this.fsm.onConnected(connection === this.firstConnection);
    };
    TrouterManager.prototype.onRegistered = function (connection) {
        this.fsm.onRegistered(connection === this.firstConnection);
    };
    TrouterManager.prototype.onUnregistered = function (connection) {
        this.fsm.onUnregistered(connection === this.firstConnection || connection === this.storedFirstConnection);
    };
    TrouterManager.prototype.onReconnecting = function (connection) {
        this.fsm.onReconnecting(connection === this.firstConnection);
    };
    TrouterManager.prototype.onReconnectIsRequired = function (connection, useConnectParamsFromCache, reason) {
        this.fsm.onReconnectionRequired(connection === this.firstConnection, useConnectParamsFromCache, reason);
    };
    TrouterManager.prototype.onDisconnected = function (connection) {
        this.fsm.onDisconnected(connection === this.firstConnection || connection == this.storedFirstConnection);
        this.storedFirstConnection = undefined;
    };
    TrouterManager.prototype.onTerminalError = function () {
        // TODO: the argument passed to onTerminalError is just ignored
        // this.fsm.onTerminalError(connection === this.firstConnection || connection == this.storedFirstConnection);
        this.fsm.onTerminalError();
        this.storedFirstConnection = undefined;
    };
    TrouterManager.prototype.onUserActivityStateAccepted = function (cv) {
        if (this.listener.onTrouterUserActivityStateAccepted) {
            this.listener.onTrouterUserActivityStateAccepted(cv);
        }
    };
    TrouterManager.prototype.onAudiencesSetResolved = function (audienceSubscriptionsResponse, cv) {
        var _a, _b;
        (_b = (_a = this.listener).onAudiencesSetResolved) === null || _b === void 0 ? void 0 : _b.call(_a, audienceSubscriptionsResponse, cv);
    };
    TrouterManager.prototype.onConnectionParametersUpdated = function (connectionParameters) {
        this.setConnectionCache(connectionParameters);
    };
    TrouterManager.prototype.setUserActivityState = function (state, correlationVector) {
        this.userActivityObject = new UserActivityObject(state, Common_1.CorrelationVector.extend(correlationVector));
        if (this.secondConnection !== undefined) {
            this.logger.info("Setting user activity ".concat(this.userActivityObject.toEventJSON(), " on the second/new connection"));
            this.secondConnection.setUserActivityState(this.userActivityObject);
            return;
        }
        if (this.firstConnection !== undefined) {
            this.logger.info("Setting user activity ".concat(this.userActivityObject.toEventJSON(), " on the first/current connection"));
            this.firstConnection.setUserActivityState(this.userActivityObject);
            return;
        }
    };
    TrouterManager.prototype.setAudienceSubscriptionsAsync = function (audienceSubscriptionModel, timeoutInMs, correlationVector) {
        this.audienceSubscriptionState = new AudienceSubscriptionState(audienceSubscriptionModel, Common_1.CorrelationVector.extend(correlationVector));
        if (this.secondConnection) {
            this.logger.info("Setting audience subscriptions ".concat(this.audienceSubscriptionState.toEventJSON(), " on second/new connection"));
            return this.secondConnection.setAudienceSubscriptionsAsync(this.audienceSubscriptionState, timeoutInMs);
        }
        if (this.firstConnection) {
            this.logger.info("Setting audience subscriptions ".concat(this.audienceSubscriptionState.toEventJSON(), " on first/current connection"));
            return this.firstConnection.setAudienceSubscriptionsAsync(this.audienceSubscriptionState, timeoutInMs);
        }
        throw new Error('No connection found');
    };
    TrouterManager.prototype.onTrouterMessageLost = function (indicators) {
        var _this = this;
        if (this.listener.onTrouterMessageLoss) {
            if (indicators === null || indicators === void 0 ? void 0 : indicators.length) {
                // Filter out already seen dropped indicators and inform server that they are processed
                var duplicates = indicators.filter(function (di) { return _this.processedMessageLoss["".concat(di.tag, "-").concat(di.etag)] !== undefined; });
                if (duplicates.length) {
                    this.logger.info("onTrouterMessageLoss - immediately acknowledging ".concat(duplicates.length, " seen dropped indicators"));
                    this.sendProcessedDroppedIndicators(duplicates);
                    indicators = indicators.filter(function (di) { return _this.processedMessageLoss["".concat(di.tag, "-").concat(di.etag)] === undefined; });
                    if (!indicators.length) {
                        this.logger.info('onTrouterMessageLoss - all declared dropped indicators have been seen before');
                        return;
                    }
                }
                // Send the data to the listeners
                var messageLossProcessed = this.listener.onTrouterMessageLoss(indicators.map(function (di) { return di.tag; }));
                if (!messageLossProcessed) {
                    this.logger.warn('onTrouterMessageLoss - some flow tag(s) have not been processed by listeners');
                    return;
                }
                // Update the cache
                indicators.forEach(function (di) {
                    _this.processedMessageLoss["".concat(di.tag, "-").concat(di.etag)] = '';
                });
                this.sendProcessedDroppedIndicators(indicators);
            }
            else {
                this.logger.warn('onTrouterMessageLoss - no flow tags have been provided');
            }
        }
    };
    TrouterManager.prototype.getConnectionCache = function () {
        var _this = this;
        if (!this.options.connectionCache) {
            return Promise.resolve(this.connectionCache);
        }
        this.logger.debug('Querying host\'s connection cache');
        return this.options.connectionCache.onGetTrouterConnectionCache()
            .then(function (serialized) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            var parsed = serialized ? JSON.parse(serialized) : undefined;
            return typeof parsed === 'object' ? parsed : undefined;
        })
            .catch(function (e) {
            _this.logger.warn("Invalid connection cache content provided: ".concat(e));
            return _this.connectionCache;
        });
    };
    TrouterManager.prototype.setConnectionCache = function (content) {
        this.connectionCache = content;
        if (this.options.connectionCache) {
            try {
                this.options.connectionCache.onSetTrouterConnectionCache(JSON.stringify(content));
            }
            catch (e) {
                this.logger.warn("Error setting external connection cache: ".concat(e));
            }
        }
    };
    TrouterManager.prototype.sendProcessedDroppedIndicators = function (messageLossIndicators) {
        if (this.firstConnection !== undefined) {
            this.firstConnection.sendProcessedDroppedIndicators(messageLossIndicators);
            return;
        }
        if (this.secondConnection !== undefined) {
            this.secondConnection.sendProcessedDroppedIndicators(messageLossIndicators);
            return;
        }
    };
    TrouterManager.prototype.configuredTrouterManager = function () {
        return new RegistrationEnforcer_1.RegistrationEnforcer(this, this.options.connectionDependsOnRegistration, this.options.delayEventsUntilRegistered);
    };
    return TrouterManager;
}());
exports.TrouterManager = TrouterManager;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrouterUrlPromise = void 0;
var Logger_1 = __webpack_require__(0);
/**
 * Util that encapsulates lifecycle of active trouter URL and manages waiter for the URL via promise
 */
var TrouterUrlPromise = /** @class */ (function () {
    function TrouterUrlPromise(logProvider) {
        this.logger = new Logger_1.Logger('UrlPromise', logProvider);
    }
    TrouterUrlPromise.prototype.getPromise = function () {
        var _this = this;
        if (this.url !== undefined) {
            this.logger.debug("returning previously resolved url: ".concat(this.url));
            return Promise.resolve(this.url);
        }
        if (this.pendingPromise === undefined) {
            this.logger.debug('creating and returning promise');
            this.pendingPromise = new Promise(function (resolve, reject) {
                _this.pendingPromiseResolveRef = resolve;
                _this.pendingPromiseRejectRef = reject;
            });
        }
        else {
            this.logger.debug('returning existing promise');
        }
        return this.pendingPromise;
    };
    TrouterUrlPromise.prototype.resolveUrl = function (url) {
        this.url = url;
        this.logger.debug("got url: ".concat(this.url));
        var resolveCallback = this.pendingPromiseResolveRef;
        this.pendingPromise = undefined;
        this.pendingPromiseResolveRef = undefined;
        this.pendingPromiseRejectRef = undefined;
        if (resolveCallback !== undefined) {
            this.logger.debug('resolving promise');
            resolveCallback(url);
        }
    };
    TrouterUrlPromise.prototype.rejectUrl = function (error) {
        this.logger.debug('aborting');
        var rejectCallback = this.pendingPromiseRejectRef;
        this.url = undefined;
        this.pendingPromise = undefined;
        this.pendingPromiseResolveRef = undefined;
        this.pendingPromiseRejectRef = undefined;
        if (rejectCallback !== undefined) {
            this.logger.debug('rejecting promise');
            rejectCallback(error);
        }
    };
    TrouterUrlPromise.prototype.resetUrl = function () {
        this.logger.debug('resetting url');
        this.url = undefined;
    };
    return TrouterUrlPromise;
}());
exports.TrouterUrlPromise = TrouterUrlPromise;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/** Socket.IO.js build:0.9.6, development. Copyright(c) 2011 LearnBoost <dev@learnboost.com> MIT Licensed */

/**
 * socket.io
 * Copyright(c) 2011 LearnBoost <dev@learnboost.com>
 * MIT Licensed
 */

(function (exports, global) {

  /**
   * IO namespace.
   *
   * @namespace
   */

  var io = exports;

  /**
   * Socket.IO version
   *
   * @api public
   */

  io.version = '0.9.6';

  /**
   * Protocol implemented.
   *
   * @api public
   */

  io.protocol = 1;

  /**
   * Available transports, these will be populated with the available transports
   *
   * @api public
   */

  io.transports = [];

  /**
   * Keep track of jsonp callbacks.
   *
   * @api private
   */

  io.j = [];

  /**
   * Keep track of our io.Sockets
   *
   * @api private
   */
  io.sockets = {};


  /**
   * Manages connections to hosts.
   *
   * @param {String} uri
   * @Param {Boolean} force creation of new socket (defaults to false)
   * @api public
   */

  io.connect = function (host, details) {
    var uri = io.util.parseUri(host)
      , uuri
      , socket;

    if (global && global.location) {
      uri.protocol = uri.protocol || global.location.protocol.slice(0, -1);
      uri.host = uri.host || (global.document
        ? global.document.domain : global.location.hostname);
      uri.port = uri.port || global.location.port;
    }

    uuri = io.util.uniqueUri(uri);

    var options = {
        host: uri.host
      , secure: 'https' == uri.protocol
      , port: uri.port || ('https' == uri.protocol ? 443 : 80)
      , query: uri.query || ''
    };

    io.util.merge(options, details);

    if (options['force new connection'] || !io.sockets[uuri]) {
      socket = new io.Socket(options);
    }

    if (!options['force new connection'] && socket) {
      io.sockets[uuri] = socket;
    }

    socket = socket || io.sockets[uuri];

    // Making /v4/c have empty namespace
    if (options['skipped handshake data']) {
      return socket.of('');
    } else {
      // if path is different from '' or /
      return socket.of(uri.path.length > 1 ? uri.path : '');
    }
  };

})(
     true ? module.exports : (this.io = {})
  , 'undefined' === typeof global ? window : global);

// Workaround inside webpack
var io = module.exports;

/**
 * socket.io
 * Copyright(c) 2011 LearnBoost <dev@learnboost.com>
 * MIT Licensed
 */

(function (exports, global) {

  /**
   * Utilities namespace.
   *
   * @namespace
   */

  var util = exports.util = {};

  /**
   * Parses an URI
   *
   * @author Steven Levithan <stevenlevithan.com> (MIT license)
   * @api public
   */

  var re = /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;

  var parts = ['source', 'protocol', 'authority', 'userInfo', 'user', 'password',
               'host', 'port', 'relative', 'path', 'directory', 'file', 'query',
               'anchor'];

  util.parseUri = function (str) {
    var m = re.exec(str || '')
      , uri = {}
      , i = 14;

    while (i--) {
      uri[parts[i]] = m[i] || '';
    }

    return uri;
  };

  /**
   * Produces a unique url that identifies a Socket.IO connection.
   *
   * @param {Object} uri
   * @api public
   */

  util.uniqueUri = function (uri) {
    var protocol = uri.protocol
      , host = uri.host
      , port = uri.port;

    if ('document' in global) {
      host = host || document.domain;
      port = port || (protocol == 'https'
        && document.location.protocol !== 'https:' ? 443 : document.location.port);
    } else {
      host = host || 'localhost';

      if (!port && protocol == 'https') {
        port = 443;
      }
    }

    return (protocol || 'http') + '://' + host + ':' + (port || 80);
  };

  /**
   * Mergest 2 query strings in to once unique query string
   *
   * @param {String} base
   * @param {String} addition
   * @api public
   */

  util.query = function (base, addition) {
    var query = util.chunkQuery(base || '')
      , components = [];

    util.merge(query, util.chunkQuery(addition || ''));
    for (var part in query) {
      if (query.hasOwnProperty(part)) {
        components.push(part + '=' + query[part]);
      }
    }

    return components.length ? '?' + components.join('&') : '';
  };

  /**
   * Transforms a querystring in to an object
   *
   * @param {String} qs
   * @api public
   */

  util.chunkQuery = function (qs) {
    var query = {}
      , params = qs.split('&')
      , i = 0
      , l = params.length
      , kv;

    for (; i < l; ++i) {
      kv = params[i].split('=');
      if (kv[0]) {
        query[kv[0]] = kv[1];
      }
    }

    return query;
  };

  /**
   * Executes the given function when the page is loaded.
   *
   *     io.util.load(function () { console.log('page loaded'); });
   *
   * @param {Function} fn
   * @api public
   */

  var pageLoaded = false;

  util.load = function (fn) {
    if ('document' in global && document.readyState === 'complete' || pageLoaded) {
      return fn();
    }

    util.on(global, 'load', fn, false);
  };

  /**
   * Adds an event.
   *
   * @api private
   */

  util.on = function (element, event, fn, capture) {
    if (element.attachEvent) {
      element.attachEvent('on' + event, fn);
    } else if (element.addEventListener) {
      element.addEventListener(event, fn, capture);
    }
  };

  /**
   * Generates the correct `XMLHttpRequest` for regular and cross domain requests.
   *
   * @param {Boolean} [xdomain] Create a request that can be used cross domain.
   * @returns {XMLHttpRequest|false} If we can create a XMLHttpRequest.
   * @api private
   */

  util.request = function (xdomain) {

    if (xdomain && 'undefined' != typeof XDomainRequest) {
      return new XDomainRequest();
    }

    if ('undefined' != typeof XMLHttpRequest && (!xdomain || util.ua.hasCORS)) {
      return new XMLHttpRequest();
    }

    if (!xdomain) {
      try {
        return new window[(['Active'].concat('Object').join('X'))]('Microsoft.XMLHTTP');
      } catch(e) { }
    }

    return null;
  };

  /**
   * XHR based transport constructor.
   *
   * @constructor
   * @api public
   */

  /**
   * Change the internal pageLoaded value.
   */

  if ('undefined' != typeof window) {
    util.load(function () {
      pageLoaded = true;
    });
  }

  /**
   * Defers a function to ensure a spinner is not displayed by the browser
   *
   * @param {Function} fn
   * @api public
   */

  util.defer = function (fn) {
    if (!util.ua.webkit || 'undefined' != typeof importScripts) {
      return fn();
    }

    util.load(function () {
      setTimeout(fn, 100);
    });
  };

  /**
   * Merges two objects.
   *
   * @api public
   */

  util.merge = function merge (target, additional, deep, lastseen) {
    var seen = lastseen || []
      , depth = typeof deep == 'undefined' ? 2 : deep
      , prop;

    for (prop in additional) {
      if (additional.hasOwnProperty(prop) && util.indexOf(seen, prop) < 0) {
        if (typeof target[prop] !== 'object' || !depth) {
          target[prop] = additional[prop];
          seen.push(additional[prop]);
        } else {
          util.merge(target[prop], additional[prop], depth - 1, seen);
        }
      }
    }

    return target;
  };

  /**
   * Merges prototypes from objects
   *
   * @api public
   */

  util.mixin = function (ctor, ctor2) {
    util.merge(ctor.prototype, ctor2.prototype);
  };

  /**
   * Shortcut for prototypical and static inheritance.
   *
   * @api private
   */

  util.inherit = function (ctor, ctor2) {
    function f() {};
    f.prototype = ctor2.prototype;
    ctor.prototype = new f;
  };

  /**
   * Checks if the given object is an Array.
   *
   *     io.util.isArray([]); // true
   *     io.util.isArray({}); // false
   *
   * @param Object obj
   * @api public
   */

  util.isArray = Array.isArray || function (obj) {
    return Object.prototype.toString.call(obj) === '[object Array]';
  };

  /**
   * Intersects values of two arrays into a third
   *
   * @api public
   */

  util.intersect = function (arr, arr2) {
    var ret = []
      , longest = arr.length > arr2.length ? arr : arr2
      , shortest = arr.length > arr2.length ? arr2 : arr;

    for (var i = 0, l = shortest.length; i < l; i++) {
      if (~util.indexOf(longest, shortest[i]))
        ret.push(shortest[i]);
    }

    return ret;
  }

  /**
   * Array indexOf compatibility.
   *
   * @see bit.ly/a5Dxa2
   * @api public
   */

  util.indexOf = function (arr, o, i) {

    for (var j = arr.length, i = i < 0 ? i + j < 0 ? 0 : i + j : i || 0;
         i < j && arr[i] !== o; i++) {}

    return j <= i ? -1 : i;
  };

  /**
   * Converts enumerables to array.
   *
   * @api public
   */

  util.toArray = function (enu) {
    var arr = [];

    for (var i = 0, l = enu.length; i < l; i++)
      arr.push(enu[i]);

    return arr;
  };

  /**
   * UA / engines detection namespace.
   *
   * @namespace
   */

  util.ua = {};

  /**
   * Whether the UA supports CORS for XHR.
   *
   * @api public
   */

  util.ua.hasCORS = 'undefined' != typeof XMLHttpRequest && (function () {
    try {
      var a = new XMLHttpRequest();
    } catch (e) {
      return false;
    }

    return a.withCredentials != undefined;
  })();

  /**
   * Detect webkit.
   *
   * @api public
   */

  util.ua.webkit = 'undefined' != typeof navigator
    && /webkit/i.test(navigator.userAgent);

})(
    'undefined' != typeof io ? io : module.exports
  , 'undefined' === typeof global ? window : global);

/**
 * socket.io
 * Copyright(c) 2011 LearnBoost <dev@learnboost.com>
 * MIT Licensed
 */

(function (exports, io) {

  /**
   * Expose constructor.
   */

  exports.EventEmitter = EventEmitter;

  /**
   * Event emitter constructor.
   *
   * @api public.
   */

  function EventEmitter () {};

  /**
   * Adds a listener
   *
   * @api public
   */

  EventEmitter.prototype.on = function (name, fn) {
    if (!this.$events) {
      this.$events = {};
    }

    if (!this.$events[name]) {
      this.$events[name] = fn;
    } else if (io.util.isArray(this.$events[name])) {
      this.$events[name].push(fn);
    } else {
      this.$events[name] = [this.$events[name], fn];
    }

    return this;
  };

  EventEmitter.prototype.addListener = EventEmitter.prototype.on;

  /**
   * Adds a volatile listener.
   *
   * @api public
   */

  EventEmitter.prototype.once = function (name, fn) {
    var self = this;

    function on () {
      self.removeListener(name, on);
      fn.apply(this, arguments);
    };

    on.listener = fn;
    this.on(name, on);

    return this;
  };

  /**
   * Removes a listener.
   *
   * @api public
   */

  EventEmitter.prototype.removeListener = function (name, fn) {
    if (this.$events && this.$events[name]) {
      var list = this.$events[name];

      if (io.util.isArray(list)) {
        var pos = -1;

        for (var i = 0, l = list.length; i < l; i++) {
          if (list[i] === fn || (list[i].listener && list[i].listener === fn)) {
            pos = i;
            break;
          }
        }

        if (pos < 0) {
          return this;
        }

        list.splice(pos, 1);

        if (!list.length) {
          delete this.$events[name];
        }
      } else if (list === fn || (list.listener && list.listener === fn)) {
        delete this.$events[name];
      }
    }

    return this;
  };

  /**
   * Removes all listeners for an event.
   *
   * @api public
   */

  EventEmitter.prototype.removeAllListeners = function (name) {
    // TODO: enable this when node 0.5 is stable
    //if (name === undefined) {
      //this.$events = {};
      //return this;
    //}

    if (this.$events && this.$events[name]) {
      this.$events[name] = null;
    }

    return this;
  };

  /**
   * Gets all listeners for a certain event.
   *
   * @api publci
   */

  EventEmitter.prototype.listeners = function (name) {
    if (!this.$events) {
      this.$events = {};
    }

    if (!this.$events[name]) {
      this.$events[name] = [];
    }

    if (!io.util.isArray(this.$events[name])) {
      this.$events[name] = [this.$events[name]];
    }

    return this.$events[name];
  };

  /**
   * Emits an event.
   *
   * @api public
   */

  EventEmitter.prototype.emit = function (name) {
    if (!this.$events) {
      return false;
    }

    var handler = this.$events[name];

    if (!handler) {
      return false;
    }

    var args = Array.prototype.slice.call(arguments, 1);

    if ('function' == typeof handler) {
      handler.apply(this, args);
    } else if (io.util.isArray(handler)) {
      var listeners = handler.slice();

      for (var i = 0, l = listeners.length; i < l; i++) {
        listeners[i].apply(this, args);
      }
    } else {
      return false;
    }

    return true;
  };

})(
    'undefined' != typeof io ? io : module.exports
  , 'undefined' != typeof io ? io : module.parent.exports
);

/**
 * socket.io
 * Copyright(c) 2011 LearnBoost <dev@learnboost.com>
 * MIT Licensed
 */

/**
 * Removed JSON polyfill - obsolete, and we are using native JSON.parse etc. throughout the rest of the codebase anyway
 */

(function (exports, nativeJSON) {
  "use strict";

  // use native JSON if it's available
  if (nativeJSON && nativeJSON.parse){
    return exports.JSON = {
      parse: nativeJSON.parse
    , stringify: nativeJSON.stringify
    }
  }

  throw new Error("JSON not available");
  
})(
    'undefined' != typeof io ? io : module.exports
  , typeof JSON !== 'undefined' ? JSON : undefined
);

/**
 * socket.io
 * Copyright(c) 2011 LearnBoost <dev@learnboost.com>
 * MIT Licensed
 */

(function (exports, io) {

  /**
   * Parser namespace.
   *
   * @namespace
   */

  var parser = exports.parser = {};

  /**
   * Packet types.
   */

  var packets = parser.packets = [
      'disconnect'
    , 'connect'
    , 'heartbeat'
    , 'message'
    , 'json'
    , 'event'
    , 'ack'
    , 'error'
    , 'noop'
  ];

  /**
   * Errors reasons.
   */

  var reasons = parser.reasons = [
      'transport not supported'
    , 'client not handshaken'
    , 'unauthorized'
  ];

  /**
   * Errors advice.
   */

  var advice = parser.advice = [
      'reconnect'
  ];

  /**
   * Shortcuts.
   */

  var JSON = io.JSON
    , indexOf = io.util.indexOf;

  /**
   * Encodes a packet.
   *
   * @api private
   */

  parser.encodePacket = function (packet) {
    var type = indexOf(packets, packet.type)
      , id = packet.id || ''
      , endpoint = packet.endpoint || ''
      , ack = packet.ack
      , data = null;

    switch (packet.type) {
      case 'error':
        var reason = packet.reason ? indexOf(reasons, packet.reason) : ''
          , adv = packet.advice ? indexOf(advice, packet.advice) : '';

        if (reason !== '' || adv !== '')
          data = reason + (adv !== '' ? ('+' + adv) : '');

        break;

      case 'message':
        if (packet.data !== '')
          data = packet.data;
        break;

      case 'event':
        var ev = { name: packet.name };

        if (packet.args && packet.args.length) {
          ev.args = packet.args;
        }

        data = JSON.stringify(ev);
        break;

      case 'json':
        data = JSON.stringify(packet.data);
        break;

      case 'connect':
        if (packet.qs)
          data = packet.qs;
        break;

      case 'ack':
        data = packet.ackId
          + (packet.args && packet.args.length
              ? '+' + JSON.stringify(packet.args) : '');
        break;
    }

    // construct packet with required fragments
    var encoded = [
        type
      , id + (ack == 'data' ? '+' : '')
      , endpoint
    ];

    // data fragment is optional
    if (data !== null && data !== undefined)
      encoded.push(data);

    return encoded.join(':');
  };

  /**
   * Encodes multiple messages (payload).
   *
   * @param {Array} messages
   * @api private
   */

  parser.encodePayload = function (packets) {
    var decoded = '';

    if (packets.length == 1)
      return packets[0];

    for (var i = 0, l = packets.length; i < l; i++) {
      var packet = packets[i];
      decoded += '\ufffd' + packet.length + '\ufffd' + packets[i];
    }

    return decoded;
  };

  /**
   * Decodes a packet
   *
   * @api private
   */

  var regexp = /([^:]+):([0-9]+)?(\+)?:([^:]+)?:?([\s\S]*)?/;

  parser.decodePacket = function (data) {
    var pieces = data.match(regexp);

    if (!pieces) return {};

    var id = pieces[2] || ''
      , data = pieces[5] || ''
      , packet = {
            type: packets[pieces[1]]
          , endpoint: pieces[4] || ''
        };

    // whether we need to acknowledge the packet
    if (id) {
      packet.id = id;
      if (pieces[3])
        packet.ack = 'data';
      else
        packet.ack = true;
    }

    // handle different packet types
    switch (packet.type) {
      case 'error':
        var pieces = data.split('+');
        packet.reason = reasons[pieces[0]] || '';
        packet.advice = advice[pieces[1]] || '';
        break;

      case 'message':
        packet.data = data || '';
        break;

      case 'event':
        try {
          var opts = JSON.parse(data);
          packet.name = opts.name;
          packet.args = opts.args;
        } catch (e) { }

        packet.args = packet.args || [];
        break;

      case 'json':
        try {
          packet.data = JSON.parse(data);
        } catch (e) { }
        break;

      case 'connect':
        packet.qs = data || '';
        break;

      case 'ack':
        var pieces = data.match(/^([0-9]+)(\+)?(.*)/);
        if (pieces) {
          packet.ackId = pieces[1];
          packet.args = [];

          if (pieces[3]) {
            try {
              packet.args = pieces[3] ? JSON.parse(pieces[3]) : [];
            } catch (e) { }
          }
        }
        break;

      case 'disconnect':
        packet.reason = data;
        break;

      case 'heartbeat':
        break;
    };

    return packet;
  };

  /**
   * Decodes data payload. Detects multiple messages
   *
   * @return {Array} messages
   * @api public
   */

  parser.decodePayload = function (data) {
    // IE doesn't like data[i] for unicode chars, charAt works fine
    if (data.charAt(0) == '\ufffd') {
      var ret = [];

      for (var i = 1, length = ''; i < data.length; i++) {
        if (data.charAt(i) == '\ufffd') {
          ret.push(parser.decodePacket(data.substr(i + 1).substr(0, length)));
          i += Number(length) + 1;
          length = '';
        } else {
          length += data.charAt(i);
        }
      }

      return ret;
    } else {
      return [parser.decodePacket(data)];
    }
  };

})(
    'undefined' != typeof io ? io : module.exports
  , 'undefined' != typeof io ? io : module.parent.exports
);
/**
 * socket.io
 * Copyright(c) 2011 LearnBoost <dev@learnboost.com>
 * MIT Licensed
 */

(function (exports, io) {

  /**
   * Expose constructor.
   */

  exports.Transport = Transport;

  /**
   * This is the transport template for all supported transport methods.
   *
   * @constructor
   * @api public
   * @param {exports.Socket} socket
   */

  function Transport (socket, sessid) {
    this.socket = socket;
    this.sessid = sessid;
    this.connectErrorCallback = undefined;
    this.isOpened = false;
  };

  /**
   * Apply EventEmitter mixin.
   */

  io.util.mixin(Transport, io.EventEmitter);

  /**
   * Handles the response from the server. When a new response is received
   * it will automatically update the timeout, decode the message and
   * forwards the response to the onMessage function for further processing.
   *
   * @param {String} data Response from the server.
   * @api private
   */

  Transport.prototype.onData = function (data) {
    this.clearCloseTimeout();

    // If the connection in currently open (or in a reopening state) reset the close
    // timeout since we have just received data. This check is necessary so
    // that we don't reset the timeout on an explicitly disconnected connection.
    if (this.socket.connected || this.socket.connecting || this.socket.reconnecting) {
      this.setCloseTimeout();
    }

    if (data !== '') {
      // todo: we should only do decodePayload for xhr transports
      var msgs = io.parser.decodePayload(data);

      if (msgs && msgs.length) {
        for (var i = 0, l = msgs.length; i < l; i++) {
          this.onPacket(msgs[i]);
        }
      }
    }

    return this;
  };

  /**
   * Handles packets.
   *
   * @api private
   */

  Transport.prototype.onPacket = function (packet) {
    this.socket.setHeartbeatTimeout();

    if (packet.type == 'heartbeat') {
      return this.onHeartbeat();
    }

    if (packet.type == 'connect' && packet.endpoint == '') {
      this.onConnect();
    }

    if (packet.type == 'error' && packet.advice == 'reconnect') {
      this.isOpened = false;
    }

    this.socket.onPacket(packet);

    return this;
  };

  /**
   * Sets close timeout
   *
   * @api private
   */

  Transport.prototype.setCloseTimeout = function () {
    if (!this.closeTimeout) {
      var self = this;

      this.closeTimeout = setTimeout(function () {
        self.onDisconnect();
      }, this.socket.closeTimeout);
    }
  };

  /**
   * Called when transport disconnects.
   *
   * @api private
   */

  Transport.prototype.onDisconnect = function () {
    if (this.close && this.isOpened) this.close();
    this.clearTimeouts();
    this.socket.onDisconnect();
    return this;
  };

  /**
   * Called when transport connects
   *
   * @api private
   */

  Transport.prototype.onConnect = function () {
    this.socket.onConnect();
    this.connectErrorCallback = undefined;
    return this;
  }

  /**
   * Clears close timeout
   *
   * @api private
   */

  Transport.prototype.clearCloseTimeout = function () {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
  };

  /**
   * Clear timeouts
   *
   * @api private
   */

  Transport.prototype.clearTimeouts = function () {
    this.clearCloseTimeout();

    if (this.reopenTimeout) {
      clearTimeout(this.reopenTimeout);
    }
  };

  /**
   * Sends a packet
   *
   * @param {Object} packet object.
   * @api private
   */

  Transport.prototype.packet = function (packet) {
    this.send(io.parser.encodePacket(packet));
  };

  /**
   * Send the received heartbeat message back to server. So the server
   * knows we are still connected.
   *
   * @param {String} heartbeat Heartbeat response from the server.
   * @api private
   */

  Transport.prototype.onHeartbeat = function (heartbeat) {
    this.packet({ type: 'heartbeat' });
  };

  /**
   * Called when the transport opens.
   *
   * @api private
   */

  Transport.prototype.onOpen = function () {
    this.isOpened = true;
    this.clearCloseTimeout();
    this.socket.onOpen();
  };

  /**
   * Notifies the base when the connection with the Socket.IO server
   * has been disconnected.
   *
   * @api private
   */

  Transport.prototype.onClose = function () {
    var self = this;

    /* FIXME: reopen delay causing a infinit loop
    this.reopenTimeout = setTimeout(function () {
      self.open();
    }, this.socket.options['reopen delay']);*/

    this.isOpened = false;
    this.socket.onClose();
    this.onDisconnect();
  };

  /**
   * Generates a connection url based on the Socket.IO URL Protocol.
   * See <https://github.com/learnboost/socket.io-node/> for more details.
   *
   * @returns {String} Connection url
   * @api private
   */

  Transport.prototype.prepareUrl = function (query) {
    /** @var {ISocketIoOptions} options */
    var options = this.socket.options;

    if (options['skipped handshake data']) {
      // /v4/c protocol
      return options.rewriteUrlForProxy(options['skipped handshake data'].websocketUrl + (query ? query : ''))
    }

    var url = this.scheme() + '://'
      + options.host + ':' + options.port + '/'
      + options.resource + '/' + io.protocol
      + '/' + this.name + '/' + this.sessid + (query ? query : '');

    return options.rewriteUrlForProxy(url);
  };

  /**
   * Checks if the transport is ready to start a connection.
   *
   * @param {Socket} socket The socket instance that needs a transport
   * @param {Function} fn The callback
   * @api private
   */

  Transport.prototype.ready = function (socket, fn) {
    fn.call(this);
  };

  /**
   * Clears the event handlers attached on to by specific transport implementations.
   *
   * @api private
   */
  Transport.prototype.clearEventHandlers = function () {
      return this;
  };
})(
    'undefined' != typeof io ? io : module.exports
  , 'undefined' != typeof io ? io : module.parent.exports
);
/**
 * socket.io
 * Copyright(c) 2011 LearnBoost <dev@learnboost.com>
 * MIT Licensed
 */

(function (exports, io, global) {

  /**
   * Expose constructor.
   */

  exports.Socket = Socket;

  /**
   * Create a new `Socket.IO client` which can establish a persistent
   * connection with a Socket.IO enabled server.
   *
   * @api public
   */

  function Socket (options) {
    this.options = {
        port: 80
      , secure: false
      , document: 'document' in global ? document : false
      , resource: 'socket.io'
      , transports: io.transports.slice()
      , 'connect timeout': 10000
      , 'try multiple transports': true
      , 'reconnect': true
      , 'reconnection delay': 500
      , 'reconnection limit': Infinity
      , 'reopen delay': 3000
      , 'max reconnection attempts': 10
      , 'sync disconnect on unload': true
      , 'auto connect': true
      , 'flash policy port': 10843
    };

    io.util.merge(this.options, options);

    this.connected = false;
    this.open = false;
    this.connecting = false;
    this.reconnecting = false;
    this.namespaces = {};
    this.buffer = [];
    this.doBuffer = false;
    this.disconnected = false;

    if (this.options['sync disconnect on unload'] &&
        (!this.isXDomain() || io.util.ua.hasCORS)) {
      var self = this;

      io.util.on(global, 'unload', function () {
        self.disconnectSync();
      }, false);
    }

    if (this.options['auto connect']) {
      this.connect();
    }
};

  /**
   * Apply EventEmitter mixin.
   */

  io.util.mixin(Socket, io.EventEmitter);

  /**
   * Returns a namespace listener/emitter for this socket
   *
   * @api public
   */

  Socket.prototype.of = function (name) {
    if (!this.namespaces[name]) {
      this.namespaces[name] = new io.SocketNamespace(this, name);

      if (name !== '') {
        this.namespaces[name].packet({ type: 'connect' });
      }
    }

    return this.namespaces[name];
  };

  /**
   * Emits the given event to the Socket and all namespaces
   *
   * @api private
   */

  Socket.prototype.publish = function () {
    this.emit.apply(this, arguments);

    var nsp;

    for (var i in this.namespaces) {
      if (this.namespaces.hasOwnProperty(i)) {
        nsp = this.of(i);
        nsp.$emit.apply(nsp, arguments);
      }
    }
  };

  /**
   * Performs the handshake
   *
   * @api private
   */

  function empty () { };

  Socket.prototype.handshake = function (fn) {
    var self = this
      , options = this.options;
      
    if (self.disconnected) {
      return;
    }

    function complete (data) {
      if (data instanceof Error) {
        self.onError(data.message);
      } else {
        fn.apply(null, data.split(':'));
      }
    };

    var url = options.rewriteUrlForProxy([
          'http' + (options.secure ? 's' : '') + ':/'
        , options.host + ':' + options.port
        , options.resource
        , io.protocol
        , io.util.query(this.options.query, 't=' + +new Date)
      ].join('/'));

    if (this.isXDomain() && !io.util.ua.hasCORS) {
      var insertAt = document.getElementsByTagName('script')[0]
        , script = document.createElement('script');

      script.src = url + '&jsonp=' + io.j.length;
      insertAt.parentNode.insertBefore(script, insertAt);

      io.j.push(function (data) {
        complete(data);
        script.parentNode.removeChild(script);
      });
    } else {
      var xhr = io.util.request();
      
      xhr.open('GET', url, true);

      var headers = this.options.requestHeaders;
      if (headers !== undefined) {
        Object.keys(headers).forEach(function(name) {
          xhr.setRequestHeader(name, headers[name]);
        });
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          xhr.onreadystatechange = empty;

          if (xhr.status == 200) {
            complete(xhr.responseText);
          } else {
            !self.reconnecting && self.onError(xhr.responseText);
          }
        }
      };
      xhr.send(null);
    }
  };

  /**
   * Find an available transport based on the options supplied in the constructor.
   *
   * @api private
   */

  Socket.prototype.getTransport = function (override) {
    var transports = override || this.transports, match;

    for (var i = 0, transport; transport = transports[i]; i++) {
      if (io.Transport[transport]
        && io.Transport[transport].check(this)
        && (!this.isXDomain() || io.Transport[transport].xdomainCheck())) {
        return new io.Transport[transport](this, this.sessionid);
      }
    }

    return null;
  };

  /**
   * Connects to the server.
   *
   * @param {Function} [fn] Callback.
   * @returns {io.Socket}
   * @api public
   */

  Socket.prototype.connect = function (fn) {
    if (this.connecting || this.disconnected) {
      return this;
    }

    var self = this;

    var onHandshakeComplete = (function (sid, heartbeat, close, transports) {
      // Params come from response's body - it's splitted by ':'
      // example: 1178beba4026e2c7-48e62d038b18f416:85:85:websocket,xhr-polling,jsonp-polling
      self.sessionid = sid;
      // Add two seconds, so connection is closed by server, not client - otherwise
      // there will be a onSocketDisconnect event which will start health check, etc
      // This can happen if server returns close/heartbeat timeout equal to 40 which is server's timeout to
      // close long poll connection, in such case client can close connection before server response with empty
      // response and client goes to health check. Server can return such timeout if client send too small ping timeout
      // during handshake
      self.closeTimeout = close * 1000 + 2000;
      self.heartbeatTimeout = heartbeat * 1000 + 2000;
      self.transports = transports ? io.util.intersect(
          transports.split(',')
        , self.options.transports
      ) : self.options.transports;

      self.setHeartbeatTimeout();
      self.remainingTransports = self.transports.slice(0);

      function tryNextTransport() {
        if (!self.connected && !self.disconnected) {
          self.connecting = false;
          clearTimeout(self.connectTimeoutTimer);

          if (self.options['try multiple transports']) {
            while (self.remainingTransports.length > 0
                   && self.remainingTransports.splice(0,1)[0] != self.transport.name) {}

            if (self.remainingTransports.length){
              connect(self.remainingTransports);
            } else {
              self.publish('connect_failed');
            }
          } else {
            self.publish('connect_failed');
          }
        }
      }


      function connect (transports){
        if (self.transport) {
            self.transport.clearTimeouts();
            self.transport.clearEventHandlers();
        }

        self.transport = self.getTransport(transports);
        if (!self.transport || self.disconnected) return self.publish('connect_failed');

        // once the transport is ready (i.e. page is fully loaded)
        self.transport.ready(self, function () {
          self.connecting = true;
          self.publish('connecting', self.transport.name);
          self.transport.open(tryNextTransport);

          if (self.options['connect timeout']) {
            self.connectTimeoutTimer = setTimeout(function () {
              tryNextTransport();
            }, self.options['connect timeout']);
          }
        });
      }

      connect(self.transports);

      self.once('connect', function (){
        clearTimeout(self.connectTimeoutTimer);

        fn && typeof fn == 'function' && fn();
      });
    });

    if (this.options['skipped handshake data']) {
      // /v4/c protocol
      var data = this.options['skipped handshake data'];
      // There is no need for the client to know a Socket ID with this protocol
      // Can probably just use some dummy/random/timestamp thing as session id, it is completely opaque, on server too
      // It can also be filled retroactively after being sent from the server inside a WS message (trouter.connected),
      // but I don't think we need to bother.
      onHandshakeComplete('v4c-' + new Date().getTime(), data.timeout, data.timeout, 'websocket');
    } else {
      this.handshake(onHandshakeComplete);
    }

    return this;
  };

  /**
   * Clears and sets a new heartbeat timeout using the value given by the
   * server during the handshake.
   *
   * @api private
   */

  Socket.prototype.setHeartbeatTimeout = function () {
    clearTimeout(this.heartbeatTimeoutTimer);

    var self = this;
    this.heartbeatTimeoutTimer = setTimeout(function () {
      self.transport.onClose();
    }, this.heartbeatTimeout);
  };

  /**
   * Sends a message.
   *
   * @param {Object} data packet.
   * @returns {io.Socket}
   * @api public
   */

  Socket.prototype.packet = function (data) {
    if (this.connected && !this.doBuffer) {
      this.transport.packet(data);
    } else {
      this.buffer.push(data);
    }

    return this;
  };

  /**
   * Sets buffer state
   *
   * @api private
   */

  Socket.prototype.setBuffer = function (v) {
    this.doBuffer = v;

    if (!v && this.connected && this.buffer.length) {
      this.transport.payload(this.buffer);
      this.buffer = [];
    }
  };

  /**
   * Disconnect the established connect.
   *
   * @returns {io.Socket}
   * @api public
   */

  Socket.prototype.disconnect = function () {
    if (this.connected || this.connecting) {
      if (this.open) {
        this.of('').packet({ type: 'disconnect' });
      }

      // handle disconnection immediately
      this.onDisconnect('booted');
    }
    this.disconnected = true;

    return this;
  };

  /**
   * Disconnects the socket with a sync XHR.
   *
   * @api private
   */

  Socket.prototype.disconnectSync = function () {
    // ensure disconnection
    var xhr = io.util.request()
      , uri = this.resource + '/' + io.protocol + '/' + this.sessionid;

    xhr.open('GET', uri, true);

    // handle disconnection immediately
    this.onDisconnect('booted');
  };

  /**
   * Check if we need to use cross domain enabled transports. Cross domain would
   * be a different port or different domain name.
   *
   * @returns {Boolean}
   * @api private
   */

  Socket.prototype.isXDomain = function () {

    var port = global.location.port ||
      ('https:' == global.location.protocol ? 443 : 80);

    return this.options.host !== global.location.hostname
      || this.options.port != port;
  };

  /**
   * Called upon handshake.
   *
   * @api private
   */

  Socket.prototype.onConnect = function () {
    if (!this.connected) {
      this.connected = true;
      this.connecting = false;
      if (!this.doBuffer) {
        // make sure to flush the buffer
        this.setBuffer(false);
      }
      this.emit('connect');
    }
  };

  /**
   * Called when the transport opens
   *
   * @api private
   */

  Socket.prototype.onOpen = function () {
    this.open = true;
  };

  /**
   * Called when the transport closes.
   *
   * @api private
   */

  Socket.prototype.onClose = function () {
    this.open = false;
    clearTimeout(this.heartbeatTimeoutTimer);
  };

  /**
   * Called when the transport first opens a connection
   *
   * @param text
   */

  Socket.prototype.onPacket = function (packet) {
    this.of(packet.endpoint).onPacket(packet);
  };

  /**
   * Handles an error.
   *
   * @api private
   */

  Socket.prototype.onError = function (err) {
    if (err && err.advice) {
      if (err.advice === 'reconnect' && (this.connected || this.connecting)) {
        this.disconnect();
        if (this.options.reconnect) {
          this.reconnect();
        }
      }
    }

    this.publish('error', err && err.reason ? err.reason : err);
  };

  /**
   * Called when the transport disconnects.
   *
   * @api private
   */

  Socket.prototype.onDisconnect = function (reason) {
    var wasConnected = this.connected
      , wasConnecting = this.connecting;

    this.connected = false;
    this.connecting = false;
    this.open = false;

    if (wasConnected || wasConnecting) {
      this.transport.close();
      this.transport.clearTimeouts();
      if (wasConnected) {
        this.publish('disconnect', reason);

        if ('booted' != reason && this.options.reconnect && !this.reconnecting) {
          this.reconnect();
        }
      } else {
        this.publish('close_during_connecting', reason);
      }
    }
  };

  /**
   * Called upon reconnection.
   *
   * @api private
   */

  Socket.prototype.reconnect = function () {
    this.reconnecting = true;
    this.reconnectionAttempts = 0;
    this.reconnectionDelay = this.options['reconnection delay'];

    var self = this
      , maxAttempts = this.options['max reconnection attempts']
      , tryMultiple = this.options['try multiple transports']
      , limit = this.options['reconnection limit'];

    function reset () {
      if (self.connected) {
        for (var i in self.namespaces) {
          if (self.namespaces.hasOwnProperty(i) && '' !== i) {
              self.namespaces[i].packet({ type: 'connect' });
          }
        }
        self.publish('reconnect', self.transport.name, self.reconnectionAttempts);
      }

      clearTimeout(self.reconnectionTimer);

      self.removeListener('connect_failed', maybeReconnect);
      self.removeListener('connect', maybeReconnect);

      self.reconnecting = false;

      delete self.reconnectionAttempts;
      delete self.reconnectionDelay;
      delete self.reconnectionTimer;
      delete self.redoTransports;

      self.options['try multiple transports'] = tryMultiple;
    };

    function maybeReconnect () {
      if (!self.reconnecting) {
        return;
      }

      if (self.connected) {
        return reset();
      };

      if (self.connecting && self.reconnecting) {
        return self.reconnectionTimer = setTimeout(maybeReconnect, 1000);
      }

      if (self.reconnectionAttempts++ >= maxAttempts) {
        if (!self.redoTransports) {
          self.on('connect_failed', maybeReconnect);
          self.options['try multiple transports'] = true;
          self.transport = self.getTransport();
          self.redoTransports = true;
          self.connect();
        } else {
          self.publish('reconnect_failed');
          reset();
        }
      } else {
        if (self.reconnectionDelay < limit) {
          self.reconnectionDelay *= 2; // exponential back off
        }

        self.connect();
        self.publish('reconnecting', self.reconnectionDelay, self.reconnectionAttempts);
        self.reconnectionTimer = setTimeout(maybeReconnect, self.reconnectionDelay);
      }
    };

    this.options['try multiple transports'] = false;
    this.reconnectionTimer = setTimeout(maybeReconnect, this.reconnectionDelay);

    this.on('connect', maybeReconnect);
  };

})(
    'undefined' != typeof io ? io : module.exports
  , 'undefined' != typeof io ? io : module.parent.exports
  , 'undefined' === typeof global ? window : global
);
/**
 * socket.io
 * Copyright(c) 2011 LearnBoost <dev@learnboost.com>
 * MIT Licensed
 */

(function (exports, io) {

  /**
   * Expose constructor.
   */

  exports.SocketNamespace = SocketNamespace;

  /**
   * Socket namespace constructor.
   *
   * @constructor
   * @api public
   */

  function SocketNamespace (socket, name) {
    this.socket = socket;
    this.name = name || '';
    this.flags = {};
    this.json = new Flag(this, 'json');
    this.ackPackets = 0;
    this.acks = {};
  };

  /**
   * Apply EventEmitter mixin.
   */

  io.util.mixin(SocketNamespace, io.EventEmitter);

  /**
   * Copies emit since we override it
   *
   * @api private
   */

  SocketNamespace.prototype.$emit = io.EventEmitter.prototype.emit;

  /**
   * Creates a new namespace, by proxying the request to the socket. This
   * allows us to use the synax as we do on the server.
   *
   * @api public
   */

  SocketNamespace.prototype.of = function () {
    return this.socket.of.apply(this.socket, arguments);
  };

  /**
   * Sends a packet.
   *
   * @api private
   */

  SocketNamespace.prototype.packet = function (packet) {
    packet.endpoint = this.name;
    this.socket.packet(packet);
    this.flags = {};
    return this;
  };

  /**
   * Sends a message
   *
   * @api public
   */

  SocketNamespace.prototype.send = function (data, fn) {
    var packet = {
        type: this.flags.json ? 'json' : 'message'
      , data: data
    };

    if ('function' == typeof fn) {
      packet.id = ++this.ackPackets;
      packet.ack = true;
      this.acks[packet.id] = fn;
    }

    return this.packet(packet);
  };

  /**
   * Emits an event
   *
   * @api public
   */

  SocketNamespace.prototype.emit = function (name) {
    var args = Array.prototype.slice.call(arguments, 1)
      , lastArg = args[args.length - 1]
      , packet = {
            type: 'event'
          , name: name
        };

    if ('function' == typeof lastArg) {
      packet.id = ++this.ackPackets;
      packet.ack = 'data';
      this.acks[packet.id] = lastArg;
      args = args.slice(0, args.length - 1);
    }

    packet.args = args;

    return this.packet(packet);
  };

  /**
   * Disconnects the namespace
   *
   * @api private
   */

  SocketNamespace.prototype.disconnect = function () {
    if (this.name === '') {
      this.socket.disconnect();
    } else {
      this.packet({ type: 'disconnect' });
      this.$emit('disconnect');
    }

    return this;
  };

  /**
   * Handles a packet
   *
   * @api private
   */

  SocketNamespace.prototype.onPacket = function (packet) {
    var self = this;

    function ack () {
      self.packet({
          type: 'ack'
        , args: io.util.toArray(arguments)
        , ackId: packet.id
      });
    };

    switch (packet.type) {
      case 'connect':
        this.$emit('connect');
        break;

      case 'disconnect':
        if (this.name === '') {
          this.socket.onDisconnect(packet.reason || 'booted');
        } else {
          this.$emit('disconnect', packet.reason || '');
        }
        break;

      case 'message':
      case 'json':
        var params = ['message', packet.data];

        if (packet.ack == 'data') {
          params.push(ack);
        } else if (packet.ack) {
          this.packet({ type: 'ack', ackId: packet.id });
        }

        this.$emit.apply(this, params);
        break;

      case 'event':
        var params = [packet.name].concat(packet.args);

        if (packet.ack == 'data')
          params.push(ack);

        this.$emit.apply(this, params);
        break;

      case 'ack':
        if (this.acks[packet.ackId]) {
          this.acks[packet.ackId].apply(this, packet.args);
          delete this.acks[packet.ackId];
        }
        break;

      case 'error':
        if (packet.advice){
          this.socket.onError(packet);
        } else {
          if (packet.reason == 'unauthorized') {
            this.$emit('connect_failed', packet.reason);
          } else {
            this.$emit('error', packet.reason);
          }
        }
        break;
    }
  };

  /**
   * Flag interface.
   *
   * @api private
   */

  function Flag (nsp, name) {
    this.namespace = nsp;
    this.name = name;
  };

  /**
   * Send a message
   *
   * @api public
   */

  Flag.prototype.send = function () {
    this.namespace.flags[this.name] = true;
    this.namespace.send.apply(this.namespace, arguments);
  };

  /**
   * Emit an event
   *
   * @api public
   */

  Flag.prototype.emit = function () {
    this.namespace.flags[this.name] = true;
    this.namespace.emit.apply(this.namespace, arguments);
  };

})(
    'undefined' != typeof io ? io : module.exports
  , 'undefined' != typeof io ? io : module.parent.exports
);

/**
 * socket.io
 * Copyright(c) 2011 LearnBoost <dev@learnboost.com>
 * MIT Licensed
 */

(function (exports, io, global) {

  /**
   * Expose constructor.
   */

  exports.websocket = WS;

  /**
   * The WebSocket transport uses the HTML5 WebSocket API to establish an
   * persistent connection with the Socket.IO server. This transport will also
   * be inherited by the FlashSocket fallback as it provides a API compatible
   * polyfill for the WebSockets.
   *
   * @constructor
   * @extends {io.Transport}
   * @api public
   */

  function WS (socket) {
    io.Transport.apply(this, arguments);
  };

  /**
   * Inherits from Transport.
   */

  io.util.inherit(WS, io.Transport);

  /**
   * Transport name
   *
   * @api public
   */

  WS.prototype.name = 'websocket';

  function empty() { };

  /**
   * Initializes a new `WebSocket` connection with the Socket.IO server. We attach
   * all the appropriate listeners to handle the responses from the server.
   *
   * @returns {Transport}
   * @api public
   */

  WS.prototype.open = function (connectErrorCallback) {
    var query = io.util.query(this.socket.options.query)
      , self = this
      , Socket

    this.connectErrorCallback = connectErrorCallback;

    if (!Socket) {
      Socket = global.MozWebSocket || global.WebSocket;
    }

    this.websocket = new Socket(this.prepareUrl(query));

    this.websocket.onopen = function () {
      self.onOpen();
      self.socket.setBuffer(false);
    };
    this.websocket.onmessage = function (ev) {
      self.onData(ev.data);
    };
    this.websocket.onclose = function () {
      self.onClose();
      self.socket.setBuffer(true);
    };
    this.websocket.onerror = function (e) {
      self.onError(e);
    };

    return this;
  };

  /**
   * Send a message to the Socket.IO server. The message will automatically be
   * encoded in the correct message format.
   *
   * @returns {Transport}
   * @api public
   */

  WS.prototype.send = function (data) {
    this.websocket.send(data);
    return this;
  };

  /**
   * Payload
   *
   * @api private
   */

  WS.prototype.payload = function (arr) {
    for (var i = 0, l = arr.length; i < l; i++) {
      this.packet(arr[i]);
    }
    return this;
  };

  /**
   * Disconnect the established `WebSocket` connection.
   *
   * @returns {Transport}
   * @api public
   */

  WS.prototype.close = function () {
    this.websocket.close();
    return this;
  };

  /**
   * Handle the errors that `WebSocket` might be giving when we
   * are attempting to connect or send messages.
   *
   * @param {Error} e The error.
   * @api private
   */

  WS.prototype.onError = function (e) {
      if (this.connectErrorCallback !== undefined) {
        this.connectErrorCallback();
        this.connectErrorCallback = undefined;
      }
      this.socket.onError(e);
  };

  /**
   * Returns the appropriate scheme for the URI generation.
   *
   * @api private
   */
  WS.prototype.scheme = function () {
    return this.socket.options.secure ? 'wss' : 'ws';
  };

  /**
   * Checks if the browser has support for native `WebSockets` and that
   * it's not the polyfill created for the FlashSocket transport.
   *
   * @return {Boolean}
   * @api public
   */

  WS.check = function () {
    return ('WebSocket' in global && !('__addTask' in WebSocket))
          || 'MozWebSocket' in global;
  };

  /**
   * Check if the `WebSocket` transport support cross domain communications.
   *
   * @returns {Boolean}
   * @api public
   */

  WS.xdomainCheck = function () {
    return true;
  };

  /**
   * Clears the event listeners attached to the `WebSocket` transport object.
   *
   * @api private
   */
  WS.prototype.clearEventHandlers = function() {
      if (this.websocket) {
          this.websocket.onopen = this.websocket.onmessage = this.websocket.onclose = this.websocket.onerror = empty;
      }
      return this;
  };

  /**
   * Add the transport to your public io.transports array.
   *
   * @api private
   */

  io.transports.push('websocket');

})(
    'undefined' != typeof io ? io.Transport : module.exports
  , 'undefined' != typeof io ? io : module.parent.exports
  , 'undefined' === typeof global ? window : global
);

/**
 * socket.io
 * Copyright(c) 2011 LearnBoost <dev@learnboost.com>
 * MIT Licensed
 */

(function (exports, io, global) {

  /**
   * Expose constructor.
   *
   * @api public
   */

  exports.XHR = XHR;

  /**
   * XHR constructor
   *
   * @constructor
   * @api public
   */

  function XHR (socket) {
    if (!socket) return;

    io.Transport.apply(this, arguments);
  };

  /**
   * Inherits from Transport.
   */

  io.util.inherit(XHR, io.Transport);

  /**
   * Establish a connection
   *
   * @returns {Transport}
   * @api public
   */

  XHR.prototype.open = function () {
    this.socket.setBuffer(false);
    this.onOpen();
    this.get();

    // we need to make sure the request succeeds since we have no indication
    // whether the request opened or not until it succeeded.
    this.setCloseTimeout();

    return this;
  };

  /**
   * Check if we need to send data to the Socket.IO server, if we have data in our
   * buffer we encode it and forward it to the `post` method.
   *
   * @api private
   */

  XHR.prototype.payload = function (payload) {
    var msgs = [];

    for (var i = 0, l = payload.length; i < l; i++) {
      msgs.push(io.parser.encodePacket(payload[i]));
    }

    this.send(io.parser.encodePayload(msgs));
  };

  /**
   * Send data to the Socket.IO server.
   *
   * @param data The message
   * @returns {Transport}
   * @api public
   */

  XHR.prototype.send = function (data) {
    this.post(data);
    return this;
  };

  function empty () { };

  /**
   * Posts a encoded message to the Socket.IO server.
   *
   * IMPORTANT: Note that only one of these requests should be in flight at any time,
   * see the mutation of `doBuffer` via `setBuffer`, and where `post` is called from.
   * Subsequent messages will be queued, and sent out on the next call
   * to `setBuffer(false)` (e.g. from the success callback).
   *
   * @param {String} data A encoded message.
   * @api private
   */
  XHR.prototype.post = function (data) {
    var self = this;
    this.socket.setBuffer(true);

    this.sendXHR = this.request('POST');

    function stateChange () {
      if (this.readyState == 4) {
        this.onreadystatechange = empty;

        if (this.status == 200) {
          clearTimeout(this.ackTimeoutTimer);

          // this flushes the buffer, which can trigger another call to `post`,
          // that will overwrite `self.sendXHR`
          self.socket.setBuffer(false);

          // at this point, self.sendXHR may already be the subsequent request
        } else {
          self.onClose();
        }
      }
    }

    function onload () {
      this.onload = empty;
      self.socket.setBuffer(false);
    };

    if (global.XDomainRequest && this.sendXHR instanceof XDomainRequest) {
      this.sendXHR.onload = this.sendXHR.onerror = onload;
    } else {
      this.sendXHR.onreadystatechange = stateChange;
    }

    this.sendXHR.send(data);
    self.sendXHR.ackTimeoutTimer = setTimeout(function () {
      self.onClose();
    }, self.socket.options.ackTimeoutMs);
  };

  /**
   * Disconnects the established `XHR` connection.
   *
   * @returns {Transport}
   * @api public
   */

  XHR.prototype.close = function () {
    this.onClose();
    return this;
  };

  /**
   * Generates a configured XHR request
   *
   * @param {String} url The url that needs to be requested.
   * @param {String} method The method the request should use.
   * @returns {XMLHttpRequest}
   * @api private
   */

  XHR.prototype.request = function (method) {
    var req = io.util.request(this.socket.isXDomain())
      , query = io.util.query(this.socket.options.query, 't=' + +new Date);

    req.open(method || 'GET', this.prepareUrl(query), true);

    var headers = this.socket.options.requestHeaders;
    if (headers !== undefined) {
      Object.keys(headers).forEach(function(name) {
        req.setRequestHeader(name, headers[name]);
      });
    }

    if (method == 'POST') {
      try {
        if (req.setRequestHeader) {
          req.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
        } else {
          // XDomainRequest
          req.contentType = 'text/plain';
        }
      } catch (e) {}
    }

    return req;
  };

  /**
   * Returns the scheme to use for the transport URLs.
   *
   * @api private
   */

  XHR.prototype.scheme = function () {
    return this.socket.options.secure ? 'https' : 'http';
  };

  /**
   * Check if the XHR transports are supported
   *
   * @param {Boolean} xdomain Check if we support cross domain requests.
   * @returns {Boolean}
   * @api public
   */

  XHR.check = function (socket, xdomain) {

    try {
      var request = io.util.request(xdomain),
          usesXDomReq = (global.XDomainRequest && request instanceof XDomainRequest),
          socketProtocol = (socket && socket.options && socket.options.secure ? 'https:' : 'http:'),
          isXProtocol = (socketProtocol != global.location.protocol);
      if (request && !(usesXDomReq && isXProtocol)) {
        return true;
      }
    } catch(e) {}

    return false;
  };

  /**
   * Check if the XHR transport supports cross domain requests.
   *
   * @returns {Boolean}
   * @api public
   */

  XHR.xdomainCheck = function () {
    return XHR.check(null, true);
  };

  /**
   * Clears the event listeners attached to the XHR transport object.
   *
   * @api private
   */
  XHR.prototype.clearEventHandlers = function () {
      if (this.sendXHR) {
          this.sendXHR.onreadystatechange = this.sendXHR.onload = empty;
      }
      return this;
  };

})(
    'undefined' != typeof io ? io.Transport : module.exports
  , 'undefined' != typeof io ? io : module.parent.exports
  , 'undefined' === typeof global ? window : global
);

/**
 * socket.io
 * Copyright(c) 2011 LearnBoost <dev@learnboost.com>
 * MIT Licensed
 */

(function (exports, io, global) {

  /**
   * Expose constructor.
   */

  exports['xhr-polling'] = XHRPolling;

  /**
   * The XHR-polling transport uses long polling XHR requests to create a
   * "persistent" connection with the server.
   *
   * @constructor
   * @api public
   */

  function XHRPolling () {
    io.Transport.XHR.apply(this, arguments);
  };

  /**
   * Inherits from XHR transport.
   */

  io.util.inherit(XHRPolling, io.Transport.XHR);

  /**
   * Merge the properties from XHR transport
   */

  io.util.merge(XHRPolling, io.Transport.XHR);

  /**
   * Transport name
   *
   * @api public
   */

  XHRPolling.prototype.name = 'xhr-polling';

  /**
   * Establish a connection, for iPhone and Android this will be done once the page
   * is loaded.
   *
   * @returns {Transport} Chaining.
   * @api public
   */

  XHRPolling.prototype.open = function (connectErrorCallback) {
    var self = this;

    self.connectErrorCallback = connectErrorCallback;

    io.Transport.XHR.prototype.open.call(self);
    return false;
  };

  /**
   * Starts a XHR request to wait for incoming messages.
   *
   * @api private
   */

  function empty () {};

  XHRPolling.prototype.get = function () {
    if (!this.isOpened) return;

    var self = this;

    function stateChange () {
      if (this.readyState == 4) {
        this.onreadystatechange = empty;

        if (this.status == 200) {
          self.connectErrorCallback = undefined;
          self.onData(this.responseText);
          self.get();
        } else {
          self.onClose();

          if (self.connectErrorCallback !== undefined) {
            self.connectErrorCallback();
            self.connectErrorCallback = undefined;
          }
        }
      }
    };

    function onload () {
      self.connectErrorCallback = undefined;
      this.onload = empty;
      this.onerror = empty;
      self.onData(this.responseText);
      self.get();
    };

    function onerror () {
      self.onClose();

      if (self.connectErrorCallback !== undefined) {
        self.connectErrorCallback();
        self.connectErrorCallback = undefined;
      }
    };

    this.xhr = this.request();

    if (global.XDomainRequest && this.xhr instanceof XDomainRequest) {
      this.xhr.onload = onload;
      this.xhr.onerror = onerror;
    } else {
      this.xhr.onreadystatechange = stateChange;
    }

    this.xhr.send(null);
  };

  /**
   * Handle the unclean close behavior.
   *
   * @api private
   */

  XHRPolling.prototype.onClose = function () {
    io.Transport.XHR.prototype.onClose.call(this);

    if (this.xhr) {
      this.xhr.onreadystatechange = this.xhr.onload = this.xhr.onerror = empty;
      try {
        this.xhr.abort();
      } catch(e){}
      this.xhr = null;
    }
  };

  /**
   * Webkit based browsers show a infinit spinner when you start a XHR request
   * before the browsers onload event is called so we need to defer opening of
   * the transport until the onload event is called. Wrapping the cb in our
   * defer method solve this.
   *
   * @param {Socket} socket The socket instance that needs a transport
   * @param {Function} fn The callback
   * @api private
   */

  XHRPolling.prototype.ready = function (socket, fn) {
    var self = this;

    io.util.defer(function () {
      fn.call(self);
    });
  };

   /**
   * Clears the event listeners attached to the XHR transport object.
   *
   * @api private
   */
  XHRPolling.prototype.clearEventHandlers = function () {
      io.Transport.XHR.prototype.clearEventHandlers.call(this);

      if (this.xhr) {
          this.xhr.onreadystatechange = this.xhr.onload = this.xhr.onerror = empty;
      }
      return this;
  }

  /**
   * Add the transport to your public io.transports array.
   *
   * @api private
   */

  io.transports.push('xhr-polling');

})(
    'undefined' != typeof io ? io.Transport : module.exports
  , 'undefined' != typeof io ? io : module.parent.exports
  , 'undefined' === typeof global ? window : global
);

exports.io = io;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13), __webpack_require__(14)(module)))

/***/ }),
/* 13 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionTracker = exports.Properties = exports.TrackerStep = exports.ClientEventName = exports.ResponseData = void 0;
var Common_1 = __webpack_require__(3);
var Constants_1 = __webpack_require__(1);
var Logger_1 = __webpack_require__(0);
/**
 * Data for trouter response
 */
var ResponseData = /** @class */ (function () {
    function ResponseData(id) {
        this.id = id;
        this.status = 200;
        this.headers = {};
        this.body = '';
    }
    return ResponseData;
}());
exports.ResponseData = ResponseData;
// Possible telemetry events
var ClientEventName;
(function (ClientEventName) {
    ClientEventName["Connected"] = "trouter_js_client_connected";
    ClientEventName["Disconnected"] = "trouter_js_client_disconnected";
    ClientEventName["Error"] = "trouter_js_client_error";
    ClientEventName["Progress"] = "trouter_js_client_progress";
    ClientEventName["Response"] = "trouter_js_client_response";
    ClientEventName["Request"] = "trouter_js_client_request";
    ClientEventName["CheckConnection"] = "trouter_js_client_check_connection";
    ClientEventName["Registration"] = "trouter_js_client_registration";
    ClientEventName["Unregistration"] = "trouter_js_client_unregistration";
})(ClientEventName || (exports.ClientEventName = ClientEventName = {}));
/**
 * Stores one step of connection process
 */
var TrackerStep = /** @class */ (function () {
    function TrackerStep(stepName, operation, delta, ts, error) {
        this.stepName = stepName;
        this.operation = operation;
        this.delta = delta;
        this.ts = ts;
        this.error = error;
    }
    return TrackerStep;
}());
exports.TrackerStep = TrackerStep;
/**
 * Base class for something that can be used as a property bag
 */
var Properties = /** @class */ (function () {
    function Properties() {
    }
    return Properties;
}());
exports.Properties = Properties;
/**
 * Information about connection
 */
var ConnectedInfo = /** @class */ (function () {
    function ConnectedInfo() {
        this.numberOfPingReplies = 0;
        this.connectedTimestamp = 0;
        this.isNewUrl = false;
        this.transportType = '';
        this.connectionNumber = 0;
    }
    return ConnectedInfo;
}());
/**
 * Default values for IEventLogSettings
 */
var EventLogSettings = /** @class */ (function () {
    function EventLogSettings() {
        this.enabled = false;
        this.numberOfStepsToMaintain = 40;
        this.logHealthCheckError = false;
        this.sendProgressTimeoutSecs = 55;
        this.logSendPingError = false;
        this.maxBackoffInMs = 120000;
        this.trouter_js_client_connected = false;
        this.trouter_js_client_disconnected = false;
        this.trouter_js_client_error = false;
        this.trouter_js_client_progress = false;
        this.trouter_js_client_response = false;
        this.trouter_js_client_request = false;
        this.trouter_js_client_registration = false;
        this.trouter_js_client_unregistration = false;
        /** This event is ENABLED by default */
        this.trouter_js_client_check_connection = true;
    }
    return EventLogSettings;
}());
/**
 * Telemetry sender
 */
var ConnectionTracker = /** @class */ (function () {
    function ConnectionTracker(logfunc, clientId, clientInfo, getServerState, endpointId, clientCorrelationID, environment) {
        this.clientId = clientId;
        this.clientInfo = clientInfo;
        this.getServerState = getServerState;
        this.endpointId = endpointId;
        this.clientCorrelationID = clientCorrelationID;
        this.environment = environment;
        this.logger = new Logger_1.Logger('ConnectionTracker', logfunc);
        this.clientCorrelationID = clientCorrelationID !== undefined ? clientCorrelationID : '';
        this.steps = [];
        this.connectionAttempt = 0;
        this.totalStepCount = 0;
        this.beginTimestamp = new Common_1.Timespan();
        this.eventLogSettings = new EventLogSettings();
        this.connectedInfo = new ConnectedInfo();
    }
    ConnectionTracker.prototype.enable = function (telemetrySender) {
        this.eventLogSettings.enabled = true;
        this.eventLogger = telemetrySender;
    };
    ConnectionTracker.prototype.disable = function () {
        this.eventLogSettings.enabled = false;
    };
    ConnectionTracker.prototype.sendProgress = function (context) {
        // connect truncates steps array. this check ensures that a progress event is only sent out if the client is not connected
        if (this.steps.length > 0) {
            this.sendTelemetry(ClientEventName.Progress, context, this.steps);
        }
    };
    ConnectionTracker.prototype.cancelProgressTimer = function () {
        if (this.progressTimeout !== undefined) {
            clearTimeout(this.progressTimeout);
            this.progressTimeout = undefined;
        }
    };
    ConnectionTracker.prototype.resetProgressSendTimer = function () {
        var _this = this;
        this.cancelProgressTimer();
        // send connection steps after a timeout
        // this timeout may fire if auth callback never comes or the client is stuck in a loop to get connected
        if (this.eventLogSettings.sendProgressTimeoutSecs !== undefined && this.eventLogSettings.sendProgressTimeoutSecs > 0) {
            this.progressTimeout = setTimeout(function () {
                _this.sendProgress({
                    reason: 'timeout',
                    timeoutSecs: _this.eventLogSettings.sendProgressTimeoutSecs
                });
            }, 1000 * this.eventLogSettings.sendProgressTimeoutSecs);
        }
    };
    ConnectionTracker.prototype.setConnectedInfo = function (isNewUrl, transportType) {
        this.connectedInfo.numberOfPingReplies = 0;
        this.connectedInfo.connectedTimestamp = Date.now();
        this.connectedInfo.isNewUrl = isNewUrl;
        this.connectedInfo.transportType = transportType;
        ++this.connectedInfo.connectionNumber;
    };
    ConnectionTracker.prototype.clearConnectedInfo = function () {
        this.connectedInfo.numberOfPingReplies = 0;
        this.connectedInfo.connectedTimestamp = 0;
        this.connectedInfo.isNewUrl = true;
        this.connectedInfo.transportType = '';
    };
    // Copies from
    // source {
    //    propName: value
    // }
    // to
    // dest {
    //    propName: { value: actualValue }
    // }
    ConnectionTracker.prototype.copyProperties = function (dest, source) {
        // copy properties from source and add in a format expected by logger
        for (var _i = 0, _a = Object.keys(source); _i < _a.length; _i++) {
            var prop = _a[_i];
            if (source[prop] !== undefined) {
                // replace hyphen by _
                dest[prop.replace(/-/g, '_')] = { value: source[prop] };
            }
        }
    };
    ConnectionTracker.prototype.increasePingResponseCount = function () {
        ++this.connectedInfo.numberOfPingReplies;
    };
    /**
     * @param eventName Telemetry event name
     * @param eventProperties Event property bag
     * @param progress
     */
    ConnectionTracker.prototype.sendTelemetry = function (eventName, eventProperties, progress) {
        try {
            if (this.eventLogSettings.enabled === true
                && this.eventLogSettings[eventName] === true
                && this.eventLogger !== undefined) {
                var serverState = this.getServerState();
                var clientEvent = {
                    name: eventName,
                    properties: {
                        connectionAttempt: { value: this.connectionAttempt },
                        epid: { value: this.endpointId },
                        clientCorrelationID: { value: this.clientCorrelationID },
                        steps: { value: (0, Common_1.toJson)(progress) },
                        clientID: { value: this.clientId },
                        eventVersion: { value: 3 },
                        environment: { value: this.environment },
                        cv: { value: Constants_1.CLIENT_VERSION },
                        ua: { value: this.clientInfo.ua },
                        // Copy ServerState
                        connectionId: { value: serverState.connectionId },
                        connectedClientId: { value: serverState.connectedClientId },
                        domId: { value: serverState.domId },
                        url: { value: serverState.unsecureUrl },
                        surl: { value: serverState.url },
                        ttlInSecs: { value: serverState.getRemainingTtlInSec() },
                        // Copy this.connectedInfo
                        numberOfPingReplies: { value: this.connectedInfo.numberOfPingReplies },
                        connectedTimestamp: { value: this.connectedInfo.connectedTimestamp },
                        isNewUrl: { value: this.connectedInfo.isNewUrl },
                        transportType: { value: this.connectedInfo.transportType },
                        connectionNumber: { value: this.connectedInfo.connectionNumber }
                    }
                };
                this.copyProperties(clientEvent.properties, eventProperties);
                this.eventLogger.logEvent(clientEvent);
            }
        }
        catch (exc) {
            this.logger.warn("error in sending event ".concat(eventName, ": ").concat((0, Common_1.toJson)(exc)));
        }
    };
    ConnectionTracker.prototype.createStep = function (stepName, operation, error) {
        return new TrackerStep(stepName, operation, this.beginTimestamp.duration, Date.now(), error);
    };
    ConnectionTracker.prototype.addStep = function (tag, progressHint, error) {
        if (this.eventLogSettings.enabled === false) {
            return;
        }
        if (this.steps.length === 0) {
            this.beginTimestamp.reset();
        }
        this.steps.push(this.createStep(tag, progressHint, error));
        ++this.totalStepCount;
        // do not maintain an ever growing list of steps. send a progress event with what is collected so far and clear steps
        // there should be enough context in any event for the server to group events created for the sameonnection
        if (this.eventLogSettings.numberOfStepsToMaintain !== undefined
            && this.steps.length > this.eventLogSettings.numberOfStepsToMaintain) {
            var progress = this.steps.slice(0);
            this.steps.length = 0;
            this.sendTelemetry(ClientEventName.Progress, { reason: 'flush' }, progress);
        }
    };
    ConnectionTracker.prototype.trackStart = function (tag) {
        this.addStep(tag, 'start');
    };
    ConnectionTracker.prototype.trackEnd = function (tag) {
        this.addStep(tag, 'end');
    };
    ConnectionTracker.prototype.trackError = function (tag, error, addStep, subOperation) {
        if (addStep === void 0) { addStep = true; }
        if (tag === 'health' && this.eventLogSettings.logHealthCheckError !== true) {
            return;
        }
        if (tag === 'ping' && this.eventLogSettings.logSendPingError === false) {
            return;
        }
        if (subOperation === undefined) {
            subOperation = 'error';
        }
        if (addStep === true) {
            this.addStep(tag, subOperation, error);
        }
        this.sendTelemetry(ClientEventName.Error, {}, [this.createStep(tag, subOperation, error)]);
    };
    ConnectionTracker.prototype.trackProgress = function (tag, subOperation) {
        this.addStep(tag, subOperation);
    };
    ConnectionTracker.prototype.trackConnected = function (isNewUrl, transportType) {
        this.setConnectedInfo(isNewUrl, transportType);
        var progress = this.steps.slice(0);
        var totalSteps = this.totalStepCount;
        var connectionDuration = this.beginTimestamp.duration;
        // clear steps collected
        this.steps.length = 0;
        this.totalStepCount = 0;
        this.sendTelemetry(ClientEventName.Connected, {
            stepCount: progress.length,
            totalStepCount: totalSteps,
            connectionEstablishmentMs_Total: connectionDuration
        }, progress);
        this.cancelProgressTimer();
    };
    ConnectionTracker.prototype.getSessionLength = function () {
        return Date.now() - this.connectedInfo.connectedTimestamp;
    };
    ConnectionTracker.prototype.trackDisconnected = function (context) {
        context.sessionLengthMS = this.getSessionLength();
        this.sendTelemetry(ClientEventName.Disconnected, context, []);
        this.resetProgressSendTimer();
    };
    ConnectionTracker.prototype.trackNewConnection = function () {
        ++this.connectionAttempt;
    };
    ConnectionTracker.prototype.trackRequest = function (request, errorMsg) {
        var context = {};
        if (errorMsg !== undefined) {
            context.hasError = true;
            context.error = errorMsg;
        }
        try {
            if (request) {
                context.requestID = request.id;
                context.httpMethod = request.method;
                context.url = request.url;
                context.bodyLength = request.body.length;
                context.shortUrl = request.shortUrl;
                context.requestTimeStamp = request.startTS;
                context.correlationVector = request.correlationVector;
                var headers = request.headers;
                for (var _i = 0, _a = Object.keys(headers); _i < _a.length; _i++) {
                    var header = _a[_i];
                    context[header] = headers[header];
                }
            }
        }
        catch (exc) {
            context.hasError = true;
            context.error = "".concat(context.error, " error creating request context ").concat((0, Common_1.toJson)(exc));
        }
        this.sendTelemetry(ClientEventName.Request, context, []);
    };
    ConnectionTracker.prototype.trackResponse = function (request, latencyMS, responseData, errorMsg) {
        var context = {};
        if (errorMsg !== undefined) {
            context.hasError = true;
            context.error = errorMsg;
        }
        try {
            context.responseTimestamp = responseData !== undefined ? responseData.sentTS : Date.now();
            if (request) {
                context.requestID = request.id;
                context.httpMethod = request.method;
                context.shortUrl = request.shortUrl;
                context.correlationVector = request.correlationVector;
                var headers = request.headers;
                for (var _i = 0, _a = Object.keys(headers); _i < _a.length; _i++) {
                    var header = _a[_i];
                    context[header] = headers[header];
                }
            }
            if (responseData) {
                context.latencyMS = latencyMS;
                context.responseCode = responseData.status;
                context.responseLength = responseData.body.length;
            }
        }
        catch (exc) {
            context.hasError = true;
            context.error = "".concat(context.error, " error creating response context ").concat((0, Common_1.toJson)(exc));
        }
        this.sendTelemetry(ClientEventName.Response, context, []);
    };
    ConnectionTracker.prototype.sendResponseError = function (errorMsg, request, responseData) {
        this.trackResponse(request, undefined, responseData, errorMsg);
    };
    ConnectionTracker.prototype.close = function () {
        this.sendProgress({
            reason: 'closed'
        });
        this.steps.length = 0;
        this.cancelProgressTimer();
    };
    ConnectionTracker.prototype.mergeSettings = function (settings) {
        if (!settings) {
            return;
        }
        this.eventLogSettings.numberOfStepsToMaintain = Math.min(40, Math.max(10, (settings.numberOfStepsToMaintain !== undefined ? settings.numberOfStepsToMaintain : 0)));
        // min of 55 secs and max allowed is 1 hr
        var newProgressTimeout = Math.min(3600, Math.max(55, settings.sendProgressTimeoutSecs !== undefined ? settings.sendProgressTimeoutSecs : 0));
        this.eventLogSettings.logHealthCheckError = settings.logHealthCheckError;
        this.eventLogSettings.logSendPingError = settings.logSendPingError;
        // Copy enable/disable flags for all telemetry events
        for (var _i = 0, _a = Object.keys(ClientEventName).map(function (k) { return ClientEventName[k]; }); _i < _a.length; _i++) {
            var iterator = _a[_i];
            if (settings[iterator] !== undefined) {
                this.eventLogSettings[iterator] = settings[iterator];
            }
        }
        if (this.eventLogSettings.sendProgressTimeoutSecs !== newProgressTimeout) {
            this.eventLogSettings.sendProgressTimeoutSecs = newProgressTimeout;
            this.resetProgressSendTimer();
        }
    };
    return ConnectionTracker;
}());
exports.ConnectionTracker = ConnectionTracker;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisconnectReason = void 0;
/**
 * Disconnect reason format sent when using the /v4/c protocol as part of the socket.io disconnect (`0::`),
 * e.g.
 * - `0::`
 * - `0:::dup`
 * - `0:::{"reason":"unauthorized","claims":"Bearer token_types=\"skype,aad,cae\""}`
 *
 * Additionally, it is also used internally for other socket.io events calling `TrouterFsm.onSocketDisconnect` (see usages).
 */
var DisconnectReason = /** @class */ (function () {
    function DisconnectReason(reason, claims, details) {
        this.reason = reason;
        this.claims = claims;
        this.details = details;
    }
    DisconnectReason.fromRawReason = function (rawReason, logger) {
        if (rawReason === '' || rawReason === 'dup') {
            return new DisconnectReason(rawReason);
        }
        try {
            var parsedReason = JSON.parse(rawReason);
            if (typeof parsedReason !== 'object' || parsedReason.reason === undefined) {
                logger === null || logger === void 0 ? void 0 : logger.error('invalid disconnect reason format');
                return new DisconnectReason('unknown', undefined, rawReason);
            }
            return new DisconnectReason(parsedReason.reason, parsedReason.claims, parsedReason.details);
        }
        catch (e) {
            // Non-JSON string from the `0::` socket.io message is just set "as is" as details
            return new DisconnectReason('disconnect', undefined, rawReason);
        }
    };
    DisconnectReason.fromSocketIoEventData = function (event, arg) {
        return typeof arg === 'string' ? new DisconnectReason(event, undefined, arg) : undefined;
    };
    DisconnectReason.prototype.toTelemetryString = function () {
        if (this.reason === 'socketerror' || this.reason === 'reconnecterror' || this.reason === 'disconnect') {
            return this.details;
        }
        return this.reason;
    };
    return DisconnectReason;
}());
exports.DisconnectReason = DisconnectReason;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExponentialBackoff = void 0;
/**
 * Executes callbacks with exponential backoff
 */
var ExponentialBackoff = /** @class */ (function () {
    function ExponentialBackoff(logger, maxBackoffInMs, gapDetectionSettings) {
        if (gapDetectionSettings === void 0) { gapDetectionSettings = { tolerance: 2, minimumWaitMs: 10000 }; }
        this.logger = logger;
        this.maxBackoffInMs = maxBackoffInMs;
        this.gapDetectionSettings = gapDetectionSettings;
        this.backoffId = 0;
        this.backoffCount = 0;
    }
    ExponentialBackoff.calculateNextBackoffMs = function (backoffCount, maxBackoffInMs) {
        var fudge = 1 + (Math.random() - 0.5) * 0.4; // +/- 20%
        var backoff = 1000 * Math.pow(2, backoffCount) * fudge; // 1s initial
        backoff = Math.round(backoff);
        return Math.min(maxBackoffInMs, backoff);
    };
    ExponentialBackoff.prototype.setMaxBackoffMs = function (ms) {
        this.maxBackoffInMs = ms;
    };
    ExponentialBackoff.prototype.backoff = function (taskName, handler) {
        var _this = this;
        if (this.timerHandle !== undefined) {
            this.logger.debug('Clearing current back off');
            clearTimeout(this.timerHandle);
            this.timerHandle = undefined;
        }
        // This detects a situation where the computer/tab likely went to sleep while NOT waiting on backoff,
        // but doing other things (e.g. waiting on fetch, waiting on token provider, etc.),
        // and woke up much later, the operation having failed, triggering a retry after backoff.
        // If a lot of time has passed in sleep, we want to reset that backoff.
        //
        // We are counting on the fact that the operation (fetch, token wait, etc.) should never take significantly longer
        // than the maximum allowed backoff time, to avoid unwanted resets.
        //
        // (If computer woke up while it WAS waiting on backoff, after a long time, it would likely complete that wait
        // immediately, so previousCompleteTime would be very close to the next attempt, thus not triggering this.)
        if (this.previousCompleteTime !== undefined) {
            var elapsed = Date.now() - this.previousCompleteTime;
            // The time to reset this needs to be much longer here, as the operation itself can take quite a long time even under normal circumstances.
            // In practice, based on settings as of February 2024, this can be triggered after a sleep that in some cases needs to be over 10 minutes.
            if (elapsed > this.maxBackoffInMs * this.gapDetectionSettings.tolerance && elapsed > this.gapDetectionSettings.minimumWaitMs) {
                this.logger.info("Back off for ".concat(taskName, " with ID ").concat(this.backoffId, " will be reset due to a lot of time having passed since the previous backoff (").concat(elapsed, " ms)"));
                this.backoffCount = 0;
                this.previousCompleteTime = undefined;
            }
        }
        var backoffMs = ExponentialBackoff.calculateNextBackoffMs(this.backoffCount, this.maxBackoffInMs);
        this.backoffId++;
        this.backoffCount++;
        this.logger.info("Backing off ".concat(taskName, " for ").concat(backoffMs, " milliseconds with ID ").concat(this.backoffId));
        this.callback = function (waitStart, expectedWait) {
            if (shouldReset(waitStart, expectedWait, _this.gapDetectionSettings)) {
                // Most likely computer/tab went to sleep while waiting on backoff and woke up much later
                _this.logger.info("Back off for ".concat(taskName, " with ID ").concat(_this.backoffId, " will be reset due to the wait (").concat(Date.now() - (waitStart !== null && waitStart !== void 0 ? waitStart : 0), " ms) being longer than expected (").concat(expectedWait, " ms)"));
                _this.backoffCount = 0;
            }
            _this.logger.info("Back off for ".concat(taskName, " with ID ").concat(_this.backoffId, " complete, invoking handler"));
            _this.timerHandle = undefined;
            _this.callback = undefined;
            _this.previousCompleteTime = Date.now();
            handler();
        };
        var backoffWaitStart = Date.now();
        this.timerHandle = setTimeout(function () { var _a; return (_a = _this.callback) === null || _a === void 0 ? void 0 : _a.call(_this, backoffWaitStart, backoffMs); }, backoffMs);
    };
    /// Stop the backoff if active, do not call the handler and reset to the initial/shortest period again
    ExponentialBackoff.prototype.reset = function () {
        if (this.timerHandle !== undefined) {
            this.logger.debug("Resetting back off with ID ".concat(this.backoffId));
            clearTimeout(this.timerHandle);
            this.timerHandle = undefined;
            this.callback = undefined;
        }
        this.backoffCount = 0;
    };
    /// Call the handler right now if active and reset to the initial/shortest period again
    ExponentialBackoff.prototype.expediteIfPending = function () {
        this.backoffCount = 0;
        if (this.timerHandle !== undefined) {
            this.logger.debug("Expediting back off with ID ".concat(this.backoffId));
            clearTimeout(this.timerHandle);
            this.timerHandle = undefined;
            var callback = this.callback;
            this.callback = undefined;
            if (callback) {
                callback();
            }
        }
    };
    return ExponentialBackoff;
}());
exports.ExponentialBackoff = ExponentialBackoff;
function shouldReset(waitStart, expectedWait, settings) {
    if (waitStart === undefined || expectedWait === undefined) {
        return false;
    }
    var actualWait = Date.now() - waitStart;
    return actualWait > expectedWait * settings.tolerance && actualWait > settings.minimumWaitMs;
}


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggingManagerConsumer = exports.RegistrationEnforcer = void 0;
var TrouterFsm_1 = __webpack_require__(6);
/**
 * Intercepts calls from TrouterConnection to TrouterManager, to only allow
 * switching to the "connected" state after the connection
 * has been successfully registered, and disconnects Trouter if an existing
 * registration expires or gets revoked.
 *
 * One instance of this wrappere exists per each TrouterConnection (though wrapping the same TrouterManger instance),
 * this object thus holds state specific to a particular TrouterConnection.
 */
var RegistrationEnforcer = /** @class */ (function () {
    function RegistrationEnforcer(wrapped, shouldConnectionDependOnRegistration, shouldHoldBackEvents) {
        this.wrapped = wrapped;
        this.shouldConnectionDependOnRegistration = shouldConnectionDependOnRegistration;
        this.shouldHoldBackEvents = shouldHoldBackEvents;
        this.isRegistered = false;
        this.heldBackEvents = [];
    }
    RegistrationEnforcer.prototype.onDownstreamRequest = function (connection, request, response) {
        this.passIfRegisteredOrNotNeeded('onDownstreamRequest', connection, request, response);
    };
    RegistrationEnforcer.prototype.onConnected = function (connection) {
        this.passIfRegisteredOrNotNeeded('onConnected', connection);
    };
    RegistrationEnforcer.prototype.onRegistered = function (connection) {
        this.isRegistered = true;
        this.wrapped.onRegistered(connection);
        this.fireHeldBackEvents();
    };
    RegistrationEnforcer.prototype.onUnregistered = function (connection) {
        this.isRegistered = false;
        this.wrapped.onUnregistered(connection);
        if (connection.getState() === TrouterFsm_1.State.Connected && this.shouldConnectionDependOnRegistration()) {
            connection.forceReconnectDueToNoRegistration();
        }
    };
    RegistrationEnforcer.prototype.onReconnecting = function (connection) {
        this.wrapped.onReconnecting(connection);
    };
    RegistrationEnforcer.prototype.onReconnectIsRequired = function (connection, useConnectParamsFromCache, reason) {
        this.wrapped.onReconnectIsRequired(connection, useConnectParamsFromCache, reason);
    };
    RegistrationEnforcer.prototype.onDisconnected = function (connection) {
        this.isRegistered = false;
        this.dropHeldBackEvents();
        this.wrapped.onDisconnected(connection);
    };
    RegistrationEnforcer.prototype.onTerminalError = function (connection) {
        this.wrapped.onTerminalError(connection);
    };
    RegistrationEnforcer.prototype.onConnectionParametersUpdated = function (connectParams) {
        this.wrapped.onConnectionParametersUpdated(connectParams);
    };
    RegistrationEnforcer.prototype.onTrouterMessageLost = function (flowTags) {
        this.passIfRegisteredOrNotNeeded('onTrouterMessageLost', flowTags);
    };
    RegistrationEnforcer.prototype.onUserActivityStateAccepted = function (cv) {
        this.passIfRegisteredOrNotNeeded('onUserActivityStateAccepted', cv);
    };
    RegistrationEnforcer.prototype.onAudiencesSetResolved = function (audienceSubscriptionsResponse, cv) {
        this.passIfRegisteredOrNotNeeded('onAudiencesSetResolved', audienceSubscriptionsResponse, cv);
    };
    RegistrationEnforcer.prototype.getState = function () {
        return this.wrapped.getState();
    };
    RegistrationEnforcer.prototype.holdBackEvent = function (kind) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.heldBackEvents.push({ kind: kind, args: args });
    };
    RegistrationEnforcer.prototype.passIfRegisteredOrNotNeeded = function (kind) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var connectionDependsOnRegistration = this.shouldConnectionDependOnRegistration();
        var holdBackEvents = this.shouldHoldBackEvents();
        // replay existing events if we previously needed registration but now don't, or if we should not hold back events anymore
        if (!connectionDependsOnRegistration || !holdBackEvents) {
            this.fireHeldBackEvents(connectionDependsOnRegistration ?
                function (e) { return e.kind !== 'onConnected'; } :
                undefined);
        }
        if (this.isRegistered || !connectionDependsOnRegistration || (holdBackEvents === false && kind !== 'onConnected')) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-return,@typescript-eslint/no-explicit-any
            (_a = this.wrapped)[kind].apply(_a, args);
        }
        else {
            this.holdBackEvent.apply(this, __spreadArray([kind], args, false));
        }
    };
    RegistrationEnforcer.prototype.fireHeldBackEvents = function (filter) {
        var _a;
        for (var _i = 0, _b = this.heldBackEvents; _i < _b.length; _i++) {
            var event_1 = _b[_i];
            if (filter !== undefined && !filter(event_1)) {
                continue;
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-return,@typescript-eslint/no-explicit-any
            (_a = this.wrapped)[event_1.kind].apply(_a, event_1.args);
        }
        if (filter === undefined) {
            this.heldBackEvents = [];
        }
        else {
            // keep everything that wasn't fired
            this.heldBackEvents = this.heldBackEvents.filter(function (e) { return !filter(e); });
        }
    };
    RegistrationEnforcer.prototype.dropHeldBackEvents = function () {
        this.heldBackEvents = [];
    };
    return RegistrationEnforcer;
}());
exports.RegistrationEnforcer = RegistrationEnforcer;
/**
 * Wrapper for debugging and tests, can be used to compare
 * the original and filtered events, by creating e.g.
 * ```
 * new LoggingManagerConsumer(
 *   new RegistrationEnforcer(
 *     new LoggingManagerConsumer(this, 'inner'),
 *     true
 *   ),
 * 'outer')
 * ```
 * where the outer one will log all the calls from TrouterConnection,
 * and the inner one will only log the calls that go through (with the
 * resulting order/delay/etc.)
 */
var LoggingManagerConsumer = /** @class */ (function () {
    function LoggingManagerConsumer(wrapped, prefix, logger, onEventAction) {
        this.wrapped = wrapped;
        this.prefix = prefix;
        this.logger = logger;
        this.onEventAction = onEventAction;
    }
    LoggingManagerConsumer.prototype.onEvent = function (name, jsonArgs) {
        var _a;
        if (this.onEventAction !== undefined) {
            this.onEventAction(name, jsonArgs);
        }
        else {
            ((_a = this.logger) !== null && _a !== void 0 ? _a : console).log("".concat(this.prefix, " TracingEnforcer: ").concat(name, "(").concat(jsonArgs, ")"));
        }
    };
    LoggingManagerConsumer.prototype.onDownstreamRequest = function (connection, request, response) {
        this.onEvent('onDownstreamRequest', JSON.stringify({ request: request, response: response }));
        this.wrapped.onDownstreamRequest(connection, request, response);
    };
    LoggingManagerConsumer.prototype.onConnected = function (connection) {
        this.onEvent('onConnected', connection.getState().toString());
        this.wrapped.onConnected(connection);
    };
    LoggingManagerConsumer.prototype.onRegistered = function (connection) {
        this.onEvent('onRegistered', connection.getState().toString());
        this.wrapped.onRegistered(connection);
    };
    LoggingManagerConsumer.prototype.onUnregistered = function (connection) {
        this.onEvent('onUnregistered', connection.getState().toString());
        this.wrapped.onUnregistered(connection);
    };
    LoggingManagerConsumer.prototype.onReconnecting = function (connection) {
        this.onEvent('onReconnecting', connection.getState().toString());
        this.wrapped.onReconnecting(connection);
    };
    LoggingManagerConsumer.prototype.onReconnectIsRequired = function (connection, useConnectParamsFromCache, reason) {
        this.onEvent('onReconnectIsRequired', JSON.stringify({ connection: connection.getState().toString(), useConnectParamsFromCache: useConnectParamsFromCache, reason: reason }));
        this.wrapped.onReconnectIsRequired(connection, useConnectParamsFromCache, reason);
    };
    LoggingManagerConsumer.prototype.onDisconnected = function (connection) {
        this.onEvent('onDisconnected', connection.getState().toString());
        this.wrapped.onDisconnected(connection);
    };
    LoggingManagerConsumer.prototype.onTerminalError = function (connection) {
        this.onEvent('onTerminalError', JSON.stringify({ connection: connection }));
        this.wrapped.onTerminalError(connection);
    };
    LoggingManagerConsumer.prototype.onConnectionParametersUpdated = function (connectParams) {
        this.onEvent('onConnectionParametersUpdated', JSON.stringify({ connectParams: connectParams }));
        this.wrapped.onConnectionParametersUpdated(connectParams);
    };
    LoggingManagerConsumer.prototype.onTrouterMessageLost = function (flowTags) {
        this.onEvent('onTrouterMessageLost', JSON.stringify({ flowTags: flowTags }));
        this.wrapped.onTrouterMessageLost(flowTags);
    };
    LoggingManagerConsumer.prototype.onUserActivityStateAccepted = function (cv) {
        this.onEvent('onUserActivityStateAccepted', JSON.stringify({ cv: cv }));
        this.wrapped.onUserActivityStateAccepted(cv);
    };
    LoggingManagerConsumer.prototype.onAudiencesSetResolved = function (audienceSubscriptionsResponse, cv) {
        this.onEvent('onAudiencesSetResolved', JSON.stringify({ audienceSubscriptionsResponse: audienceSubscriptionsResponse, cv: cv }));
        this.wrapped.onAudiencesSetResolved(audienceSubscriptionsResponse, cv);
    };
    LoggingManagerConsumer.prototype.getState = function () {
        return this.wrapped.getState();
    };
    return LoggingManagerConsumer;
}());
exports.LoggingManagerConsumer = LoggingManagerConsumer;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrouterManagerFsm = void 0;
var Interfaces_1 = __webpack_require__(2);
var InternalInterfaces_1 = __webpack_require__(4);
var Logger_1 = __webpack_require__(0);
var TrouterConnection_1 = __webpack_require__(7);
/**
 * State machine for manager
 */
var TrouterManagerFsm = /** @class */ (function () {
    function TrouterManagerFsm(logFunc, worker) {
        this.worker = worker;
        this.state = InternalInterfaces_1.TrouterManagerState.Unknown;
        this.logger = new Logger_1.Logger('ManagerFsm', logFunc);
    }
    TrouterManagerFsm.prototype.start = function () {
        if (this.state === InternalInterfaces_1.TrouterManagerState.Unknown) {
            this.setState(InternalInterfaces_1.TrouterManagerState.Disconnected);
            this.worker.forceStopLingeringConnection();
            this.worker.startFirstConnection();
        }
        else {
            // Trouter is already running, but external code calling start()
            // is often triggered by some relevant external event (e.g. computer waking up),
            // so we want to retry immediately to not create unnecessary delays.
            this.logger.info("start called in state '".concat(InternalInterfaces_1.TrouterManagerState[this.state], "', expediting pending backoffs, if any"));
            this.worker.expediteBackoffOnConnections();
        }
    };
    TrouterManagerFsm.prototype.stop = function (dontUnregister) {
        if (this.state !== InternalInterfaces_1.TrouterManagerState.Unknown) {
            this.setState(InternalInterfaces_1.TrouterManagerState.Unknown);
            this.worker.stopFirstConnection(dontUnregister === true);
            this.worker.stopSecondConnection(dontUnregister === true);
        }
        else {
            this.showIgnored('stop');
        }
    };
    /** Returns current state */
    TrouterManagerFsm.prototype.getState = function () {
        switch (this.state) {
            case InternalInterfaces_1.TrouterManagerState.Unknown:
            case InternalInterfaces_1.TrouterManagerState.Connected:
            case InternalInterfaces_1.TrouterManagerState.Disconnected:
            case InternalInterfaces_1.TrouterManagerState.Switching:
                return this.state;
            case InternalInterfaces_1.TrouterManagerState.TerminalError:
                return Interfaces_1.TrouterState.Disconnected;
        }
    };
    TrouterManagerFsm.prototype.getInternalState = function () {
        return this.state;
    };
    TrouterManagerFsm.prototype.onConnected = function (first) {
        if (this.state === InternalInterfaces_1.TrouterManagerState.Disconnected && first) {
            if (this.worker.doesSecondConnectionExist()) {
                this.setState(InternalInterfaces_1.TrouterManagerState.Switching);
            }
            else {
                this.setState(InternalInterfaces_1.TrouterManagerState.Connected);
                this.worker.dispatchConnected();
            }
        }
        else {
            this.showIgnored("onConnected(".concat(first, ")"));
        }
    };
    TrouterManagerFsm.prototype.onRegistered = function (first) {
        if (this.state === InternalInterfaces_1.TrouterManagerState.Disconnected && !first) {
            this.setState(InternalInterfaces_1.TrouterManagerState.Connected);
            this.worker.switchConnections();
            this.worker.stopSecondConnection(true);
            this.worker.dispatchConnected();
        }
        else if (this.state === InternalInterfaces_1.TrouterManagerState.Switching && !first) {
            this.setState(InternalInterfaces_1.TrouterManagerState.Connected);
            this.worker.switchConnections();
            this.worker.stopSecondConnectionDelayed();
            this.worker.dispatchConnected();
        }
        else if (this.state === InternalInterfaces_1.TrouterManagerState.Disconnected && first) {
            // happens when reconnect prompts connection to the same instance which dispatches disconnect as duplicate (both on old connection)
            // at this point `first` is the new connection
            this.setState(InternalInterfaces_1.TrouterManagerState.Connected);
            this.worker.dispatchConnected();
        }
        this.worker.dispatchRegistrationState(true);
    };
    TrouterManagerFsm.prototype.onUnregistered = function (first) {
        if (first) {
            this.worker.dispatchRegistrationState(false);
        }
    };
    TrouterManagerFsm.prototype.onReconnecting = function (first) {
        if ((this.state === InternalInterfaces_1.TrouterManagerState.Connected || this.state === InternalInterfaces_1.TrouterManagerState.Switching) && first) {
            this.setState(InternalInterfaces_1.TrouterManagerState.Disconnected);
            this.worker.dispatchDisconnected();
        }
        else {
            this.showIgnored("onReconnecting(".concat(first, ")"));
        }
    };
    TrouterManagerFsm.prototype.onReconnectionRequired = function (first, useConnectParamsFromCache, reason) {
        if (this.state === InternalInterfaces_1.TrouterManagerState.Connected && first) {
            this.setState(InternalInterfaces_1.TrouterManagerState.Switching);
            this.worker.startSecondConnection(useConnectParamsFromCache);
        }
        else if (this.state === InternalInterfaces_1.TrouterManagerState.Disconnected && first) {
            this.worker.startSecondConnection(useConnectParamsFromCache);
        }
        else if (this.state === InternalInterfaces_1.TrouterManagerState.Switching && first && reason === TrouterConnection_1.ReconnectReason.Configuration) {
            // Intentionally ignoring `trouter.reconnect` events arriving during an in-progress switch (on either connection),
            // only configuration change is handled. This matches the current behavior of the C++ client.
            // Even in the ignored cases, the client should still end up being connected to the right environment eventually.
            this.logger.debug('onReconnectionRequired: switch requested while already in Switching state');
            this.worker.stopSecondConnection(true);
            this.worker.startSecondConnection(useConnectParamsFromCache);
        }
        else {
            this.showIgnored("onReconnectionRequired(".concat(first, ")"));
        }
    };
    TrouterManagerFsm.prototype.onDisconnected = function (first) {
        if (this.state == InternalInterfaces_1.TrouterManagerState.Unknown && first) {
            // This is executed after an explicit stop()
            this.worker.dispatchDisconnected();
        }
        else if (this.state == InternalInterfaces_1.TrouterManagerState.Switching && first) {
            // The current/old connection got disconnected during a connection switch
            // (the disconnect would result only in onReconnecting() at other times,
            // when automatic reconnects are still enabled)
            this.worker.switchConnections();
            this.worker.stopSecondConnection(false);
            this.setState(InternalInterfaces_1.TrouterManagerState.Disconnected);
            this.worker.dispatchDisconnected();
        }
        else {
            this.showIgnored("onDisconnected(".concat(first, ")"));
        }
    };
    TrouterManagerFsm.prototype.onTerminalError = function () {
        this.setState(InternalInterfaces_1.TrouterManagerState.TerminalError);
        this.worker.dispatchTerminalError();
    };
    TrouterManagerFsm.prototype.showIgnored = function (event) {
        this.logger.info("Ignoring event '".concat(event, "' in state '").concat(InternalInterfaces_1.TrouterManagerState[this.state], "'"));
    };
    TrouterManagerFsm.prototype.setState = function (state) {
        this.logger.info("Switching from state '".concat(InternalInterfaces_1.TrouterManagerState[this.state], "' to state '").concat(InternalInterfaces_1.TrouterManagerState[state], "'"));
        if (this.state === state) {
            this.logger.error("Attempt to switch to the current state '".concat(InternalInterfaces_1.TrouterManagerState[state], "'"));
            return;
        }
        this.state = state;
    };
    return TrouterManagerFsm;
}());
exports.TrouterManagerFsm = TrouterManagerFsm;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceTrouterUrlBase = exports.getTrouterServiceVersion = exports.createTrouterService = exports.TrouterService = exports.UserActivityState = exports.TrouterState = void 0;
var Constants_1 = __webpack_require__(1);
var Interfaces_1 = __webpack_require__(2);
Object.defineProperty(exports, "TrouterState", { enumerable: true, get: function () { return Interfaces_1.TrouterState; } });
Object.defineProperty(exports, "UserActivityState", { enumerable: true, get: function () { return Interfaces_1.UserActivityState; } });
var Logger_1 = __webpack_require__(0);
var MessageHandler_1 = __webpack_require__(8);
var SkypeTokenProviderWithCache_1 = __webpack_require__(9);
var TrouterManager_1 = __webpack_require__(10);
var TrouterUrlPromise_1 = __webpack_require__(11);
function populateTelemetryOptions(startingCfg, ecsCfg) {
    if (!ecsCfg) {
        return startingCfg;
    }
    var res = __assign(__assign({}, startingCfg), {
        enabled: ecsCfg.TelemetryEnabled
    });
    if (ecsCfg.ClientTelemetryEventEnabled !== undefined) {
        res = __assign(__assign({}, res), ecsCfg.ClientTelemetryEventEnabled);
    }
    return res;
}
function populateTrouterOptions(cfg, logger, ecsCfg) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var rewriteUrlForProxyCallback = function (url) {
        if (cfg.proxyUrlRewrite) {
            logger.info('Using rewritten URL for proxy');
            return cfg.proxyUrlRewrite(url);
        }
        else {
            return url;
        }
    };
    return {
        clientInfo: {
            ua: cfg.trouterSettings.productName,
            v: cfg.trouterSettings.version
        },
        ioOptions: {
            // uncomment for manual testing
            // transports: ['xhr-polling'],
            // 'connect timeout': XXX, 10000 by default in socket.io code
            ackTimeoutMs: 5000,
            rewriteUrlForProxy: rewriteUrlForProxyCallback
        },
        clientCorrelationID: cfg.trouterSettings.sessionId,
        environment: cfg.trouterSettings.environment,
        telemetrySettings: populateTelemetryOptions(cfg.telemetryConfig.settings, ecsCfg),
        eventLogger: cfg.telemetryConfig.eventLogger,
        endpointId: cfg.trouterSettings.registrationId,
        // keeping existing behavior of || - using default value when there's empty string
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        trouterUrl: (ecsCfg === null || ecsCfg === void 0 ? void 0 : ecsCfg.TrouterConnectionUrl) || cfg.trouterSettings.trouterServiceUrl,
        registration: cfg.trouterSettings.registrarServiceUrl
            ? {
                registrarUrl: cfg.trouterSettings.registrarServiceUrl,
                registrationId: (_a = cfg.trouterSettings.registrationId) !== null && _a !== void 0 ? _a : '',
                pnhAppId: (_b = cfg.trouterSettings.pnhAppId) !== null && _b !== void 0 ? _b : '',
                platform: (_c = cfg.trouterSettings.platform) !== null && _c !== void 0 ? _c : '',
                pnhTemplateKey: (_d = cfg.trouterSettings.pnhTemplate) !== null && _d !== void 0 ? _d : '',
                platformUIVersion: (_e = cfg.trouterSettings.platformUIVersion) !== null && _e !== void 0 ? _e : '',
                // keeping existing behavior of || - using default value when there's empty string
                // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                productContext: cfg.trouterSettings.pnhProductContext || undefined,
                context: (_f = cfg.trouterSettings.pnhContext) !== null && _f !== void 0 ? _f : '',
                registrarTtlSec: ((_g = cfg.trouterSettings.maxRegistrationTimeInMs) !== null && _g !== void 0 ? _g : 0) / 1000
            }
            : undefined,
        connectionDependsOnRegistration: cfg.trouterSettings.registrarServiceUrl === undefined ?
            (function () { return false; }) :
            ((_h = cfg.trouterSettings.connectionDependsOnRegistration) !== null && _h !== void 0 ? _h : (function () { return false; })),
        delayEventsUntilRegistered: (_j = cfg.trouterSettings.delayEventsUntilRegistered) !== null && _j !== void 0 ? _j : (function () { return false; }),
        timeoutOptions: __assign({ 
            // keeping existing behavior of || - using default value when there's 0
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            connectionTimeoutMs: cfg.trouterSettings.trouterConnectTimeoutInMs || 30000, fetchTimeoutMs: 10000, pingTimeoutMs: 40000, pongTimeoutMs: 5000, 
            /** Followup WI to remove hardcoded value: https://domoreexp.visualstudio.com/MSTeams/_workitems/edit/2307271 */
            maxBackoffMs: cfg.trouterSettings.productName === 'TeamsCDL' ? 300000 : 30000, requestTimeoutMs: 5000, userActivityResponseTimeoutMs: 10000 }, cfg.trouterSettings.timeoutOptions),
        incallTimeoutOptions: __assign({ connectionTimeoutMs: 10000, fetchTimeoutMs: 5000, pingTimeoutMs: 5000, pongTimeoutMs: 2000, maxBackoffMs: cfg.trouterSettings.productName === 'TeamsCDL' ? 300000 : 10000, requestTimeoutMs: 5000, userActivityResponseTimeoutMs: 10000 }, cfg.trouterSettings.incallTimeoutOptions),
        incallModeTimeoutMs: (_k = cfg.trouterSettings.incallModeTimeoutMs) !== null && _k !== void 0 ? _k : 0,
        lingeringConnectionDelayMs: 60000,
        // keeping existing behavior of || - using default value when there's 0
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        userActivitySecondResendDelayMs: cfg.trouterSettings.userActivitySecondResendDelayMs || 10000,
        duplicateDisconnectThresholdMs: 10000,
        connectionCache: cfg.connectionCache,
        // eslint-disable-next-line @typescript-eslint/unbound-method
        registrationStateCallback: cfg.registrationStateCallbackForAcsDoNotUse,
        rewriteUrlForProxy: rewriteUrlForProxyCallback,
        retryLimitOnTokenFetch: cfg.trouterSettings.retryLimitOnTokenFetch,
        extraConnectionHeaders: cfg.trouterSettings.extraConnectionHeaders,
        expediteBackoffOnStartMinimumDelayMs: 10000,
        // JSON.stringify() override for dumping options to log as JSON in TrouterManager
        toJSON: function () {
            return __assign(__assign({}, this), { 
                // If cache is set to some object of the host app, do not try to serialize it.
                // It could contain circular references and JSON.stringify() would fully fail.
                connectionCache: this.connectionCache ? {} : this.connectionCache });
        }
    };
}
/**
 * TrouterService implementation class
 */
var TrouterService = /** @class */ (function () {
    function TrouterService(logProvider) {
        this.logProvider = logProvider;
        this.stateChangedListeners = [];
        this.logger = new Logger_1.Logger('Trouter', logProvider);
        this.trouterUrlPromise = new TrouterUrlPromise_1.TrouterUrlPromise(logProvider);
        this.messageHandlers = new MessageHandler_1.MessageHandlerRegistry(logProvider);
        this.listeners = {};
        this.connectionInfo = null;
        this.logger.info("Created TrouterService version ".concat(Constants_1.CLIENT_VERSION));
    }
    TrouterService.prototype.start = function (cfg) {
        var _a;
        this.logger.info('Start');
        if (!cfg.skypeTokenProvider && !cfg.authTokenProvider) {
            throw new Error('no token provider has been configured, either skypeTokenProvider or authTokenProvider must be populated');
        }
        if (cfg.skypeTokenProvider && !cfg.trouterSettings.disableInternalSkypeTokenCache) {
            cfg.skypeTokenProvider = (0, SkypeTokenProviderWithCache_1.addCacheAsBackupTo)(cfg.skypeTokenProvider);
        }
        this.trouterCfg = cfg;
        var options = populateTrouterOptions(cfg, this.logger, this.ecsCfg);
        if (cfg.internalEnableV4cProtocol === false) {
            options.forceV4aProtocol = true;
        }
        var authTokenProvider = authTokenProviderProtector(this.logger, (_a = cfg.authTokenProvider) !== null && _a !== void 0 ? _a : skypeTokenAdapter(cfg.skypeTokenProvider));
        if (this.trouterServer === undefined) {
            this.trouterServer = new TrouterManager_1.TrouterManager(this.logProvider, options, authTokenProvider, cfg.authTokenProvider === undefined, this);
        }
        if (this.pendingActivityState !== undefined) {
            this.trouterServer.setUserActivityState(this.pendingActivityState[0], this.pendingActivityState[1]);
            this.pendingActivityState = undefined;
        }
        this.trouterServer.start();
    };
    TrouterService.prototype.stop = function (dontUnregister) {
        this.logger.info('close connection');
        this.trouterUrlPromise.rejectUrl(new Error('TrouterService is stopped'));
        if (this.trouterServer !== undefined) {
            this.trouterServer.stop(dontUnregister);
        }
    };
    TrouterService.prototype.setEcsConfig = function (fullEcsData) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        var ecsSection = 'TrouterJScriptClient';
                        _this.ecsCfg = (fullEcsData[ecsSection]);
                        _this.logger.info("Setting ECS configuration to ".concat(JSON.stringify(_this.ecsCfg)));
                        if (_this.trouterServer !== undefined && _this.trouterCfg !== undefined) {
                            var options = populateTrouterOptions(_this.trouterCfg, _this.logger, _this.ecsCfg);
                            _this.trouterServer.configure(options);
                        }
                        resolve();
                    })];
            });
        });
    };
    /**
     * Notifies trouter that network is restored - trouter will try to restore connection immediately
     */
    TrouterService.prototype.checkConnection = function (disconnectDetected) {
        if (this.trouterServer !== undefined) {
            this.trouterServer.checkConnection(disconnectDetected !== null && disconnectDetected !== void 0 ? disconnectDetected : false);
        }
    };
    TrouterService.prototype.resendRegistration = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.trouterServer) {
                    throw new Error('resendRegistration called too early');
                }
                return [2 /*return*/, this.trouterServer.resendRegistration()];
            });
        });
    };
    // Listeners
    TrouterService.prototype.registerListener = function (listener, path) {
        if (path === '' || !path.startsWith('/') || path.includes('?') || path.includes('#')) {
            this.logger.error("Listener path '".concat(path, "' is not valid"));
            return false;
        }
        if (this.listeners[path]) {
            this.logger.error("Another listener is already registered for path '".concat(path, "'"));
            return false;
        }
        this.listeners[path] = listener;
        this.logger.debug("Listener for path '".concat(path, "' registered"));
        if (this.connectionInfo) {
            listener.onTrouterConnected(this.connectionInfo.baseEndpointUrl + path, this.connectionInfo);
        }
        return true;
    };
    TrouterService.prototype.unregisterListener = function (listener) {
        var paths = [];
        for (var _i = 0, _a = Object.keys(this.listeners); _i < _a.length; _i++) {
            var path = _a[_i];
            if (this.listeners[path] === listener) {
                paths.push(path);
            }
        }
        if (paths.length === 0) {
            return false;
        }
        for (var _b = 0, paths_1 = paths; _b < paths_1.length; _b++) {
            var path = paths_1[_b];
            delete this.listeners[path];
        }
        this.logger.debug("Listener for path(s) '".concat(paths.join('\', \''), "' unregistered"));
        return true;
    };
    TrouterService.prototype.onTrouterConnected = function (endpointUrl, connectionInfo) {
        this.logger.debug('Trouter is now connected');
        for (var _i = 0, _a = Object.keys(this.listeners); _i < _a.length; _i++) {
            var path = _a[_i];
            try {
                this.listeners[path].onTrouterConnected(connectionInfo.baseEndpointUrl + path, connectionInfo);
            }
            catch (e) {
                this.logger.error("Listener '".concat(path, "' threw an exception from onTrouterConnected(): ").concat(e));
            }
        }
        this.connectionInfo = connectionInfo;
        this.trouterUrlPromise.resolveUrl(endpointUrl);
        this.notifyStateChanged(Interfaces_1.TrouterState.Connected, {
            url: endpointUrl,
            getRemainingTtlInSec: function () { return connectionInfo.connectionTtlSec; }
        });
    };
    TrouterService.prototype.onTrouterDisconnected = function () {
        this.logger.debug('Trouter is now disconnected');
        this.connectionInfo = null;
        for (var _i = 0, _a = Object.keys(this.listeners); _i < _a.length; _i++) {
            var path = _a[_i];
            var listener = this.listeners[path];
            if (listener.onTrouterDisconnected) {
                try {
                    listener.onTrouterDisconnected();
                }
                catch (e) {
                    this.logger.error("Listener '".concat(path, "' threw an exception from onTrouterDisconnected(): ").concat(e));
                }
            }
        }
        this.notifyStateChanged(Interfaces_1.TrouterState.Disconnected);
    };
    TrouterService.prototype.onTrouterRequest = function (request, response) {
        var bestPath = '';
        for (var _i = 0, _a = Object.keys(this.listeners); _i < _a.length; _i++) {
            var path = _a[_i];
            if (request.path.startsWith(path) && path.length > bestPath.length) {
                bestPath = path;
            }
        }
        if (bestPath !== '') {
            try {
                this.listeners[bestPath].onTrouterRequest(request, response);
            }
            catch (e) {
                this.logger.error("Listener '".concat(bestPath, "' threw an exception from onTrouterRequest(): ").concat(e));
                response.status = 500;
                response.headers = { 'Trouter-Responder': 'ClientLib' };
                response.send();
            }
            return;
        }
        if (this.tryMessageHandlers(request, response)) {
            return;
        }
        response.status = 404;
        response.headers = { 'Trouter-Responder': 'ClientLib' };
        response.send();
    };
    TrouterService.prototype.onTrouterMessageLoss = function (flowTags) {
        this.logger.info("onTrouterMessageLoss called with tags [".concat(flowTags, "]"));
        var messageLossProcessed = true;
        for (var _i = 0, _a = Object.keys(this.listeners); _i < _a.length; _i++) {
            var path = _a[_i];
            var listener = this.listeners[path];
            if (listener.onTrouterMessageLoss) {
                try {
                    messageLossProcessed = listener.onTrouterMessageLoss(flowTags) && messageLossProcessed;
                    if (messageLossProcessed === undefined) {
                        this.logger.error("Listener '".concat(path, "' did not return a boolean value from onTrouterMessageLoss()"));
                        messageLossProcessed = false;
                    }
                }
                catch (e) {
                    this.logger.error("Listener '".concat(path, "' threw an exception from onTrouterMessageLoss(): ").concat(e));
                    messageLossProcessed = false;
                }
            }
        }
        return messageLossProcessed;
    };
    TrouterService.prototype.onTrouterUserActivityStateAccepted = function (cv) {
        this.logger.debug("onTrouterUserActivityStateAccepted cv: ".concat(cv));
        for (var _i = 0, _a = Object.keys(this.listeners); _i < _a.length; _i++) {
            var path = _a[_i];
            var listener = this.listeners[path];
            if (listener.onTrouterUserActivityStateAccepted) {
                try {
                    listener.onTrouterUserActivityStateAccepted(cv);
                }
                catch (e) {
                    this.logger.error("Listener '".concat(path, "' threw an exception from onTrouterUserActivityStateAccepted(): ").concat(e));
                }
            }
        }
    };
    TrouterService.prototype.onAudiencesSetResolved = function (audienceSubscriptionsResponse, cv) {
        this.logger.debug("onAudiencesSetResolved cv: ".concat(cv));
        for (var _i = 0, _a = Object.keys(this.listeners); _i < _a.length; _i++) {
            var path = _a[_i];
            var listener = this.listeners[path];
            if (listener.onAudiencesSetResolved) {
                try {
                    listener.onAudiencesSetResolved(audienceSubscriptionsResponse, cv);
                }
                catch (e) {
                    this.logger.error("Listener '".concat(path, "' threw an exception from onAudienceSubscribed(): ").concat(e));
                }
            }
        }
    };
    TrouterService.prototype.setUserActivityState = function (state, correlationVector) {
        if (state !== Interfaces_1.UserActivityState.Active && state !== Interfaces_1.UserActivityState.Inactive) {
            throw new Error("setUserActivityState called with unsupported value ".concat(state));
        }
        this.logger.info("setUserActivityState called with value ".concat(Interfaces_1.UserActivityState[state]));
        if (this.trouterServer && this.state() !== Interfaces_1.TrouterState.Unknown) {
            this.trouterServer.setUserActivityState(state, correlationVector);
        }
        else {
            this.pendingActivityState = [state, correlationVector];
            this.logger.warn('setUserActivityState called before start() or after stop()');
        }
    };
    TrouterService.prototype.setAudienceSubscriptions = function (audienceSubscriptionModel, correlationVector) {
        if (audienceSubscriptionModel.audienceSubscriptions.length > 1) {
            throw new Error("Only singular audience subscription is supported");
        }
        if (this.trouterServer && this.state() !== Interfaces_1.TrouterState.Unknown) {
            return this.trouterServer.setAudienceSubscriptionsAsync(audienceSubscriptionModel, 15000, correlationVector);
        }
        throw new Error('audience subscribe called before start() or after stop()');
    };
    // Legacy API
    TrouterService.prototype.state = function () {
        if (this.trouterServer !== undefined) {
            return this.trouterServer.getState();
        }
        return Interfaces_1.TrouterState.Unknown;
    };
    TrouterService.prototype.isInTerminalState = function () {
        if (this.trouterServer !== undefined) {
            return this.trouterServer.isInTerminalState();
        }
        return false;
    };
    TrouterService.prototype.reportStateInfo = function () {
        if (this.trouterServer === undefined) {
            return "";
        }
        return this.trouterServer.reportStateInfo();
    };
    TrouterService.prototype.getServerState = function () {
        if (this.trouterServer !== undefined) {
            return this.trouterServer.getServerState();
        }
        return undefined;
    };
    TrouterService.prototype.getTrouterUrlAsync = function () {
        if (this.trouterServer !== undefined) {
            return this.trouterUrlPromise.getPromise();
        }
        else {
            return Promise.reject(new Error('TrouterService has not been started'));
        }
    };
    TrouterService.prototype.onStateChanged = function (callback) {
        this.logger.info('onStateChanged called');
        if (callback === undefined) {
            this.stateChangedListeners = this.stateChangedListeners.filter(function (listener) { return (listener.wrappedCallback === undefined); });
        }
        else {
            this.offStateChanged(callback);
            var wrapper = function (state, info) {
                callback(state, info ? info.url : '');
            };
            wrapper.wrappedCallback = callback;
            this.stateChangedListeners.push(wrapper);
        }
    };
    TrouterService.prototype.offStateChanged = function (callback) {
        this.logger.info('offStateChanged called');
        var sizeBeforeRemoval = this.stateChangedListeners.length;
        this.stateChangedListeners = this.stateChangedListeners.filter(function (listener) { return (listener.wrappedCallback !== callback); });
        return (sizeBeforeRemoval > this.stateChangedListeners.length);
    };
    TrouterService.prototype.addCallback = function (callback) {
        this.logger.info('addListener called');
        var index = this.stateChangedListeners.indexOf(callback, 0);
        if (index === -1 && callback !== undefined) {
            this.stateChangedListeners.push(callback);
        }
    };
    TrouterService.prototype.removeCallback = function (callback) {
        this.logger.info('removeListener called');
        var index = this.stateChangedListeners.indexOf(callback, 0);
        if (index > -1) {
            this.stateChangedListeners.splice(index, 1);
            return true;
        }
        return false;
    };
    TrouterService.prototype.registerMessageHandler = function (handler) {
        this.logger.info('registerMessageHandler is called');
        this.messageHandlers.register(handler);
    };
    TrouterService.prototype.clearMessageHandlers = function () {
        this.logger.info('clearMessageHandlers is called');
        this.messageHandlers.clear();
    };
    TrouterService.prototype.notifyStateChanged = function (state, info) {
        var _this = this;
        this.logger.info("notifyStateChanged called, will forward to ".concat(this.stateChangedListeners.length, " listeners"));
        this.stateChangedListeners.forEach(function (callback) {
            try {
                callback(state, info);
            }
            catch (error) {
                _this.logger.error("Error in callback ".concat(error));
            }
        });
    };
    TrouterService.prototype.tryMessageHandlers = function (request, response) {
        if (!this.messageHandlers.active()) {
            return false;
        }
        var body;
        var eventId = null;
        try {
            body = JSON.parse(request.body);
            eventId = (body && (body.evt || body.eventId)) || null;
            // eslint-disable-next-line no-empty
        }
        catch (e) { }
        var message = {
            eventId: eventId,
            url: (this.connectionInfo ? this.connectionInfo.baseEndpointUrl : '') + request.path,
            body: body,
            rawBody: request.body,
            headers: request.headers
        };
        var result = this.messageHandlers.handleMessage(message);
        if (!result.isHandled) {
            return false;
        }
        response.status = result.resultCode;
        if (result.responseHeaders) {
            response.headers = result.responseHeaders;
        }
        if (result.responseBody) {
            response.body = result.responseBody;
        }
        response.send();
        return true;
    };
    return TrouterService;
}());
exports.TrouterService = TrouterService;
function createTrouterService(logger) {
    return new TrouterService(logger);
}
exports.createTrouterService = createTrouterService;
function getTrouterServiceVersion() {
    return Constants_1.CLIENT_VERSION;
}
exports.getTrouterServiceVersion = getTrouterServiceVersion;
function replaceTrouterUrlBase(existingUrl, newBase) {
    var schemaSepPos = existingUrl.indexOf('://');
    if (schemaSepPos >= 0) {
        var pathSepPos = existingUrl.indexOf('/', schemaSepPos + 3);
        if (pathSepPos >= 0) {
            return newBase + existingUrl.substr(pathSepPos);
        }
    }
    return '';
}
exports.replaceTrouterUrlBase = replaceTrouterUrlBase;
function skypeTokenAdapter(provider) {
    var _this = this;
    return function (req) { return __awaiter(_this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = {};
                    return [4 /*yield*/, provider(req.needFresh)];
                case 1: return [2 /*return*/, (_a.token = _b.sent(), _a.tokenType = 'skype', _a)];
            }
        });
    }); };
}
function authTokenProviderProtector(logger, provider) {
    var _this = this;
    var previousToken;
    return function (req) { return __awaiter(_this, void 0, void 0, function () {
        var requestTime, timerId, rsp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestTime = new Date();
                    timerId = setInterval(function () {
                        var delay = Math.round((Date.now() - requestTime.getTime()) / 60000);
                        logger.warn("Note: Trouter auth token request promise from ".concat(requestTime.toISOString(), " has not been resolved for ").concat(delay, " minutes. The client is blocked from operating properly"));
                    }, 5 * 60000);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, provider(req)];
                case 2:
                    rsp = _a.sent();
                    if (req.needFresh && rsp.token === previousToken) {
                        logger.error('API violation: Trouter auth token provider got a request with needRefresh=true, but returned the same token as last time anyway. Please fix the host app');
                    }
                    previousToken = rsp.token;
                    return [2 /*return*/, rsp];
                case 3:
                    clearInterval(timerId);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
}


/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_21__;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// tstrouter.js